import { Mousewheel } from 'swiper/modules';

window.HotelDetails = null;
window.HotelPhotoList = [];
window.ExprezyData = null;
var CheckExprezy;

window.HotelRoomPhotoSortedData = null;

window.WhatCurrentImageIndex = 0;
var MainImageSwiper;

window.CurrentExprezyIndex = 1;
window.ExprezyLastPage = 1;
window.HowManyExprezyPerPage = 6;
window.ExprezyScrollObserver = null;

var MobileBookCheckRoomButtonHotelDetails;

window.ThisRoomData = null;

window.SelectedHotelDetailsFilter = null;


// ====================================== PREPARE EARLY UI ======================================

window.PrepareUIHotelDetails = function()
{
    let SeeAllPhotosEarly = document.getElementById("SeeAllPhotosEarly");
    if(SeeAllPhotosEarly != null)
        SeeAllPhotosEarly.innerHTML = window["SeeAllPhotosTxt" + window.CurrentCountryID];
    
    let FacilityHeaderText = document.getElementById("FacilityHeaderText");
    if(FacilityHeaderText != null)
        FacilityHeaderText.innerHTML = window["FacilityTxt" + window.CurrentCountryID];
    
    let FacilityHeaderTextMobile = document.getElementById("FacilityHeaderTextMobile");
    if(FacilityHeaderTextMobile != null)
        FacilityHeaderTextMobile.innerHTML = window["FacilityTxt" + window.CurrentCountryID];

    let ChooseAccOrExpHeaderText = document.getElementById("ChooseAccOrExpHeaderText");
    if(ChooseAccOrExpHeaderText != null)
        ChooseAccOrExpHeaderText.innerHTML = window["ChooseAccommodationTxt" + window.CurrentCountryID];

    let FilterHotelDetailsAccText = document.getElementById("FilterHotelDetailsAccText");
    if(FilterHotelDetailsAccText != null)
        FilterHotelDetailsAccText.innerHTML = window["AccommodationTxt" + window.CurrentCountryID];

    let FilterHotelDetailsExperienceText = document.getElementById("FilterHotelDetailsExperienceText");
    if(FilterHotelDetailsExperienceText != null)
        FilterHotelDetailsExperienceText.innerHTML = window["ExperienceTxt" + window.CurrentCountryID];


    let PingNowButton = document.getElementById("PingNowButton");
    if(PingNowButton != null)
        PingNowButton.innerHTML = window["PingNowBtnTxt" + window.CurrentCountryID] + "<a id='PingNowButtonHREF' class='HREFInsideContainer'></a>";

    let ShareThisPingButtonText = document.getElementById("ShareThisPingButtonText");
    if(ShareThisPingButtonText != null)
        ShareThisPingButtonText.innerHTML = window["ShareThisPingTxt" + window.CurrentCountryID];

    let DapatkanRefMessageText = document.getElementById("DapatkanRefMessageText");
    if(DapatkanRefMessageText != null)
        DapatkanRefMessageText.innerHTML = window["DapatkanRefMessageTxt" + window.CurrentCountryID];

    let DownPaymentPriceHeaderText = document.getElementById("DownPaymentPriceHeaderText");
    if(DownPaymentPriceHeaderText != null)
        DownPaymentPriceHeaderText.innerHTML = window["DownPaymentPriceTxt" + window.CurrentCountryID];

    let EstimatedFinalPriceHeaderText = document.getElementById("EstimatedFinalPriceHeaderText");
    if(EstimatedFinalPriceHeaderText != null)
        EstimatedFinalPriceHeaderText.innerHTML = window["EstimatedFinalPriceTxt" + window.CurrentCountryID];

    let SeeNearbyHeaderText = document.getElementById("SeeNearbyHeaderText");
    if(SeeNearbyHeaderText != null)
        SeeNearbyHeaderText.innerHTML = window["SeeNearbyOnMapTxt" + window.CurrentCountryID];

    let ViewMoreExperiencesButtonText = document.getElementById("ViewMoreExperiencesButtonText");
    if(ViewMoreExperiencesButtonText != null)
        ViewMoreExperiencesButtonText.innerHTML = window["ViewMoreExpTxt" + window.CurrentCountryID];

    let AddOnHeaderText = document.getElementById("AddOnHeaderText");
    if(AddOnHeaderText != null)
        AddOnHeaderText.innerHTML = window["AddOnsTxt" + window.CurrentCountryID];

    let LihatSemuaTextDescription = document.getElementById("LihatSemuaTextDescription");
    if(LihatSemuaTextDescription != null)
        LihatSemuaTextDescription.innerHTML = window["ViewAllTxt" + window.CurrentCountryID];

    let SeeMoreFacilityButtonText = document.getElementById("SeeMoreFacilityButtonText");
    if(SeeMoreFacilityButtonText != null)
        SeeMoreFacilityButtonText.innerHTML = window["ViewAllTxt" + window.CurrentCountryID];

    let NoRoomAvailableHeaderText = document.getElementById("NoRoomAvailableHeaderText");
    if(NoRoomAvailableHeaderText != null)
        NoRoomAvailableHeaderText.innerHTML = window["NoRoomAvailableHeaderTxt" + window.CurrentCountryID];

    let NoRoomAvailableMessageText = document.getElementById("NoRoomAvailableMessageText");
    if(NoRoomAvailableMessageText != null)
        NoRoomAvailableMessageText.innerHTML = window["NoRoomAvailableMessageTxt" + window.CurrentCountryID];

    let ExploreHotelDetailsButton = document.getElementById("ExploreHotelDetailsButton");
    if(ExploreHotelDetailsButton != null)
    {
        ExploreHotelDetailsButton.innerHTML = window["ExploreMoreTxt" + window.CurrentCountryID];
        ExploreHotelDetailsButton.href = "/search/en/bali.html?search=Bali";
    }

    MobileBookCheckRoomButtonHotelDetails = document.getElementById("MobileBookCheckRoomButtonHotelDetails");

    // Footer -----------------------------------------------------------------------------------
    let MulaiDariHeaderText = document.getElementById("MulaiDariHeaderText");
    if(MulaiDariHeaderText != null)
        MulaiDariHeaderText.innerHTML = window["FromTxt" + window.CurrentCountryID];


    let AddOnsSwiperContainer = document.getElementById("AddOnsHotelDetailSwiperContainer");
    let AddOnsSwiper = new window.Swiper(AddOnsSwiperContainer,
    {
        slidesPerView: 'auto',
        spaceBetween: 0,
        freeMode: true,
        observer: true,
        observeParents: true,
    });

    // Some Mobile UI ------------------------------------------------------------------

    let BackButtonMobile = document.querySelectorAll(".BackButtonMobile");
    BackButtonMobile.forEach(thisbutton =>
    {
        thisbutton.onclick = function()
        {
            window.history.back();
        }
    });

    let PilihKamarMobileText = document.querySelectorAll(".PilihKamarMobileText");
    PilihKamarMobileText.forEach(thistext =>
    {
        thistext.innerHTML = window["SelectRoomItemButtonTxt" + window.CurrentCountryID];
    });

    let UbahButtonText = document.querySelectorAll(".UbahKamarMobileButtonText");
    UbahButtonText.forEach(thistext =>
    {
        thistext.innerHTML = window["EditButtonTxt" + window.CurrentCountryID];
    });


    // Set Early Hotel Details Mobile Check In - Out ----------------------------------------------------

    let ExtraMobileCheckInOutDateContainer = document.querySelectorAll(".ExtraMobileCheckInOutDateContainer");
    if(ExtraMobileCheckInOutDateContainer != null && ExtraMobileCheckInOutDateContainer.length > 0)
    {
        ExtraMobileCheckInOutDateContainer.forEach(thiscontainer =>
        {
            let ThisCheckInOutMobileButton = thiscontainer.querySelector(".ExtraMobileCheckInOutDateButton");
            ThisCheckInOutMobileButton.onclick = function()
            {
                window.InstantiateCheckInOutMobilePanel(()=>
                {
                    let NewCheckInYear;
                    let NewCheckInMonth;
                    let NewCheckInDay;

                    let NewCheckOutYear;
                    let NewCheckOutMonth;
                    let NewCheckOutDay;

                    if(window.ThisRoomData.book_type == "per night")
                    {
                        let NewUpdateCheckInDateInfo = window.CurrentSelectedCheckIn;

                        NewCheckInYear = NewUpdateCheckInDateInfo.getFullYear();
                        NewCheckInMonth = (NewUpdateCheckInDateInfo.getMonth() + 1);
                        NewCheckInDay = NewUpdateCheckInDateInfo.getDate();

                        let NewUpdateCheckOutDateInfo = window.CurrentSelectedCheckOut;

                        NewCheckOutYear = NewUpdateCheckOutDateInfo.getFullYear();
                        NewCheckOutMonth = (NewUpdateCheckOutDateInfo.getMonth() + 1);
                        NewCheckOutDay = NewUpdateCheckOutDateInfo.getDate();
                    }
                    else
                    {
                        NewCheckInYear = window.CurrentSelectedYearEdit;
                        NewCheckInMonth = window.CurrentSelectedMonthEdit;
                        NewCheckInDay = window.CurrentSelectedDayEdit;

                        let CurrentCheckOutDate = new Date(NewCheckInYear, NewCheckInMonth-1, NewCheckInDay);
                        CurrentCheckOutDate.setDate(CurrentCheckOutDate.getDate() + 1);

                        NewCheckOutYear = CurrentCheckOutDate.getFullYear();
                        NewCheckOutMonth = (CurrentCheckOutDate.getMonth() + 1);
                        NewCheckOutDay = CurrentCheckOutDate.getDate();
                    }

                    window.CheckInDateNonTop = NewCheckInYear + "-" + NewCheckInMonth + "-" + NewCheckInDay;
                    window.CheckInNonTopInput.setAttribute("Date", NewCheckInDay);
                    window.CheckInNonTopInput.setAttribute("Month", NewCheckInMonth);
                    window.CheckInNonTopInput.setAttribute("Year", NewCheckInYear);

                    window.CheckOutDateNonTop = NewCheckOutYear + "-" + NewCheckOutMonth + "-" + NewCheckOutDay;
                    window.CheckOutNonTopInput.setAttribute("Date", NewCheckOutDay);
                    window.CheckOutNonTopInput.setAttribute("Month", NewCheckOutMonth);
                    window.CheckOutNonTopInput.setAttribute("Year", NewCheckOutYear);
                    
                    window.CalculateTotalHotelDetails(true);

                }, true);
            }
        });
    }
    
    // ------------------------------ SET UBAH KAMAR MOBILE ---------------------------
    
    let UbahKamarMobileButton = document.querySelectorAll(".UbahKamarMobileButton");
    UbahKamarMobileButton.forEach(thisbutton =>
    {
        thisbutton.onclick = function()
        {
            window.InstantiateEditHotelDetailsMobileMenu(()=>
            {
                //console.log("Update All Mobile");

                let NewUpdateCheckInDateInfo;
                let NewUpdateCheckOutDateInfo;

                if(window.ThisRoomData.book_type == "per night")
                {
                    NewUpdateCheckInDateInfo = window.MobileCheckInToChange;
                    NewUpdateCheckOutDateInfo = window.MobileCheckOutToChange;

                    //console.log("NewUpdateCheckInDateInfo", NewUpdateCheckInDateInfo);
                    //console.log("NewUpdateCheckOutDateInfo", NewUpdateCheckOutDateInfo);
                }
                else
                {
                    //console.log("window.CurrentSelectedYearEdit", window.CurrentSelectedYearEdit);
                    //console.log("window.CurrentSelectedYearEdit", window.CurrentSelectedMonthEdit);
                    //console.log("window.CurrentSelectedYearEdit", window.CurrentSelectedDayEdit);

                    let GetFinalSelectedCheckInDate = new Date(window.CurrentSelectedYearEdit, parseInt(window.CurrentSelectedMonthEdit) - 1, window.CurrentSelectedDayEdit);
                    let GetFinalSelectedCheckOutDate = new Date(window.CurrentSelectedYearEdit, parseInt(window.CurrentSelectedMonthEdit) - 1, window.CurrentSelectedDayEdit);
                    GetFinalSelectedCheckOutDate.setDate(GetFinalSelectedCheckOutDate.getDate() + 1);

                    NewUpdateCheckInDateInfo = GetFinalSelectedCheckInDate;
                    NewUpdateCheckOutDateInfo = GetFinalSelectedCheckOutDate;

                    //console.log("NewUpdateCheckInDateInfo", NewUpdateCheckInDateInfo);
                    //console.log("NewUpdateCheckOutDateInfo", NewUpdateCheckOutDateInfo);
                }

                let NewCheckInYear = NewUpdateCheckInDateInfo.getFullYear();
                let NewCheckInMonth = (NewUpdateCheckInDateInfo.getMonth() + 1);
                let NewCheckInDay = NewUpdateCheckInDateInfo.getDate();

                window.CheckInDateNonTop = NewCheckInYear + "-" + NewCheckInMonth + "-" + NewCheckInDay;
                window.CheckInNonTopInput.setAttribute("Date", NewCheckInDay);
                window.CheckInNonTopInput.setAttribute("Month", NewCheckInMonth);
                window.CheckInNonTopInput.setAttribute("Year", NewCheckInYear);


                let NewCheckOutYear = NewUpdateCheckOutDateInfo.getFullYear();
                let NewCheckOutMonth = (NewUpdateCheckOutDateInfo.getMonth() + 1);
                let NewCheckOutDay = NewUpdateCheckOutDateInfo.getDate();

                window.CheckOutDateNonTop = NewCheckOutYear + "-" + NewCheckOutMonth + "-" + NewCheckOutDay;
                window.CheckOutNonTopInput.setAttribute("Date", NewCheckOutDay);
                window.CheckOutNonTopInput.setAttribute("Month", NewCheckOutMonth);
                window.CheckOutNonTopInput.setAttribute("Year", NewCheckOutYear);

                document.getElementById("RoomQuotaHotelDetailsInput").setAttribute("room-quota", window.ThisCurrentQuotaInput);    

                window.CalculateTotalHotelDetails(true);
            },false, true);
        }
    });

    window.HotelDetailsScrollSetting();
}

window.LoadAllHotelDetails = function(MainSession, loggedin)
{
    if(sessionStorage.getItem("tempstatus") != null) // If Hotel Not Exist -----------------------------
    {
        sessionStorage.removeItem("tempstatus");
        return;
    }

    // let CurrentUrl = new URL(window.location.href);
    // let param = new URLSearchParams(CurrentUrl.search.slice(1));
    window.HotelID = window.location.pathname.split("/").pop().split(".")[0];

    // ------------------- DETERMINE SLUG EXIST OR NOT -------------------------------------------------

    // if(param.has('slug') == true || (window.location.pathname.includes(".php") == false && window.TempSlugFromHTML != null))
    // {
    //     if(param.has('slug') == true)
    //     {
    //         window.HotelSlug = CurrentUrl.searchParams.get("slug");
    //     }
    //     else
    //     {
    //         window.HotelSlug = window.TempSlugFromHTML;
    //     }
    // }
    // else
    // {
    //     // window.location.href = "index.php";
    //     return;
    // }

    // ------------------------- SET TOP SEARCH INFO --------------------------------

    window.SetUpTopDateQuotaSearch(false);

    window.CheckInDateNonTop = window.CheckInInfo;
    window.CheckOutDateNonTop = window.CheckOutInfo;
    window.RoomQuotaNonTop = window.RoomNumberInfo;


    // ----------------------- SET EARLY -----------------------------------------------
    
    let RoomQuotaTextToDisplay = window.RoomQuotaNonTop + " " + window["RoomTxt" + window.CurrentCountryID];
    if(window.RoomQuotaNonTop > 1)
    {
        RoomQuotaTextToDisplay = window.RoomQuotaNonTop + " " + window["RoomTxtex" + window.CurrentCountryID];
    }

    let MobileCurrentStatusHotelDetailsText = document.querySelectorAll(".MobileCurrentStatusHotelDetailsText");
    let DifferenceBetweenDays = window.GetDateDifferences(window.CheckInDateNonTop, window.CheckOutDateNonTop);
    MobileCurrentStatusHotelDetailsText.forEach(thistext =>
    {
        thistext.innerHTML =  window.NightTextDisplayer(DifferenceBetweenDays) + " • " + RoomQuotaTextToDisplay;
    });


    //--------------------------------------- LOAD HOTEL DETAILS -----------------------------------

    window.LoadAccommodationDetails(null, ()=>
    {
        LoadAddOnsHotel();

        // Set Slug -------------------------------------
        
        window.HotelSlug = window.HotelDetails.slug;

        //--------------------------------------- CHANGE URL --------------------------------

        let CheckInInfoToPadStart = window.CheckInInfo.split("-")
        let CheckInInfoCombined = CheckInInfoToPadStart[0] + "-" + CheckInInfoToPadStart[1].toString().padStart(2, '0') + "-" + CheckInInfoToPadStart[2].toString().padStart(2, '0');
            
        let CheckOutInfoToPadStart = window.CheckOutInfo.split("-")
        let CheckOutInfoCombined = CheckOutInfoToPadStart[0] + "-" + CheckOutInfoToPadStart[1].toString().padStart(2, '0') + "-" + CheckOutInfoToPadStart[2].toString().padStart(2, '0');
            
        // Replace URL -------------------------------------------------------------------------------

        if(window.SearchInfo == null)
        {
            window.SearchInfo = window.HotelDetails.province;
            window.MainSearchInputField.value =  window.SearchInfo;
            window.MainSearchInputField.setAttribute("province-slug", window.HotelDetails.province_slug);
            window.MainSearchInputField.setAttribute("current-inputed", window.SearchInfo);
            window.LoadTotalAccommodation(window.SlugInfo, window.SearchInfo);
        }
        // let UpdateURL = "
        // window.history.replaceState(window.history.state, document.title, UpdateURL);

        let UpdateURL = null;
        if(window.WhichPageisNow == "HotelDetails")
        {
            UpdateURL = "/" + window.HotelDetails.category.category_name.toLowerCase() + "/" + window.CurrentCountryID + "/" +  window.HotelDetails.id_hotel  + ".html?search=" + window.SearchInfo + "&checkin=" + CheckInInfoCombined + "&checkout=" + CheckOutInfoCombined + "&room=" + window.RoomNumberInfo;
        }

        if (typeof (window.history.replaceState) != "undefined" && UpdateURL != null)
        {
            var obj =
            {
                Url: UpdateURL
            };
            window.history.replaceState(obj, obj.Title, obj.Url);
        }

        
        // Max Discount -----------------------------------------------------------------------------------

        if(window.HotelDetails.max_disc != null && window.HotelDetails.max_disc > 0)
        {
            document.getElementById("MaxDiscountContainer").className = "RedBorderMaxDiscountHotelDetails";
            document.getElementById("MaxDiscountText").innerHTML = window["DiscountTxt" + window.CurrentCountryID](parseInt(window.HotelDetails.max_disc));
            document.getElementById("MaxDiscountText").style.opacity = 1;

            if(document.getElementById("MaxDiscountContainerMobile") != null)
            {
                document.getElementById("MaxDiscountContainerMobile").className = "RedBorderMaxDiscountHotelDetails";
                document.getElementById("MaxDiscountTextMobile").innerHTML = window["DiscountTxt2" + window.CurrentCountryID](parseInt(window.HotelDetails.max_disc));
                document.getElementById("MaxDiscountTextMobile").style.opacity = 1;
            }

            if(document.getElementById("MaxDiscountContainerMobile2") != null)
            {
                document.getElementById("MaxDiscountContainerMobile2").className = "RedBorderMaxDiscountHotelDetails LowMaxDiscountMobileContainer";
                document.getElementById("MaxDiscountTextMobile2").innerHTML = window["DiscountTxt2" + window.CurrentCountryID](parseInt(window.HotelDetails.max_disc));
                document.getElementById("MaxDiscountTextMobile2").style.opacity = 1;
            }


            document.getElementById("RedDiscountDetailsRightContainer").style.display = "";
            document.getElementById("RedDiscountDetailsRightText").innerHTML = parseInt(window.HotelDetails.max_disc) + "%";

            if(document.getElementById("PotonganMessageMobileContainer") != null)
            {
                document.getElementById("PotonganMessageMobileContainer").style.display = "";
                document.getElementById("PotonganMessageMobile").innerHTML = window["DiscountWithMaxTxt" + window.CurrentCountryID](parseInt(window.HotelDetails.max_disc), window.HotelDetails.max_disc_until);
            }

            if(document.getElementById("PotonganMessageMobileContainerTop") != null)
            {
                document.getElementById("PotonganMessageMobileContainerTop").style.display = "";
                document.getElementById("PotonganMessageMobileTop").innerHTML = window["DiscountWithMaxTxt" + window.CurrentCountryID](parseInt(window.HotelDetails.max_disc), window.HotelDetails.max_disc_until);
            }
            

            // Up To -----------------------------------------

            if(window.HotelDetails.max_disc_until != null && window.HotelDetails.max_disc_until > 0)
            {
                document.getElementById("UpToTextContainer").style.display = "";
                document.getElementById("UpToText").innerHTML = window["UpToTxt" + window.CurrentCountryID] + " " + window.ConvertTextToRP(parseInt(window.HotelDetails.max_disc_until), 1, false, false);

                if(document.getElementById("UpToTextContainerMobile") != null)
                {
                    // document.getElementById("UpToTextContainerMobile").style.display = "flex";
                    document.getElementById("UpToTextMobile").innerHTML = window["UpToTxt" + window.CurrentCountryID] + " " + window.ConvertTextToRP(parseInt(window.HotelDetails.max_disc_until), 1, false, false);
                }
            }
        }
        else
        {
            document.getElementById("MaxDiscountContainer").style.display = "none";

            if(document.getElementById("MaxDiscountContainerMobile") != null)
                document.getElementById("MaxDiscountContainerMobile").style.display = "none";

            if(document.getElementById("MaxDiscountContainerMobile2") != null)
                document.getElementById("MaxDiscountContainerMobile2").style.display = "none";

            document.getElementById("RedDiscountDetailsRightContainer").style.display = "none";
        }

        // Accommodation Type and Name -----------------------------------------------------------------------------------
            
        document.getElementById("AccommodationnameTypeLoading").style.display = "none";
        document.getElementById("AccommodationTypeandNameContainer").style.display = "";
        document.getElementById("AccommodationTypeText").innerHTML = window.HotelDetails.category.category_name;
        document.getElementById("AccommodationNameText").innerHTML = window.HotelDetails.hotel_name;
        if(document.getElementById("HotelNameHeaderTopBar") != null)
        document.getElementById("HotelNameHeaderTopBar").innerHTML = window.HotelDetails.hotel_name;

        // Location -----------------------------------------------------------------------------------------

        document.getElementById("LoadingLocationTextWrapper").style.display = "none";
        document.getElementById("LocationTextWrapper").style.display = "";
        document.getElementById("LocationText").innerHTML = window.HotelDetails.location;

        if(window.HotelDetails.link_gmaps != null)
        {
            document.getElementById("LocationText").innerHTML = window.HotelDetails.location + " - <a class='SeeMapTextInsidePanel InterBoldTextFont HyperlinkUnderlineText' id='SeeMapTextInsidePanel'>" + window["SeeMapTxt" + window.CurrentCountryID] +"</a>";
            document.getElementById("SeeMapTextInsidePanel").href = window.HotelDetails.link_gmaps;
            document.getElementById("SeeMapTextInsidePanel").target = "_blank";
            document.getElementById("SeeMapTextInsidePanel").rel = "noopener noreferrer";
        }

        // Description -----------------------------------------------------------------------------------------
        let HotelDescriptionToDisplay = window.HotelDetails.hotel_description.replace(/(?:\r\n|\r|\n)/g, '<br>');
        HotelDescriptionToDisplay = window.decodeGarbledContent(HotelDescriptionToDisplay);


        document.getElementById("AboutHotelTextMobileText").innerHTML = window["TentangTxt" + window.CurrentCountryID] + " " + window.HotelDetails.hotel_name;
        document.getElementById("AboutHotelTextMobileText").style.display = "";
        document.getElementById("AboutHotelTextMobileLoading").style.display = "none";

        document.getElementById("AccommodationDescriptionLoading").style.display = "none";
        document.getElementById("AccommodationDescriptionText").style.display = "";
        document.getElementById("AccommodationDescriptionText").innerHTML = HotelDescriptionToDisplay;

        document.getElementById("AccommodationDescriptionLoadingMobile").style.display = "none";
        document.getElementById("AccommodationDescriptionTextMobile").style.display = "";
        document.getElementById("AccommodationDescriptionTextMobile").innerHTML = HotelDescriptionToDisplay;

        let AccommodationDescriptionCollapsible = document.getElementById("AccommodationDescriptionCollapsible");
        let SeeMoreButtonDescription = document.getElementById("SeeMoreButtonDescription");
        SeeMoreButtonDescription.style.display = "";
        let LihatSemuaTextDescription = document.getElementById("LihatSemuaTextDescription");

        if(HotelDescriptionToDisplay.length >= 500)
        {
            window.SetDynamicCollapsible(AccommodationDescriptionCollapsible, SeeMoreButtonDescription, LihatSemuaTextDescription);
        }
        else
        {
            AccommodationDescriptionCollapsible.className = "";
            SeeMoreButtonDescription.style.display = "none";

        }

                
        // Price Early -----------------------------------------------------------------------------------------

        // if(window.HotelDetails != null && window.HotelDetails.rooms.length > 0)
        // {
        //     let RoomDatas = window.HotelDetails.rooms;
        //     let originalRoomPrice = 0;
        //     let FinalPriceDiscounted = 0;

        //     let OriginalPriceTextMobileHotelDetails = document.getElementById("OriginalPriceTextMobileHotelDetails");
        //     let FinalPriceTextMobileHotelDetails = document.getElementById("FinalPriceTextMobileHotelDetails");

        //     for(let i = 0; i < RoomDatas.length; i++)
        //     {
        //         if(RoomDatas[i].status_available == "Yes" && window.CurrentSelectedRoomID == null) // Set Early Selected -------------------------------
        //         {
        //             window.CurrentSelectedRoomID = RoomDatas[i].id_hotel_room;
        //             window.ThisRoomData = RoomDatas[i].room_pings[0].dates;

        //             if(OriginalPriceTextMobileHotelDetails != null)
        //                 OriginalPriceTextMobileHotelDetails.innerHTML = window.ConvertTextToRP(window.ThisRoomData[0].price, 1, false, false);

        //             if(FinalPriceTextMobileHotelDetails != null)
        //                 FinalPriceTextMobileHotelDetails.innerHTML = window.ConvertTextToRP(window.ThisRoomData[0].price_after_disc_per_room, 1, false, false) + "<span class='InterMediumTextFont' style='color:#000000'>" + window["PerMalam2Txt" + window.CurrentCountryID] + "</span>";

        //             // for(let j = 0; j < ThisRoomData.length; j++)
        //             // {
        //             //     originalRoomPrice = originalRoomPrice + parseInt(ThisRoomData[j].price);
        //             //     FinalPriceDiscounted = FinalPriceDiscounted + parseInt(ThisRoomData[j].price);
        //             // }
        //         }
        //     }
        // }

        // Facility -----------------------------------------------------------------------------------------

        document.getElementById("FacilityLoadingWrapper").style.display = "none";
        document.getElementById("FacilityListMainWrapper").style.display = "";

        let MainFacilityContainer = document.getElementById("FacilityAndBenefitsContainer");
        let MobileFacilityContainer = document.getElementById("FacilityAndBenefitsContainerMobile");

        let MainHotelFaciltyList = [MainFacilityContainer, MobileFacilityContainer];

        MainHotelFaciltyList.forEach(ThisContainer =>
        {
            ThisContainer.innerHTML = "";

            for(let i = 0; i < window.HotelDetails.facilities.length; i++)
            {
                let FaciltyChildrenContainer = document.createElement("div");
                FaciltyChildrenContainer.className = "FaciltyChildrenContainer";
                ThisContainer.append(FaciltyChildrenContainer);

                let FacilityIcon = document.createElement("img");
                FacilityIcon.className = "FacilityIcon";
                FacilityIcon.src = window.HotelDetails.facilities[i].icon_link;
                FaciltyChildrenContainer.append(FacilityIcon);

                let FacilityNameText = document.createElement("p");
                FacilityNameText.className = "FacilityNameText InterRegularTextFont";
                FacilityNameText.innerHTML = window.HotelDetails.facilities[i]["facility_name_" + window.CurrentCountryID];
                FaciltyChildrenContainer.append(FacilityNameText);
            }
        });

        let SeeMoreFacilityButton = document.getElementById("SeeMoreFacilityButton");
        let SeeMoreFacilityButtonText = document.getElementById("SeeMoreFacilityButtonText");

        if(window.HotelDetails.facilities.length >= 11)
        {
            SeeMoreFacilityButton.style.display = "";
            window.SetDynamicCollapsible(MobileFacilityContainer, SeeMoreFacilityButton, SeeMoreFacilityButtonText);
        }
        else
        {
            
            MobileFacilityContainer.className = "FacilityAndBenefitsContainer";
            SeeMoreButtonDescription.style.display = "none";

        }



        // Room and Hotel Photo -----------------------------------------------------------------------------------

        window.LoadRoomPhotoBeforeHotelPhoto("HotelDetails", loggedin);

        // Nearby Map -----------------------------------------------------------------------------------

        document.getElementById("SeeNearbyHeaderText").style.display = "";
        document.getElementById("SeeNearbyHeaderLoading").style.display = "none";
        
        let EmbedMapContainer = document.getElementById("EmbedMapContainer");
        InstantiateNearbyMap(window.HotelDetails.embed_maps_med, EmbedMapContainer);

        // Nearby Property --------------------------------------------------------------------------------

        let WhereToInstantiateAll = document.getElementById("AllMainContentSection");
        let NearbyPropertyURL = "/hotels/search/" + window.HotelDetails.province_slug + "/popular?checkin=" + window.CheckInInfo + "&checkout=" + window.CheckOutInfo + "&rooms=" + window.RoomNumberInfo + "&min_price=" + 0 + "&max_price=" + 1000000000;
        let NearbyHeaderText = window["TrendingAccOnTxt" + window.CurrentCountryID] + " " + window.HotelDetails.province;
        window.ReadyToLoadBasicHotelPanelData(WhereToInstantiateAll, NearbyPropertyURL, "NearbyProperty", NearbyHeaderText);

        // Load Exprezy Data -----------------------------------------------------------------------------

        document.getElementById("PingExprezyHeaderText").innerHTML = window["WhatPeopleSayAboutTxt" + window.CurrentCountryID](window.HotelDetails.hotel_name);
        window.LoadExprezyData(MainSession, loggedin);

        // Mobile Low Panel Button -----------------------------------------------------------------------

        if(MobileBookCheckRoomButtonHotelDetails != null)
        {
            // MobileBookCheckRoomButtonHotelDetails.className = "BasicTextButton BasicBoxShadow OrangeButton HorizontalButtonExpanded SignInTopDropDownText Selectable";
            MobileBookCheckRoomButtonHotelDetails.innerHTML = window["LihatKamarButtonTxt" + window.CurrentCountryID];
            MobileBookCheckRoomButtonHotelDetails.onclick = function()
            {
                const RoomHotelContainer = document.getElementById("ChangeRoomContainerHotelDetailsMobile");
                window.ScrollToWindow(RoomHotelContainer);
            }
        }

        // Min Date Range -------------------------------------------------------------------------------

        let MinRangeDateContainerLeft = document.getElementById("MinRangeDateContainerLeft");
        if(MinRangeDateContainerLeft != null)
            MinRangeDateContainerLeft.style.display = "none";

        let MinRangeDateContainerRight = document.getElementById("MinRangeDateContainerRight");
        if(MinRangeDateContainerRight != null)
            MinRangeDateContainerRight.style.display = "none";

        let ThisRoomData = window.HotelDetails.rooms;
        let CurrentLowestDateRange = 0;
        for(let i = 0; i < ThisRoomData.length; i++)
        {
            let WhatMinRangeThis = ThisRoomData[i].min_booking_notice_days;
            if(WhatMinRangeThis != 0 && (CurrentLowestDateRange == 0 || CurrentLowestDateRange > WhatMinRangeThis))
            {
                CurrentLowestDateRange = WhatMinRangeThis;
            }
        }

        if(CurrentLowestDateRange > 0)
        {
            // MinRangeDateContainerLeft.style.display = "flex";
            // let MinRangeDateContainerLeftText = document.getElementById("MinRangeDateContainerLeftText");
            // if(MinRangeDateContainerLeftText != null)
            //     MinRangeDateContainerLeftText.innerHTML = window.MinRangeTextLeft(CurrentLowestDateRange);

            MinRangeDateContainerRight.style.display = "flex";
            let KebijakanReservasiHeaderText = document.getElementById("KebijakanReservasiHeaderText");
            if(KebijakanReservasiHeaderText != null)
                KebijakanReservasiHeaderText.innerHTML = window["KebijakanReservasiTxt" + window.CurrentCountryID];

            let MinRangeDateContainerRightText = document.getElementById("MinRangeDateContainerRightText");
            if(MinRangeDateContainerRightText != null)
                MinRangeDateContainerRightText.innerHTML = window.MinRangeTextRight(CurrentLowestDateRange);
        }


        return
        //!!!!!!!!!!!!!
        // Share Button -----------------------------------------------------------------------------------

        // window.LoadAllHotelDetails();
        // LoadBasicPanel(("nearby_property.php?search=" + window.SearchInfo.toLowerCase() + "&checkin=" + window.CheckInInfo + "&checkout=" + window.CheckOutInfo + "&room=" + window.RoomNumberInfo + "&id_hotel="+window.HotelID), "NearBy", "Nearby Property", "List-of-Nearby-Property");
    }, ()=>
    {
        window.location.replace("/not_found");
    });
}


// ==================================== 

window.HotelDetailsScrollSetting = function()
{
    const AccommodationNameTextMain = document.getElementById("AccommodationNameText");
    const TopBarHotelDetails = document.getElementById("HeaderSearchHotelDetailsTopBar");
    const WhichTopBarCheckCollide = document.getElementById("TopCornerButtonContainer");

    const hotelObserver = new IntersectionObserver(
    ([entry]) =>
    {
        if(entry.isIntersecting)
        {
            if(TopBarHotelDetails.classList.contains("TopBarHotelDetailsNameDisplayed") == true)
                TopBarHotelDetails.classList.remove("TopBarHotelDetailsNameDisplayed");
        }
        else
        {
            if(TopBarHotelDetails.classList.contains("TopBarHotelDetailsNameDisplayed") == false)
                TopBarHotelDetails.classList.add("TopBarHotelDetailsNameDisplayed");
        }
    },
    {
        threshold:0
    });
    hotelObserver.observe(AccommodationNameTextMain);


    const ChangeRoomContainer = document.getElementById('ChangeRoomContainerHotelDetailsMobile');
    const TotalPriceMobileBottom = document.getElementById('TotalPriceMobileBottom');
    const BottomIndexContainer = document.getElementById("BottomIndexContainer");

    function UpdateStickyBookingBar()
    {
        const navbarRect = WhichTopBarCheckCollide.getBoundingClientRect();
        const roomRect = ChangeRoomContainer.getBoundingClientRect();
        const bottompanelRect = BottomIndexContainer.getBoundingClientRect();

        const collided = roomRect.top <= navbarRect.bottom;
        TopBarHotelDetails.classList.toggle("TopBarEditBookingDisplayed", collided);


        const viewportHeight = window.innerHeight;
        const collidedWithBottom = (roomRect.bottom <= viewportHeight && bottompanelRect.top >= viewportHeight);
        TotalPriceMobileBottom.classList.toggle("TotalPriceMobileBottomDisplay", collidedWithBottom);
    }

    window.addEventListener("scroll", UpdateStickyBookingBar, { passive: true });
    window.addEventListener("resize", UpdateStickyBookingBar);
    
    // window.addEventListener("scroll", () =>
    // {
    //     const navbarRect = TopBarHotelDetails.getBoundingClientRect();
    //     const roomRect = ChangeRoomContainer.getBoundingClientRect();

    //     if(roomRect.top <= navbarRect.bottom)
    //     {
    //         if(TopBarHotelDetails.classList.contains("TopBarEditBookingDisplayed") == false)
    //             TopBarHotelDetails.classList.add("TopBarEditBookingDisplayed");
    //     }
    //     else
    //     {
    //         if(TopBarHotelDetails.classList.contains("TopBarEditBookingDisplayed") == true)
    //             TopBarHotelDetails.classList.remove("TopBarEditBookingDisplayed");
    //     }
    // });

    // const bookingObserver = new IntersectionObserver(
    // ([entry]) =>
    // {
    //     if(entry.isIntersecting)
    //     {
    //         stickyBooking.classList.remove("Show");
    //     }
    //     else
    //     {
    //         stickyBooking.classList.add("Show");
    //     }
    // },
    // {
    //     threshold:0
    // });

    // bookingObserver.observe(bookingSection);
    
};



// =========================== LOAD HOTEL & ROOM PHOTO ===========================

window.LoadRoomPhotoBeforeHotelPhoto = function(whichtype, loggedin)
{
    let RoomData = window.HotelDetails.rooms;

    let LoadingContainer = null;
    let RoomContainerToInstant = null;

    let HotelDetailsFilterButtons = document.querySelectorAll(".HotelDetailsFilterButton");

    if(whichtype == "HotelDetails")
    {
        if(window.SelectedHotelDetailsFilter == null)
        {
            window.SelectedHotelDetailsFilter = "Accommodation";
        }

        HotelDetailsFilterButtons.forEach(ThisButton =>
        {
            ThisButton.className = "BasicTextButton BasicBoxShadow BlueOutlineButton SignInButtonTop Selectable HotelDetailsTypeToBookContainer HotelDetailsFilterButton";

            if(ThisButton.id == (window.SelectedHotelDetailsFilter + "FilterButtonHotelDetails"))
            {
                ThisButton.className = "BasicTextButton BasicBoxShadow BlueButtonLight SignInButtonTop Selectable HotelDetailsTypeToBookContainer HotelDetailsFilterButton";
            }
        });

        let ChooseAccOrExpHeaderText = document.getElementById("ChooseAccOrExpHeaderText");
           
        if(ChooseAccOrExpHeaderText != null)
            ChooseAccOrExpHeaderText.innerHTML = window["Choose" + window.SelectedHotelDetailsFilter + "Txt" + window.CurrentCountryID];
        
        document.getElementById("ChooseAccOrExpHeaderText").style.display = "";
        document.getElementById("RoomHeaderLoading").style.display = "none";

        let RoomHotelContainer = document.getElementById("RoomHotelContainer");
        RoomHotelContainer.innerHTML = "";

        LoadingContainer = document.createElement("div");
        LoadingContainer.style.width = "100%";
        LoadingContainer.style.height = "fit-content";
        LoadingContainer.style.display = "flex";
        LoadingContainer.style.flexDirection = "column";
        RoomHotelContainer.append(LoadingContainer);

        RoomData.forEach(rooms =>
        {
            window.LoadingContentPanel(LoadingContainer, 4, null);
        });

        RoomContainerToInstant = document.createElement("div");
        RoomContainerToInstant.style.width = "100%";
        RoomContainerToInstant.style.height = "fit-content";
        RoomContainerToInstant.style.display = "flex";
        RoomContainerToInstant.style.flexDirection = "column";
        RoomContainerToInstant.style.display = "none";
        RoomHotelContainer.append(RoomContainerToInstant);


    }


    let UrlHotelPhoto = "/v2/hotels/" + window.HotelID + "/photos?page=1&limit=9999";
    let LoadRoomPhotoURL = "/v2/hotels/" + window.HotelID + "/rooms/photos?page=1&limit=99999";
    
    window.CallApiAxios({
        method: "GET",
        url: LoadRoomPhotoURL,
    }).then(res =>
    {
        //console.log(LoadRoomPhotoURL);

        if(res.status == 200)
        {
            let LoadRoomListData = res.data.data;
            //console.log(LoadRoomListData);

            // Assign Each Room Photo To Room Data -------------------------------
            
            for(let i = 0; i < LoadRoomListData.length; i++)
            {
                for(let j = 0; j < window.HotelDetails.rooms.length; j++)
                {
                    if(window.HotelDetails.rooms[j].id_hotel_room == LoadRoomListData[i].id_hotel_room)
                    {
                        window.HotelDetails.rooms[j].room_photo = LoadRoomListData[i];
                    }
                }
            }

            // Instantiate Room List -------------------------------------------

            if(whichtype == "HotelDetails")
            {
                let AccommodationFilterButtonHotelDetails = document.getElementById("AccommodationFilterButtonHotelDetails");
                if(AccommodationFilterButtonHotelDetails != null)
                {
                    AccommodationFilterButtonHotelDetails.onclick = function()
                    {
                        window.SelectedHotelDetailsFilter = "Accommodation";
                        window.LoadRoomPhotoBeforeHotelPhoto(whichtype, loggedin);
                    }
                }

                let ExperienceFilterButtonHotelDetails = document.getElementById("ExperienceFilterButtonHotelDetails");
                if(ExperienceFilterButtonHotelDetails != null)
                {
                    ExperienceFilterButtonHotelDetails.onclick = function()
                    {
                        window.SelectedHotelDetailsFilter = "Experience";
                        window.LoadRoomPhotoBeforeHotelPhoto(whichtype, loggedin);
                    }
                }

                window.InstantiateRoomList(RoomContainerToInstant, window.HotelDetails.rooms);
                window.CheckImageContainerImageLoaded(RoomContainerToInstant, LoadingContainer, true);
            }

            // Load Hotel Photo ------------------------------------------

            window.LoadPhotoAccommodationDetails(window.HotelDetails.rooms, UrlHotelPhoto, whichtype, loggedin);
            //window.PreparetoInstantiateHotelImage(RoomData, UrlHotelPhoto, "HotelDetails");
        }
    })
    .catch(err =>
    {
        //console.error(err);
        window.LoadPhotoAccommodationDetails(window.HotelDetails.rooms, UrlHotelPhoto, whichtype, loggedin);
    });
}


window.LoadPhotoAccommodationDetails = function(roomdatas, UrlHotelPhoto, whichtype, loggedin)
{
    window.CallApiAxios({
        method: "GET",
        url: UrlHotelPhoto,
    }).then(res =>
    {
        //console.log(res);
        if(res.status == 200)
        {
            //console.log(UrlHotelPhoto);
            window.HotelPhotoList = res.data.data;
            //console.log(window.HotelPhotoList);
            //console.log(roomdatas);

            // Share Button -----------------------------------------------------------------------------------
            //!!!!!!!!!!!!!!!!!!!!!!! CHECK IF SHARE IMAGE AVAILABLE
            if(loggedin == true)
            {
                document.getElementById("ShareAccommodationButtonWrapper").style.display = "";

                if(whichtype == "HotelDetails")
                {
                    document.getElementById('ShareAccommodationButton').onclick = function()
                    {
                        // let HotelImageFullUrlArray = window.HotelDetails.photos[0].split("/");
                        // let HotelName = HotelImageFullUrlArray[HotelImageFullUrlArray.length-1];
                        window.CheckHotelImageExist(window.HotelPhotoList[0].hotel_photo, window.HotelDetails.id_hotel, loggedin);
                    }
                }

                if(document.getElementById("ShareAccommodationButtonWrapperMobile") != null)
                {
                    document.getElementById("ShareAccommodationButtonWrapperMobile").style.display = "";

                    if(whichtype == "HotelDetails")
                    {
                        document.getElementById('ShareAccommodationButtonMobile').onclick = function()
                        {
                            // let HotelImageFullUrlArray = window.HotelDetails.photos[0].split("/");
                            // let HotelName = HotelImageFullUrlArray[HotelImageFullUrlArray.length-1];
                            window.CheckHotelImageExist(window.HotelPhotoList[0].hotel_photo, window.HotelDetails.id_hotel, loggedin);
                        }
                    }
                }
            }
            else
            {
                document.getElementById("ShareAccommodationButtonWrapper").remove();

                if(document.getElementById("ShareAccommodationButtonWrapperMobile") != null)
                    document.getElementById("ShareAccommodationButtonWrapperMobile").remove();
            }

            // Combine All Image From Hotel First -----------------------------------------------------------

            let AllHotelRoomPhotosBecomeOne =  [...window.HotelPhotoList];
            let SortedRoomPhotos = [];
            window.HotelRoomPhotoSortedData = [];

            for(let i = 0; i < roomdatas.length; i++)
            {
                AllHotelRoomPhotosBecomeOne.push(roomdatas[i].room_photo);
                SortedRoomPhotos.push(roomdatas[i].room_photo);
            }

            window.HotelRoomPhotoSortedData = 
            {
                "hotel_photo":window.HotelPhotoList,
                "room_photo":SortedRoomPhotos,
            }

            //console.log(window.HotelRoomPhotoSortedData);

            // Instantiate Photos --------------------------------------------------------------------------------------------
            
            //console.log("AllHotelRoomPhotosBecomeOne", AllHotelRoomPhotosBecomeOne);
            
            window.PreparetoInstantiateHotelImage(AllHotelRoomPhotosBecomeOne);

        }
    })
    .catch(err =>
    {
        //console.error(err);
    });
}


// =========================== EXPREZY DATA ===========================

window.LoadExprezyData = function(MainSession, loggedin)
{
    //!!!!!!!!!!!!!!!!!!!!!!!
    let URLLoadExprezy = "/v2/hotels/" + window.HotelID + "/exprezy?page=1&limit=" + window.HowManyExprezyPerPage;
    
    window.CallApiAxios({
        method: "GET",
        url: URLLoadExprezy,
    }).then(res =>
    {
        //console.log(URLLoadExprezy);
        //console.log(res);

        if(res.status == 200)
        {
            window.ExprezyData = res.data.data.exprezy;

            //console.log(window.ExprezyData);

            if(loggedin == true) // If User Has Booked Previously, Instantiate The Section Where User Can Comment -------------------------
            {
                let CheckUserBookedHotelURL = "/v2/hotels/" + window.HotelID + "/exprezy/check?id_user=" + MainSession.usd_PING_id + "&token=" + MainSession.usd_PING_tkn;

                window.CallApiAxios({
                    method: "GET",
                    url: CheckUserBookedHotelURL,
                }).then(res =>
                {
                    CheckExprezy = res.data;

                    //console.log("Check Whether User Has Book or Not-------------------------------");
                    //console.log(CheckUserBookedHotelURL);
                    // //console.log(res);
                    //console.log(CheckExprezy);

                    // Instantiate All Commentary ----------------------------------------------
                            
                    if(CheckExprezy.data.length > 0)
                    {
                        document.getElementById("SubmitExperienceContainer").style.display = "";
                        document.getElementById("YouHaveFinishedBookMesText").innerHTML = window["YouHaveBookedPreviouslyMesTxt" + window.CurrentCountryID](window.HotelDetails.hotel_name);

                        document.getElementById("SubmitExperienceButton").onclick = function()
                        {
                            window.OpenViewMoreExperiences(null, CheckExprezy.data[0].booking_reference, MainSession, window.HotelID);
                        }
                    }
                })
                .catch(err =>
                {
                    //console.error(err);
                });

                window.InstantiateAllPingExprezyData(window.ExprezyData, null, MainSession, window.HotelID, null);
            }
            else
            {
                window.InstantiateAllPingExprezyData(window.ExprezyData, null, null, window.HotelID, null);
            }
            


            // Ratings ------------------------------------------------------------

            document.getElementById("RatingMainWrapper").style.display = "";
            document.getElementById("RatingMainWrapperMobile").style.display = "";
            document.getElementById("LoadingRatingMainWrapper").style.display = "none";
                
            let TotalRating = 0;
            let TotalQuantity = window.ExprezyData.length;
                    
            for(let i = 0; i < TotalQuantity; i++)
            {
                TotalRating = TotalRating + parseInt(window.ExprezyData[i].rating);
            }

            let RatingAverage = TotalRating / TotalQuantity; // For Star Icon Class
            let ValueForClassRating = 0;

            if (Number.isInteger(RatingAverage))
            {
                ValueForClassRating = RatingAverage;
            }
            else
            {
                ValueForClassRating = Math.floor(RatingAverage) * 10 + 5;
            }

            document.getElementById("AccRatingText").innerHTML = RatingAverage;
            document.getElementById("AccRatingTextMobile").innerHTML = RatingAverage;

            document.getElementById("StarRatingIconMainWrapperMobile").classList.add("StarRating" + RatingAverage);
            document.getElementById("StarRatingIconMainWrapper").classList.add("StarRating" + RatingAverage);

            document.getElementById("TotalRatingsText").innerHTML = TotalQuantity + " " + window["RatingTxt" + window.CurrentCountryID];
            document.getElementById("TotalRatingsTextMobile").innerHTML = TotalQuantity + " " + window["RatingTxt" + window.CurrentCountryID];

            if(TotalQuantity > 1)
            {
                document.getElementById("TotalRatingsText").innerHTML = TotalQuantity + " " + window["RatingTxtex" + window.CurrentCountryID];
                document.getElementById("TotalRatingsTextMobile").innerHTML = TotalQuantity + " " + window["RatingTxtex" + window.CurrentCountryID];
            }
        }
        else
        {
            document.getElementById("RatingMainWrapper").style.display = "none";
            document.getElementById("RatingMainWrapperMobile").style.display = "none";
            document.getElementById("LoadingRatingMainWrapper").style.display = "none";
        }
    })
    .catch(err =>
    {
        //console.error(err);
        document.getElementById("RatingMainWrapper").style.display = "none";
        document.getElementById("RatingMainWrapperMobile").style.display = "none";
        document.getElementById("LoadingRatingMainWrapper").style.display = "none";
    });
}

window.InstantiateAllPingExprezyData = function(ExprezyData, idbookingadd, MainUserInfo, hotelid, LocationTextToDisplay)
{
    let userID = MainUserInfo?.usd_PING_id;
    
    let PingExprezyMainContainer = document.getElementById("PingExprezyMainContainer");
    let PingExprezySwiperContainer = document.getElementById("PingExprezySwiperContainer");
    let PingExprezyWrapper = document.getElementById("PingExprezyWrapper");
    PingExprezyWrapper.innerHTML = "";

    let ExprezyButtonLeft = document.getElementById("ExprezyButtonLeft");
    let ExprezyButtonRight = document.getElementById("ExprezyButtonRight");

    PingExprezyMainContainer.style.display = "";

    //console.log("ExprezyData", ExprezyData);
    
    for(let i = 0; i < ExprezyData.length; i++)
    {
        let ThisLoadingPanel = window.LoadingContentPanel(PingExprezyWrapper, 5, null);
        
        let PingExprezyPanel = document.createElement("div");
        PingExprezyPanel.className = "PingExprezyPanel InterMediumTextFont Selectable swiper-slide";
        PingExprezyPanel.onclick = function()
        {
            window.OpenViewMoreExperiences(ExprezyData[i].id_experience, idbookingadd, MainUserInfo, hotelid);
        }
        PingExprezyPanel.style.display = "none";
        PingExprezyWrapper.append(PingExprezyPanel);

        let PingExprezyImageContainer = document.createElement("div"); // Ping Exprezy -----------------------
        PingExprezyImageContainer.className = "PingExprezyImageContainer";
        PingExprezyPanel.append(PingExprezyImageContainer);

        let ThisExprezyPhotos = ExprezyData[i].photos;
        if(ExprezyData[i].photos.length <= 0)
        {
            let PhotoTempData =
            {
                "photo":"/Assets/images/NoHotelImage.jpg"
            }
            ThisExprezyPhotos.push(PhotoTempData);
        }

        let FunctionToCallAfterLoaded = function()
        {
            ThisLoadingPanel.remove();
            PingExprezyPanel.style.display = "";
        }

        window.CheckAllImageRemoveEmptyAndWaitLoadCallFunc(ThisExprezyPhotos, "photo", "/Assets/images/NoHotelImage.jpg", PingExprezyImageContainer, { quality: 70}, PingExprezyPanel, ()=>FunctionToCallAfterLoaded());

        let RatingPingExprezyContainer = document.createElement("div"); // Star Rating
        RatingPingExprezyContainer.className = "RatingPingExprezyContainer";
        PingExprezyImageContainer.append(RatingPingExprezyContainer);

        let StarRatingIcon = document.createElement("img");
        StarRatingIcon.src = "/Assets/images/ButtonIcon/star-fill.svg";
        RatingPingExprezyContainer.append(StarRatingIcon);

        let RatingTextMain = document.createElement("p");
        RatingTextMain.className = "RatingPingExprezyRatingText RobotoBoldTextFont";
        RatingTextMain.style.color = "#2494D9";
        RatingTextMain.innerHTML = ExprezyData[i].rating;
        RatingPingExprezyContainer.append(RatingTextMain);

        let RatingTextSub = document.createElement("p");
        RatingTextSub.className = "RatingPingExprezyRatingText RobotoTextFont";
        RatingTextSub.innerHTML = "/5";
        RatingPingExprezyContainer.append(RatingTextSub);


        let PingExprezyDescriptionContainer = document.createElement("div"); // Bottom Description -----------------------
        PingExprezyDescriptionContainer.className = "PingExprezyDescriptionContainer";
        PingExprezyPanel.append(PingExprezyDescriptionContainer);

        let PingExperienceDescriptionText = document.createElement("div");
        PingExperienceDescriptionText.className = "PingExperienceDescriptionText";
        PingExprezyDescriptionContainer.append(PingExperienceDescriptionText);

        let RoomHotelDescriptionInsidePanel = document.createElement("p");
        RoomHotelDescriptionInsidePanel.className = "RoomHotelDescriptionInsidePanel InterRegularTextFont";
        RoomHotelDescriptionInsidePanel.style.color = "#344054";
        RoomHotelDescriptionInsidePanel.innerHTML = ExprezyData[i].experience;
        PingExperienceDescriptionText.append(RoomHotelDescriptionInsidePanel);

        let PingExprezyUserInfoWrapper = document.createElement("div");
        PingExprezyUserInfoWrapper.className = "PingExprezyUserInfoWrapper";
        PingExprezyDescriptionContainer.append(PingExprezyUserInfoWrapper);

        let PingExprezyUserProfileIcon = document.createElement("img");
        PingExprezyUserProfileIcon.className = "PingExprezyUserProfileIcon";
        PingExprezyUserProfileIcon.src = ExprezyData[i].user.profile_picture;
        PingExprezyUserInfoWrapper.append(PingExprezyUserProfileIcon);

        let PingExprezyUserNameLocationWrapper = document.createElement("div");
        PingExprezyUserNameLocationWrapper.className = "PingExprezyUserNameLocationWrapper";
        PingExprezyUserInfoWrapper.append(PingExprezyUserNameLocationWrapper);

        let PingExprezyUserProfileText = document.createElement("p");
        PingExprezyUserProfileText.className = "LabelGreyHeaderSmallerText InterBoldTextFont";
        let UserToDisplay = ExprezyData[i].user.first_name;
        if(userID == ExprezyData[i].user.id_user)
        {
            UserToDisplay = UserToDisplay + " <a class='InterItalicTextFont'>(" + window["YouTxt" + window.CurrentCountryID] + ")</a>";
        }
        PingExprezyUserProfileText.innerHTML = UserToDisplay;
        PingExprezyUserNameLocationWrapper.append(PingExprezyUserProfileText);

        if(LocationTextToDisplay != null)
        {
            let PingExprezyLocationText = document.createElement("p");
            PingExprezyLocationText.className = "LabelGreyHeaderSmallerText InterRegularTextFont";
            PingExprezyLocationText.innerHTML = LocationTextToDisplay;
            PingExprezyUserNameLocationWrapper.append(PingExprezyLocationText);
        }
    }
 
    let PingExprezySwiper = new window.Swiper(PingExprezySwiperContainer,
    {
        slidesPerView: 'auto',
        spaceBetween: 0,
        direction: 'vertical',
        freeMode: true,
        observer: true,
        observeParents: true,
        navigation: {
            prevEl: ExprezyButtonLeft,
            nextEl: ExprezyButtonRight,
        },
        breakpoints:
        {
            561:
            {
                direction: 'horizontal'
            }
        }
    });

    document.getElementById("ViewMoreExperiencesButtonText").onclick = function()
    {
        window.OpenViewMoreExperiences(null, idbookingadd, MainUserInfo, hotelid);
    }

    PingExprezyMainContainer.style.display = "";
}


window.OpenViewMoreExperiences = function(whichidcurrentlyselected, bookingreferences, MainUserInfo, hotelid)
{
    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let FlexContainerWithTopPanel = document.createElement("div");
    FlexContainerWithTopPanel.className = "FlexContainerWithTopPanel";
    BasicBlackBlocker.append(FlexContainerWithTopPanel);

    let TopHeaderContainerInsidePanel = document.createElement("div"); // Top Blue Container ------------------------------------
    TopHeaderContainerInsidePanel.className = "TopHeaderContainerInsidePanel";
    TopHeaderContainerInsidePanel.style.zIndex = 1;
    FlexContainerWithTopPanel.append(TopHeaderContainerInsidePanel);

    let TopHeaderContentWrapper = document.createElement("div");
    TopHeaderContentWrapper.className = "TopHeaderContentWrapper";
    TopHeaderContainerInsidePanel.append(TopHeaderContentWrapper)

    let PinginGoLogo = document.createElement("img");
    PinginGoLogo.className = "PinginGoLogo";
    PinginGoLogo.src = "/Assets/images/Icon/pingingo-icon.svg";
    TopHeaderContentWrapper.append(PinginGoLogo)

    let PingExprezyText = document.createElement("p");
    PingExprezyText.className = "PingExprezyText RobotoBoldTextFont";
    PingExprezyText.innerHTML = "PING-EXPREZY";
    TopHeaderContentWrapper.append(PingExprezyText)

    let CloseButtonInsidePanel = document.createElement("img");
    CloseButtonInsidePanel.className = "CloseButtonInsidePanel Selectable2";
    CloseButtonInsidePanel.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    CloseButtonInsidePanel.onclick = function()
    {
        window.ClosePanelAnimate(FlexContainerWithTopPanel, BasicBlackBlocker, null);
    }
    TopHeaderContainerInsidePanel.append(CloseButtonInsidePanel)


    let FlexContainerBaseAnimate = document.createElement("div"); // Main Container ------------------------------------------------------
    FlexContainerBaseAnimate.className = "FlexContainerBaseAnimate PingExprezyViewMoreContainer";
    FlexContainerWithTopPanel.append(FlexContainerBaseAnimate);

    
    if(bookingreferences != null)
    {
        let InputUserExperienceMainContainer = document.createElement("div"); // Main Container ----------
        InputUserExperienceMainContainer.className = "InputUserExperienceMainContainer";
        FlexContainerBaseAnimate.append(InputUserExperienceMainContainer);

        let YouHaveFinishedMessageP = document.createElement("p");
        YouHaveFinishedMessageP.className = "LabelGreyHeaderSmallerText2 InterRegularTextFont";
        YouHaveFinishedMessageP.innerHTML = window["YouHaveFinishedStayingExprezyTxt" + window.CurrentCountryID](window.HotelDetails.hotel_name);
        InputUserExperienceMainContainer.append(YouHaveFinishedMessageP);

        let TellUserExperienceWrapper = document.createElement("div");
        TellUserExperienceWrapper.className = "TellUserExperienceWrapper";
        InputUserExperienceMainContainer.append(TellUserExperienceWrapper);
        
        let TellMeYourExperienceMessageP = document.createElement("p");
        TellMeYourExperienceMessageP.className = "LabelGreyHeaderText InterBoldTextFont";
        TellMeYourExperienceMessageP.style.marginBottom = "0 !important;";
        TellMeYourExperienceMessageP.style.width = "100%";
        TellMeYourExperienceMessageP.style.textAlign = "center";
        TellMeYourExperienceMessageP.textContent = window["TellMeYourExperiencesTxt" + window.CurrentCountryID];
        TellUserExperienceWrapper.append(TellMeYourExperienceMessageP);

        // Rating Star
        let RatingStarContainer = document.createElement("div");
        RatingStarContainer.className = "UserExperienceRatingContainer";
        RatingStarContainer.setAttribute("current-rating", 0);
        TellUserExperienceWrapper.append(RatingStarContainer);


        // Upload Photo
        let uploadPhotoExprezyContainer = document.createElement("div");
        uploadPhotoExprezyContainer.className = "UserExperienceUploadPhoto BasicRoundRadius BasicBoxShadowMid";
        uploadPhotoExprezyContainer.style.display = "none";
        TellUserExperienceWrapper.append(uploadPhotoExprezyContainer);

        let uploadPhotoExprezyImg = document.createElement("img");
        // uploadPhotoExprezyImg.src = "/Assets/images/AnimateBG/1.jpg";
        uploadPhotoExprezyContainer.append(uploadPhotoExprezyImg);

        let uploadPhotoExprezyBlocker = document.createElement("div");
        uploadPhotoExprezyBlocker.className = "BlockerWithHoverableText BlockerOpacityOnHover";
        uploadPhotoExprezyBlocker.style = "width: 100%; height: 100%; position: absolute; top: 0; left: 0;";
        uploadPhotoExprezyContainer.append(uploadPhotoExprezyBlocker);

        let uploadPhotoExprezyBlockerText = document.createElement("p");
        uploadPhotoExprezyBlockerText.className = "LabelGreyHeaderSmallerText2 InterRegularTextFont";
        uploadPhotoExprezyBlockerText.textContent = window["RemovePhotoTxt" + window.CurrentCountryID];
        uploadPhotoExprezyBlocker.append(uploadPhotoExprezyBlockerText);


        let NewExperiencesInputFileImg = document.createElement("input");
        NewExperiencesInputFileImg.type = "file";
        NewExperiencesInputFileImg.id = "NewExperiencesInputFileImg";
        NewExperiencesInputFileImg.style.display = "none";
        NewExperiencesInputFileImg.accept = ".jpg, .png, .jpeg";
        TellUserExperienceWrapper.append(NewExperiencesInputFileImg);

        
        // Warning Error
        let PingExprezyWarningContainer = document.createElement("div");
        PingExprezyWarningContainer.className = "BasicRoundRadius MarginTextUpDown RedWarningContainer";
        PingExprezyWarningContainer.id = "PingExprezyWarningContainer";
        PingExprezyWarningContainer.style.marginTop = 0;
        PingExprezyWarningContainer.style.display = "none";
        TellUserExperienceWrapper.append(PingExprezyWarningContainer);

        let PingExprezyWarningText = document.createElement("p");
        PingExprezyWarningText.className = "InterMediumTextFont";
        PingExprezyWarningText.id = "PingExprezyWarningText";
        PingExprezyWarningContainer.append(PingExprezyWarningText);


        // Text Area container
        let PingExprezyTextContainer = document.createElement("div");
        PingExprezyTextContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
        PingExprezyTextContainer.id = "ContactUsYourMessageInputContainer";
        PingExprezyTextContainer.style.cssText = "width: 100%; min-width: 100%;";
        TellUserExperienceWrapper.append(PingExprezyTextContainer);

        let PingExprezyTextArea = document.createElement("textarea");
        PingExprezyTextArea.rows = "4";
        PingExprezyTextArea.cols = "50";
        PingExprezyTextArea.className = "InputFieldInsideSmallPanel ContactUsMessageInputField InputFieldSelectable InterMediumTextFont";
        PingExprezyTextArea.placeholder = window["PlaceholderTellMeExperiencesTxt" + window.CurrentCountryID];
        PingExprezyTextContainer.append(PingExprezyTextArea);


        // Add photo button
        let AddPhotoButtonExprezy = document.createElement("button");
        AddPhotoButtonExprezy.className = "BasicTextButton OrangeButton SignInButtonTop Selectable MarginTextUpDown";
        AddPhotoButtonExprezy.style = "width: 100%; margin-bottom: 0 !important";
        TellUserExperienceWrapper.append(AddPhotoButtonExprezy);

        let AddPhotoButtonExprezyWrapper = document.createElement("div");
        AddPhotoButtonExprezyWrapper.style.cssText = "width: fit-content; height: fit-content; display: flex; margin: auto;";
        AddPhotoButtonExprezy.append(AddPhotoButtonExprezyWrapper);

        let AddPhotoButtonExprezyIcon = document.createElement("img");
        AddPhotoButtonExprezyIcon.src = "/Assets/images/ButtonIcon/camera-plus.svg";
        AddPhotoButtonExprezyIcon.className = "BasicIconInsideButton";
        AddPhotoButtonExprezyIcon.style.marginLeft = "0";
        AddPhotoButtonExprezyWrapper.append(AddPhotoButtonExprezyIcon);

        let AddPhotoButtonExprezyText = document.createElement("p");
        AddPhotoButtonExprezyText.textContent = window["AddPhotoToYourExperiencesButtonTxt" + window.CurrentCountryID];
        AddPhotoButtonExprezyText.style.whiteSpace = "nowrap";
        AddPhotoButtonExprezyWrapper.append(AddPhotoButtonExprezyText);


        // Submit button
        let SubmitExperienceButton = document.createElement("button");
        SubmitExperienceButton.className = "BasicTextButton OrangeButton SignInButtonTop ButtonUnselectable MarginTextUpDown";
        SubmitExperienceButton.style.marginBottom = "0 !important";
        SubmitExperienceButton.style.cssText = "width: 100%; background-color: #50A9E1; margin-bottom: 0!important";
        TellUserExperienceWrapper.append(SubmitExperienceButton);

        let SubmitExperienceWrapper = document.createElement("div");
        SubmitExperienceWrapper.style.cssText = "width: fit-content; height: fit-content; display: flex; margin: auto;";
        SubmitExperienceButton.append(SubmitExperienceWrapper);

        let SubmitExperienceIcon = document.createElement("img");
        SubmitExperienceIcon.className = "BasicIconInsideButton PlusIconWhiteButton";
        SubmitExperienceIcon.style.marginLeft = "0";
        SubmitExperienceWrapper.append(SubmitExperienceIcon);

        let SubmitExperienceText = document.createElement("p");
        SubmitExperienceText.innerHTML = window["SubmitExperienceButtonTxt" + window.CurrentCountryID];
        SubmitExperienceText.style.whiteSpace = "nowrap";
        SubmitExperienceWrapper.append(SubmitExperienceText);


        // ------------------------ ADD FUNCTION --------------------------------

        let CheckFunctionToCall = function(isallowchange)
        {
            CheckInputtedNewExprezzy(isallowchange, bookingreferences, MainUserInfo, hotelid, FlexContainerWithTopPanel, BasicBlackBlocker, RatingStarContainer, NewExperiencesInputFileImg, PingExprezyWarningContainer, PingExprezyWarningText, PingExprezyTextContainer, PingExprezyTextArea, SubmitExperienceButton);
        }

        for (let i = 0; i < 5; i++)
        {
            let RatingStar = document.createElement("img");
            RatingStar.className = "UserExperienceStar Selectable2";
            RatingStar.onclick = function()
            {
                PingExprezyWarningContainer.style.display = "none";
                RatingStarContainer.className = "UserExperienceRatingContainer UserExperienceCurrent" + (i+1);
                RatingStarContainer.setAttribute("current-rating", i+1);
                CheckFunctionToCall(true);
            }
            RatingStarContainer.append(RatingStar);
        }

        NewExperiencesInputFileImg.onchange = function()
        {
            if(NewExperiencesInputFileImg.files[0] == null)
            {
                uploadPhotoExprezyContainer.style.display = "none";
                uploadPhotoExprezyImg.src = "";
            }
            else
            {
                uploadPhotoExprezyContainer.style.display = "";
                uploadPhotoExprezyImg.src = URL.createObjectURL(NewExperiencesInputFileImg.files[0]);
            }
            CheckFunctionToCall(true);
        }

        uploadPhotoExprezyBlocker.onclick = function()
        {
            NewExperiencesInputFileImg.value = null;
            uploadPhotoExprezyContainer.style.display = "none";
            CheckFunctionToCall(true);
        }

        AddPhotoButtonExprezy.onclick = function()
        {
            NewExperiencesInputFileImg.click();
        }


        PingExprezyTextArea.onfocus = function(event)
        {
            SubmitExperienceButton.className = "BasicTextButton OrangeButton SignInButtonTop ButtonUnselectable MarginTextUpDown";
            PingExprezyTextContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3";
            PingExprezyWarningContainer.style.display = "none";
        }
        PingExprezyTextArea.addEventListener("focusout", (event) =>
        {
            CheckFunctionToCall(true);
        });

        CheckFunctionToCall(false);
    }

    // ------------------------------ PAST EXPREZY------------------------------

    if(bookingreferences == null)
    {
        let PastExprezyMainContainer = document.createElement("div"); 
        PastExprezyMainContainer.className = "ListofExprezyAllContainer";
        FlexContainerBaseAnimate.append(PastExprezyMainContainer);

        let PaymentSectionHeaderText = document.createElement("p"); 
        PaymentSectionHeaderText.className = "PaymentSectionHeaderText MarginTextUpDown InterBoldTextFont";
        PaymentSectionHeaderText.style = "width: fit-content; margin: 0 auto;";
        PaymentSectionHeaderText.innerHTML = window.HotelDetails.hotel_name;
        PastExprezyMainContainer.append(PaymentSectionHeaderText);

        let BasicContentScroller = document.createElement("div");
        BasicContentScroller.className = "BasicContentScroller HideScrollBar";
        PastExprezyMainContainer.append(BasicContentScroller);

        let ScrollSentinelExprezy = document.createElement("div");
        PastExprezyMainContainer.append(ScrollSentinelExprezy);
        
        window.CurrentExprezyIndex = 1;
        window.ExprezyLastPage = 1;
        window.LoadExprezyDataBasedOnPage(whichidcurrentlyselected, hotelid, MainUserInfo, BasicContentScroller, ScrollSentinelExprezy);
    }


    //------------------------------------ ANIMATE EASE IN --------------------------------------

    window.OpenPanelAnimate(FlexContainerWithTopPanel, BasicBlackBlocker);
}

window.LoadExprezyDataBasedOnPage = function(whichidcurrentlyselected, hotelid, MainUserInfo, BasicContentScroller, ScrollSentinelExprezy)
{
    let LoadingTempInstantiated = [];
    for(let i = 0; i < window.HowManyExprezyPerPage; i++)
    {
        LoadingTempInstantiated.push(InstantiateLoadingExprezyCommentFullScreen(BasicContentScroller));
    }
    
    let URLLoadExprezy = "/v2/hotels/" + hotelid + "/exprezy?page=" + window.CurrentExprezyIndex + "&limit=" + window.HowManyExprezyPerPage;

    window.CallApiAxios({
        method: "GET",
        url: URLLoadExprezy,
    }).then(res =>
    {
        //console.log(URLLoadExprezy);
        //console.log(res);

        if(res.status == 200)
        {
            let ExprezyData = res.data.data.exprezy;

            LoadingTempInstantiated.forEach(loadingtemp => {
                loadingtemp.remove();
            });

            InstantiateExprezyCommentPanel(ExprezyData, whichidcurrentlyselected, MainUserInfo, BasicContentScroller);

            if(window.CurrentExprezyIndex == 1)
            {
                if(res.data.pagination.total_pages != null)
                {
                    window.ExprezyLastPage = res.data.pagination.total_pages;
                }

                let ThisDataObserverOption = {
                    pageKey: "CurrentExprezyIndex",
                    lastPageKey: "ExprezyLastPage",
                    sentinelEl: ScrollSentinelExprezy,
                    functiontocall: () =>
                    {
                        return window.LoadExprezyDataBasedOnPage(whichidcurrentlyselected, hotelid, MainUserInfo, BasicContentScroller, ScrollSentinelExprezy);
                    }
                };
                window.ExprezyScrollObserver = window.makeObserver(ThisDataObserverOption);
            }
        }
    })
    .catch(err =>
    {
        //console.error(err);
        LoadingTempInstantiated.forEach(loadingtemp => {
            loadingtemp.remove();
        });
    });
}

function InstantiateExprezyCommentPanel(ExprezyData, whichidcurrentlyselected, MainUserInfo, wheretoInstantiate)
{
    let ScrollToDropDown;
    let userID = MainUserInfo.usd_PING_id;

    for(let i = 0; i < ExprezyData.length; i++)
    {
        let LoadingExprezy = InstantiateLoadingExprezyCommentFullScreen(wheretoInstantiate)

        let PingExprezyPanelViewDetails = document.createElement("div");
        PingExprezyPanelViewDetails.className = "PingExprezyPanelViewDetails InterMediumTextFont";
        PingExprezyPanelViewDetails.style.opacity = 0;
        wheretoInstantiate.append(PingExprezyPanelViewDetails);

        let PingExprezyImageContainerFullDisplay = document.createElement("img");
        PingExprezyImageContainerFullDisplay.className = "PingExprezyImageContainerFullDisplay";
        window.checkImageUrlValid(ExprezyData[i].photos[0], "/Assets/images/NoHotelImage.jpg", PingExprezyImageContainerFullDisplay, () =>
        {
            window.CheckIfImageLoadedAndCallAFunction(PingExprezyPanelViewDetails, ()=>
            {
                LoadingExprezy.remove();
                PingExprezyPanelViewDetails.style.opacity = 1;
            });
        }, {});
        PingExprezyPanelViewDetails.append(PingExprezyImageContainerFullDisplay);

        let PingExprezyDescriptionContainer = document.createElement("div");
        PingExprezyDescriptionContainer.className = "PingExprezyDescriptionContainer";
        PingExprezyPanelViewDetails.append(PingExprezyDescriptionContainer);

        let TopUserAndDateInfoWrapper = document.createElement("div"); // User and Date ---------------------
        TopUserAndDateInfoWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
        TopUserAndDateInfoWrapper.style = "flex: 1; height: fit-content; display: flex;";
        PingExprezyDescriptionContainer.append(TopUserAndDateInfoWrapper);

        let PingExprezyUserInfoWrapper = document.createElement("div");
        PingExprezyUserInfoWrapper.className = "PingExprezyUserInfoWrapper";
        TopUserAndDateInfoWrapper.append(PingExprezyUserInfoWrapper);

        let PingExprezyUserProfileIcon = document.createElement("img");
        PingExprezyUserProfileIcon.className = "PingExprezyUserProfileIcon";
        PingExprezyUserProfileIcon.src = ExprezyData[i].user.profile_picture;
        PingExprezyUserInfoWrapper.append(PingExprezyUserProfileIcon);

        let PingExprezyUserProfileName = document.createElement("p");
        PingExprezyUserProfileName.className = "LabelGreyHeaderText InterBoldTextFont";
        let UserToDisplay = ExprezyData[i].user.first_name;
        if(userID == ExprezyData[i].user.id_user)
        {
            UserToDisplay = UserToDisplay + " <a class='InterItalicTextFont'>(" + window["YouTxt" + window.CurrentCountryID] + ")</a>";
        }
        PingExprezyUserProfileName.innerHTML = UserToDisplay;
        PingExprezyUserInfoWrapper.append(PingExprezyUserProfileName);

        let DatePublishedText = document.createElement("p");
        DatePublishedText.className = "LabelGreyHeaderSmallerText InterRegularTextFont";
        DatePublishedText.style = "margin-left: auto; white-space: nowrap;";
        DatePublishedText.innerHTML = window.GetHowManyPastMinHourDaysDate(ExprezyData[i].create_update_at);
        TopUserAndDateInfoWrapper.append(DatePublishedText);


        let StarRatingWrapper = document.createElement("div"); // Star Rating ---------------------
        StarRatingWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
        PingExprezyDescriptionContainer.append(StarRatingWrapper);

        let StarRatingIconWrapper = document.createElement("div");
        StarRatingIconWrapper.className = "StarRatingIconWrapper StarRating" + ExprezyData[i].rating;
        StarRatingWrapper.append(StarRatingIconWrapper);
        

        for(let j = 0; j < 5; j++)
        {
            let StarRatingIcon = document.createElement("div");
            StarRatingIcon.className = "StarRatingIcon";
            StarRatingIconWrapper.append(StarRatingIcon);
        }

        let StarRatingTextWrapper = document.createElement("div");
        StarRatingTextWrapper.className = "StarRatingIconWrapper";
        StarRatingWrapper.append(StarRatingTextWrapper);

        let RatingMainText = document.createElement("p");
        RatingMainText.className = "RatingBlueText InterBoldTextFont";
        RatingMainText.innerHTML = ExprezyData[i].rating;
        StarRatingTextWrapper.append(RatingMainText);

        let RatingSubsText = document.createElement("p");
        RatingSubsText.className = "RatingGreyText InterRegularTextFont";
        RatingSubsText.innerHTML = "/5";
        StarRatingTextWrapper.append(RatingSubsText);


        let RoomHotelDescriptionInsidePanel = document.createElement("p"); // Description ---------------------
        RoomHotelDescriptionInsidePanel.className = "RoomHotelDescriptionInsidePanel InterRegularTextFont";
        RoomHotelDescriptionInsidePanel.style = "color: rgb(52, 64, 84); margin-bottom: 0;";
        RoomHotelDescriptionInsidePanel.innerHTML = ExprezyData[i].experience;
        PingExprezyDescriptionContainer.append(RoomHotelDescriptionInsidePanel);

        // Get Information For Basic Scroll Start
        if(whichidcurrentlyselected == ExprezyData[i].id_experience)
        {
            ScrollToDropDown = PingExprezyPanelViewDetails;
        }
    }

    window.ScrollToSelectedDropDown(wheretoInstantiate, ScrollToDropDown);

}

function InstantiateLoadingExprezyCommentFullScreen(wheretoInstantiate)
{
    let PingExprezyPanelViewDetails = document.createElement("div");
    PingExprezyPanelViewDetails.className = "PingExprezyPanelViewDetails InterMediumTextFont";
    wheretoInstantiate.append(PingExprezyPanelViewDetails);

    let DivImageExprezyContainer = document.createElement("div");
    DivImageExprezyContainer.className = "PingExprezyImageContainerFullDisplay";
    PingExprezyPanelViewDetails.append(DivImageExprezyContainer);

    let LoadingGreyCover = document.createElement("div");
    LoadingGreyCover.className = "loading_grey ImageFullCover";
    DivImageExprezyContainer.append(LoadingGreyCover);

    let PingExprezyImageContainerFullDisplay = document.createElement("img");
    PingExprezyImageContainerFullDisplay.className = "PingExprezyImageContainerFullDisplay";
    PingExprezyImageContainerFullDisplay.style.opacity = 0;
    PingExprezyImageContainerFullDisplay.src = "/Assets/images/NoHotelImage.jpg";
    DivImageExprezyContainer.append(PingExprezyImageContainerFullDisplay);

    let PingExprezyDescriptionContainer = document.createElement("div");
    PingExprezyDescriptionContainer.className = "PingExprezyDescriptionContainer";
    PingExprezyPanelViewDetails.append(PingExprezyDescriptionContainer);

    let TopUserAndDateInfoWrapper = document.createElement("div"); // User and Date ---------------------
    TopUserAndDateInfoWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
    TopUserAndDateInfoWrapper.style = "flex: 1; height: fit-content; display: flex;";
    PingExprezyDescriptionContainer.append(TopUserAndDateInfoWrapper);

    let PingExprezyUserInfoWrapper = document.createElement("div");
    PingExprezyUserInfoWrapper.className = "PingExprezyUserInfoWrapper";
    TopUserAndDateInfoWrapper.append(PingExprezyUserInfoWrapper);

    let LoadingProfileImageExprezy = document.createElement("div");
    LoadingProfileImageExprezy.className = "PingExprezyUserProfileIcon loading_grey ImageFullCover";
    PingExprezyUserInfoWrapper.append(LoadingProfileImageExprezy);

    let PingExprezyUserProfileIcon = document.createElement("div");
    PingExprezyUserProfileIcon.className = "ImageFullCover loading_grey";
    LoadingProfileImageExprezy.append(PingExprezyUserProfileIcon);

    let PingExprezyUserProfileName = document.createElement("p");
    PingExprezyUserProfileName.className = "LabelGreyHeaderText InterBoldTextFont loading_grey";
    PingExprezyUserProfileName.innerHTML = "Test1234";
    PingExprezyUserProfileName.style.color = "transparent";
    PingExprezyUserInfoWrapper.append(PingExprezyUserProfileName);

    let DatePublishedText = document.createElement("p");
    DatePublishedText.className = "LabelGreyHeaderSmallerText InterRegularTextFont loading_grey";
    DatePublishedText.style = "margin-left: auto; white-space: nowrap;";
    DatePublishedText.style.color = "transparent";
    DatePublishedText.innerHTML = "01 January 2025";
    TopUserAndDateInfoWrapper.append(DatePublishedText);


    let StarRatingWrapper = document.createElement("div"); // Star Rating ---------------------
    StarRatingWrapper.className = "HotelDetailsHotelInformationMarginWrapper loading_grey";
    StarRatingWrapper.style.width = "fit-content";
    PingExprezyDescriptionContainer.append(StarRatingWrapper);

    let StarRatingIconWrapper = document.createElement("div");
    StarRatingIconWrapper.className = "StarRatingIconWrapper StarRating5";
    StarRatingWrapper.append(StarRatingIconWrapper);

    for(let j = 0; j < 5; j++)
    {
        let StarRatingIcon = document.createElement("div");
        StarRatingIcon.className = "StarRatingIcon";
        StarRatingIcon.style.opacity = 0;
        StarRatingIconWrapper.append(StarRatingIcon);
    }

    let StarRatingTextWrapper = document.createElement("div");
    StarRatingTextWrapper.className = "StarRatingIconWrapper";
    StarRatingWrapper.append(StarRatingTextWrapper);

    let RatingMainText = document.createElement("p");
    RatingMainText.className = "RatingBlueText InterBoldTextFont";
    RatingMainText.innerHTML = 5;
    RatingMainText.style.opacity = 0;
    StarRatingTextWrapper.append(RatingMainText);

    let RatingSubsText = document.createElement("p");
    RatingSubsText.className = "RatingGreyText InterRegularTextFont";
    RatingSubsText.innerHTML = "/5";
    RatingSubsText.style.opacity = 0;
    StarRatingTextWrapper.append(RatingSubsText);


    let RoomHotelDescriptionInsidePanel = document.createElement("p"); // Description ---------------------
    RoomHotelDescriptionInsidePanel.className = "RoomHotelDescriptionInsidePanel InterRegularTextFont loading_grey";
    RoomHotelDescriptionInsidePanel.style = "color: transparent; margin-bottom: 0;";
    RoomHotelDescriptionInsidePanel.innerHTML = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur vel justo hendrerit, fermentum velit ut, hendrerit mauris. Aenean placerat purus ut magna faucibus malesuada. Proin ultrices euismod diam sed mollis. Fusce pretium magna non leo mollis, quis luctus nunc consequat. Integer a vestibulum ante. Donec et dolor dui. Integer lobortis in risus pharetra congue. Morbi at enim blandit, posuere metus at, cursus nibh. Nunc nec volutpat felis, eget tristique lectus. Morbi vel ex a tortor viverra dapibus.";
    PingExprezyDescriptionContainer.append(RoomHotelDescriptionInsidePanel);

    return PingExprezyPanelViewDetails
}


function CheckInputtedNewExprezzy(isallowchange, bookingreferences, MainUserInfo, hotelid, FlexContainerWithTopPanel, BasicBlackBlocker, RatingStarContainer, NewExperiencesInputFileImg, PingExprezyWarningContainer, PingExprezyWarningText, PingExprezyTextContainer, PingExprezyTextArea, SubmitExperienceButton)
{
    let IsInputtedValid = true;
    let CurrentRating = RatingStarContainer.getAttribute("current-rating");
    PingExprezyWarningContainer.style.display = "none";

    if(parseInt(CurrentRating) < 1)
    {
        IsInputtedValid = false;

        if(isallowchange == true)
        {
            PingExprezyWarningContainer.style.display = "";
            PingExprezyWarningText.innerHTML = window["RatingMustBetween1To5Txt" + window.CurrentCountryID];
        }
    }

    if(PingExprezyTextArea.value == ""  || PingExprezyTextArea.value.replace(/ /g, "") == "") // First Name
    {
        IsInputtedValid = false;

        if(isallowchange == true)
        {
            PingExprezyTextContainer.className = "SmallPanelDropDownContainer BasicInputFieldContainer Selectable3 InputFieldWarningOutline";

            PingExprezyWarningContainer.style.display = "";
            PingExprezyWarningText.innerHTML = window["UserExperienceCannotBeEmptyTxt" + window.CurrentCountryID];
        }
    }

    if(NewExperiencesInputFileImg.files.length <= 0)
    {
        IsInputtedValid = false;

        if(isallowchange == true)
        {
            PingExprezyWarningContainer.style.display = "";
            PingExprezyWarningText.innerHTML = window["ExperiencePhotoCannotEmptyTxt" + window.CurrentCountryID];
        }
    }

    if(IsInputtedValid == true)
    {
        SubmitExperienceButton.className = "BasicTextButton OrangeButton SignInButtonTop Selectable MarginTextUpDown";
        SubmitExperienceButton.onclick = function()
        {
            let formData = new FormData();

            formData.append('id_user', MainUserInfo.usd_PING_id);
            formData.append('token', MainUserInfo.usd_PING_tkn);
            formData.append('rating', CurrentRating);
            formData.append('experience', PingExprezyTextArea.value);

            PushPhotoAndMessageExperience(bookingreferences, NewExperiencesInputFileImg.files[0], formData, FlexContainerWithTopPanel, BasicBlackBlocker, PingExprezyWarningContainer, PingExprezyWarningText);
        }
    }
    else
    {
        SubmitExperienceButton.className = "BasicTextButton OrangeButton SignInButtonTop ButtonUnselectable MarginTextUpDown";
        SubmitExperienceButton.onclick = function(){};
    }
}

function PushPhotoAndMessageExperience(bookingreferences, imageinput, formData, FlexContainerWithTopPanel, BasicBlackBlocker, PingExprezyWarningContainer, PingExprezyWarningText)
{
    let UploadPhotoExprezyURL = "/v2/bookings/" + bookingreferences + "/exprezy/upload";
    let UploadExprezyBasicInfoURL = "/v2/bookings/" + bookingreferences + "/exprezy";

    //console.log(window.ConvertFormDataToJSON(formData));
    
    let SubmitExBlocker = window.InstantiateLoadingBlocker("SubmitExBlocker");
    ///!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

    window.CallApiAxios({
        method: "POST",
        url: UploadExprezyBasicInfoURL,
        data: formData
    }).then(res =>
    {
        //console.log(UploadExprezyBasicInfoURL);
        //console.log(res);

        if(res.status == 201)
        {
            formData.append('id_experience', res.data.data.id_experience);
            formData.append('image', imageinput);

            window.CallApiAxios({
                method: "POST",
                url: UploadPhotoExprezyURL,
                data: formData,
                convertFormData: false
            }).then(res =>
            {
                //console.log(UploadPhotoExprezyURL);
                //console.log(res);
                if(res.status == 201)
                {
                    window.ClosePanelAnimate(FlexContainerWithTopPanel, BasicBlackBlocker, null);
                    window.location.reload();
                }
                else
                {
                    PingExprezyWarningContainer.style.display = "";
                    PingExprezyWarningText.innerHTML = window["BasicErrorMes" + window.CurrentCountryID];
                }

                SubmitExBlocker.remove();
            })
            .catch(err =>
            {
                //console.error(err);
                PingExprezyWarningContainer.style.display = "";
                SubmitExBlocker.remove();
                if(err.data.message == "Failed to upload exprezy photo")
                {
                    PingExprezyWarningText.innerHTML = window["FailedToUploadExprezyPhotoTxt" + window.CurrentCountryID];
                }
                else if(err.data.errors != null)
                {
                    if(err.data.errors.id_experience == "The selected id_experience is invalid.")
                    {
                        PingExprezyWarningText.innerHTML = window["IDExperinceInvalidTxt" + window.CurrentCountryID];
                    }
                    else if(err.data.errors.image == "The image must be an image file.")
                    {
                        PingExprezyWarningText.innerHTML = window["ErrorImageMustBeImageFileTxt" + window.CurrentCountryID];
                    }
                }
                else
                {
                    PingExprezyWarningText.innerHTML = window["BasicErrorMes" + window.CurrentCountryID];
                }
            });
        }
    })
    .catch(err =>
    {
        //console.error(err);
        PingExprezyWarningContainer.style.display = "";
        SubmitExBlocker.remove();

        if(err.data.message == "Booking not found for this user")
        {
            PingExprezyWarningText.innerHTML = window["ErrorBookingNotFoundForThisUserTxt" + window.CurrentCountryID];
        }
        else if(err.data.message == "Experience already exists for this booking")
        {
            PingExprezyWarningText.innerHTML = window["ErrorExprezyAlreayExistTxt" + window.CurrentCountryID];
        }
        else if(err.data.message == "Failed to create exprezy")
        {
            PingExprezyWarningText.innerHTML = window["FailedToSendUserExTxt" + window.CurrentCountryID];
        }
        else
        {
            PingExprezyWarningText.innerHTML = window["BasicErrorMes" + window.CurrentCountryID];
        }
    });
}

// ========================================== INSTANTIATE HOTEL IMAGE ============================================

window.AllHotelImagePool = null;
window.AllFacilitiesImagePool = [];
window.AllRoomImagePool = [];

window.PreparetoInstantiateHotelImage = function(HotelPhotos) // Load Hotel Image As Pool ---------------------------------
{
    (async () =>
    {
        window.AllHotelImagePool = await window.createImagePoolImmediate(HotelPhotos);

        window.AllRoomImagePool = window.AllHotelImagePool.filter(img => img.getAttribute("type") === "Room");
        window.AllFacilitiesImagePool = window.AllHotelImagePool.filter(img => img.getAttribute("type") === "Hotel");

        window.FinalPreparationInstantiateHotelImage();
        window.resolvePoolInBackground(window.AllHotelImagePool, "/Assets/images/NoHotelImage.jpg");
    })();

    return
    (async () =>
    {
        window.AllHotelImagePool = await window.buildImagePoolCompleteLoad(HotelPhotos, "/Assets/images/NoHotelImage.jpg", {quality: 100});
        //console.log(window.AllHotelImagePool);

        window.AllHotelImagePool.forEach(PhotoData =>
        {
            if(PhotoData.getAttribute("type") == "Room")
            {
                window.AllRoomImagePool.push(PhotoData);
            }
            else
            {
                window.AllFacilitiesImagePool.push(PhotoData);
            }
        });

        window.FinalPreparationInstantiateHotelImage();
    })();
}

window.FinalPreparationInstantiateHotelImage = function()
{
    window.WhatCurrentImageIndex = 0;

    let ImagePreviewBackgroundContainer = document.getElementById("ImagePreviewBackgroundContainer");
    ImagePreviewBackgroundContainer.style.display = "";
    let LoadingImageBackgroundPreview = document.getElementById("LoadingImageBackground");
    LoadingImageBackgroundPreview.style.display = "none";
    let ImageTopMainWrapper = document.getElementById("ImageTopMainWrapper");

    let MiniImageListSwiperContainer = document.getElementById("MiniImageListSwiperContainer");
    let MiniImageListSwiperWrapper = document.getElementById("MiniImageListSwiperWrapper");
    MiniImageListSwiperWrapper.innerHTML = "";
    let ImgSwiperPrevButton = document.getElementById("ImgSwiperPrevButton");
    let ImgSwiperNextButton = document.getElementById("ImgSwiperNextButton");

    let RemainingPhotoTextContainer = document.getElementById("RemainingPhotoTextContainer");
    if(RemainingPhotoTextContainer != null)
    RemainingPhotoTextContainer.style.display = "";

    let RemainingPhotoText = document.getElementById("RemainingPhotoText");

    let PrevMobilePhotoButtonContainer = document.getElementById("PrevMobilePhotoButtonContainer");
    if(PrevMobilePhotoButtonContainer != null)
        PrevMobilePhotoButtonContainer.style.display = "";

    let PrevMobilePhotoButton = document.getElementById("PrevMobilePhotoButton");

    let NextMobilePhotoButtonContainer = document.getElementById("NextMobilePhotoButtonContainer");
    if(NextMobilePhotoButtonContainer != null)
        NextMobilePhotoButtonContainer.style.display = "";

    let NextMobilePhotoButton = document.getElementById("NextMobilePhotoButton");




    let ListOfPrevImageButton = [ImgSwiperPrevButton, PrevMobilePhotoButton];
    let ListOfNextImageButton = [ImgSwiperNextButton, NextMobilePhotoButton];

    // Instantiate Images ------------------------------------------------------------------------------

    window.InstantiateHotelImage(ImagePreviewBackgroundContainer, LoadingImageBackgroundPreview, ImageTopMainWrapper);

    // Mini choice Image ---------------------------------------------------------------------------------
    
    MainImageSwiper = new window.Swiper(MiniImageListSwiperContainer, 
    {
        effect: 'coverflow',
        freeMode: true,
        centeredSlides: true,
        slidesPerView: 'auto',
        observer: true,
        observeParents: true,
        centeredSlides: true,
        coverflowEffect: {
            rotate: 30,
            stretch: 0,
            depth: 150,
            modifier: 1,
            slideShadows: true,
        },
        navigation: {
            nextEl: ListOfNextImageButton,
            prevEl: ListOfPrevImageButton,
        },
        on:{
        slideChange : function()
        {
            window.WhatCurrentImageIndex = this.activeIndex;
            const totalSlides = MainImageSwiper.slides.length;

            let TextToDisplay = (window.WhatCurrentImageIndex + 1) + "/" + totalSlides;
            if(RemainingPhotoText != null)
            RemainingPhotoText.innerHTML = TextToDisplay;
            
            window.InstantiateHotelImage(ImagePreviewBackgroundContainer, LoadingImageBackgroundPreview, ImageTopMainWrapper);
        }}
    });


    window.WhatCurrentImageIndex = MainImageSwiper.activeIndex;
    if(RemainingPhotoText != null)
    RemainingPhotoText.innerHTML = (window.WhatCurrentImageIndex + 1) + "/" + window.AllHotelImagePool.length;


    for(let i = 0; i < window.AllHotelImagePool.length; i++)
    {
        let HotelImageSwiperPanel = document.createElement("div");
        HotelImageSwiperPanel.className = "HotelImageSwiperPanel swiper-slide Selectable2";
        HotelImageSwiperPanel.onclick = function()
        {
            MainImageSwiper.slideTo(i);
        }
        MiniImageListSwiperWrapper.append(HotelImageSwiperPanel);

        let LoadingSkeleton = document.createElement("div"); // Loading Grey -------------
        LoadingSkeleton.className = "loading_grey ImageFullCover";
        HotelImageSwiperPanel.append(LoadingSkeleton);

        let baseImg = window.AllHotelImagePool[i]; // Clone Image From Pool ----------------

        let ThisClonedImage = document.createElement("img");
        ThisClonedImage.style.opacity = 0;
        ThisClonedImage.className = "ImageFullCover";

        baseImg._clones ??= [];
        baseImg._clones.push(ThisClonedImage);

        window.HandleLoadingSkeletonAndImage(LoadingSkeleton, ThisClonedImage);

        let ImageSmallChoice = HotelImageSwiperPanel.appendChild(ThisClonedImage); // Append Image ----------------
        ImageSmallChoice.classList.add("ImageFullCover");
    }

    ImgSwiperNextButton.style.opacity = "";
    ImgSwiperPrevButton.style.opacity = "";
}

window.InstantiateHotelImage = function(ImagePreviewBackgroundContainer, LoadingImageBackgroundPreview, ImageTopMainWrapper)
{
    ImageTopMainWrapper.innerHTML = "";
    ImagePreviewBackgroundContainer.innerHTML = "";

    // let ImagePreviewBackground = ImagePreviewBackgroundContainer.appendChild(window.AllHotelImagePool[WhatCurrentImageIndex].cloneNode(true));
    let ImagePreviewBackground = ImagePreviewBackgroundContainer.appendChild(window.bindImageFromPool(window.AllHotelImagePool[window.WhatCurrentImageIndex]));

    ImagePreviewBackground.id = "ImagePreviewBackground";
    ImagePreviewBackground.classList.add("RoomPanelImageBackgroundDisplay");

    // window.checkImageUrlValid(HotelPhotos[WhatCurrentImageIndex], "/Assets/images/NoHotelImage.jpg", BackgroundToDisplay, () =>{}, { quality: 70});

    // Main Hotel Image ----------------------------------------------------------------------------------

    let HotelDetailsHotelImageMain = document.createElement("div");
    HotelDetailsHotelImageMain.className = "HotelDetailsHotelImageMain BasicRoundRadius Selectable";
    ImageTopMainWrapper.append(HotelDetailsHotelImageMain);

    let ImageMainLoading = document.createElement("div");
    ImageMainLoading.className = "loading_grey ImageFullCover";
    HotelDetailsHotelImageMain.append(ImageMainLoading);
    
    let ImageFullCover = HotelDetailsHotelImageMain.appendChild(window.bindImageFromPool(window.AllHotelImagePool[window.WhatCurrentImageIndex]));
    ImageFullCover.className = "ImageFullCover";
    ImageFullCover.style.opacity = 0;
    ImageFullCover.onclick = function()
    {
        window.OpenImageFullScreen("WhatCurrentImageIndex", window.AllHotelImagePool, () => MainImageSwiper.slideTo(window["WhatCurrentImageIndex"]));
    }
    window.HandleLoadingSkeletonAndImage(ImageMainLoading, ImageFullCover);

    let BasicTextButton = document.createElement("button");
    BasicTextButton.className = "BasicTextButton BasicBoxShadow OrangeButton SeeAllPhotosButton Selectable HideOnMobile3";
    BasicTextButton.innerHTML = window["SeeAllPhotosTxt" + window.CurrentCountryID];
    BasicTextButton.onclick = function()
    {
        window.OpenSeeAllPhotosContainer();
    }
    HotelDetailsHotelImageMain.append(BasicTextButton);

    // Sub Hotel Image ---------------------------------------------------------------------------------

    let HotelImageSubsContainer;
    let HowManyInstantiated = 1;

    if(window.AllHotelImagePool.length > 1)
    {
        for(let i = (window.WhatCurrentImageIndex+1); i < window.AllHotelImagePool.length; i++)
        {
            if(HowManyInstantiated < 5)
            {
                if(HowManyInstantiated%2 != 0)
                {
                    HotelImageSubsContainer = document.createElement("div");
                    HotelImageSubsContainer.className = "HotelDetailsHotelImageSub";
                    ImageTopMainWrapper.append(HotelImageSubsContainer);
                }
        
                let ImageSubsMiniContainer = document.createElement("div");
                ImageSubsMiniContainer.className = "HotelDetailsHotelImageSubMini2";
                HotelImageSubsContainer.append(ImageSubsMiniContainer);
    
                let ImageSubsMiniLoading = document.createElement("div");
                ImageSubsMiniLoading.className = "loading_grey ImageFullCover";
                ImageSubsMiniContainer.append(ImageSubsMiniLoading);

                let ImageSubsMiniImage = ImageSubsMiniContainer.appendChild(window.bindImageFromPool(window.AllHotelImagePool[i]));
                ImageSubsMiniImage.className = "ImageFullCover";
                ImageSubsMiniImage.style.opacity = 0;
                ImageSubsMiniImage.onclick = function()
                {
                    MainImageSwiper.slideTo(i);
                }
                window.HandleLoadingSkeletonAndImage(ImageSubsMiniLoading, ImageSubsMiniImage);

                HowManyInstantiated++;
            }
        }
    }

    if(HotelImageSubsContainer != null && HotelImageSubsContainer.children.length == 1) // If the Image inside sub mini wrapper only one, add 1 dummy
    {
        let ImageSubsMiniContainer = document.createElement("div");
        ImageSubsMiniContainer.className = "HotelDetailsHotelImageSubMini2";
        ImageSubsMiniContainer.style.opacity = "0";
        HotelImageSubsContainer.append(ImageSubsMiniContainer);

        let ImageSubsMiniImage = document.createElement("img");
        ImageSubsMiniImage.className = "ImageFullCover";
        ImageSubsMiniContainer.append(ImageSubsMiniImage);
    }

    // window.CheckImageContainerImageLoaded2(document.getElementById("HotelDetailsHotelImageContainer"), true);
}

// ========================================== INSTANTIATE HOTEL IMAGE ============================================

window.InstantiateRoomList = function(RoomContainerToInstant, RoomData)
{
    if(window.SelectedHotelDetailsFilter != null)
    {
        let NoRoomAvailableHeaderText = document.getElementById("NoRoomAvailableHeaderText");
        let NoRoomAvailableMessageText = document.getElementById("NoRoomAvailableMessageText");

        let ToFilter = "per night";
        if(window.SelectedHotelDetailsFilter == "Experience")
        {
            if(NoRoomAvailableHeaderText != null)
                NoRoomAvailableHeaderText.innerHTML = window["NoExperienceAvailableHeaderTxt" + window.CurrentCountryID];
            
            if(NoRoomAvailableMessageText != null)
                NoRoomAvailableMessageText.innerHTML = window["NoExperienceAvailableMessageTxt" + window.CurrentCountryID];

            ToFilter = "per day";
        }
        else
        {
            if(NoRoomAvailableHeaderText != null)
                NoRoomAvailableHeaderText.innerHTML = window["NoRoomAvailableHeaderTxt" + window.CurrentCountryID];
            
            if(NoRoomAvailableMessageText != null)
                NoRoomAvailableMessageText.innerHTML = window["NoRoomAvailableMessageTxt" + window.CurrentCountryID];
        }
            

        RoomData = RoomData.filter(thisbookingdata => thisbookingdata.book_type === ToFilter);
    }

    let RoomHotelContainer = document.getElementById("RoomHotelContainer");
    let NoRoomAvailableContainer = document.getElementById("NoRoomAvailableContainer");

    //console.log(RoomData);
    //console.log(RoomContainerToInstant);

    if(RoomData.length > 0)
    {
        RoomHotelContainer.style.display = "";
        NoRoomAvailableContainer.style.display = "none";

        for(let i = 0; i < RoomData.length; i++)
        {
            let RoomHotelPanel = document.createElement("div");
            RoomHotelPanel.className = "RoomHotelPanel";
            RoomHotelPanel.style.flexDirection = "column";
            RoomHotelPanel.setAttribute("room-id", RoomData[i].id_hotel_room);
            RoomContainerToInstant.append(RoomHotelPanel);
        
            let RoomHotelWrapper = document.createElement("div"); // Top Info ----------------
            RoomHotelWrapper.className = "RoomHotelWrapper";
            RoomHotelPanel.append(RoomHotelWrapper);
        
            let RoomHotelImageInsidePanel = document.createElement("div"); // Room Hotel
            RoomHotelImageInsidePanel.className = "RoomHotelImageInsidePanel HotelDetailsRoomHotelContainer";
            RoomHotelWrapper.append(RoomHotelImageInsidePanel);

            let LoadingImageGrey = document.createElement("div");
            LoadingImageGrey.className = "loading_grey ImageFullCover";
            RoomHotelImageInsidePanel.append(LoadingImageGrey);

            let PotonganContainer = null;

            if(RoomData[i]?.room_pings?.length > 0 && RoomData[i]?.room_pings[0]?.dates?.length > 0)
            {
                let ThisRoomDiscData = RoomData[i].room_pings[0].dates[0].disc_now;
                let MaxDiscountPinginGo = parseInt(ThisRoomDiscData.max_price_disc_pingingo ?? 0, 10) || 0;;
                let MaxDiscountMitra = parseInt(ThisRoomDiscData.max_price_disc_mitra ?? 0, 10) || 0;
                let TotalMaxDiscount = MaxDiscountPinginGo + MaxDiscountMitra;
                let DiscountPercentage = ThisRoomDiscData.total_discount;

                if(DiscountPercentage != 0 && TotalMaxDiscount != 0)
                {
                    PotonganContainer = document.createElement("div");  // potongan Menginap Room ----------------
                    PotonganContainer.className = "HotelDetailsHotelInformationMarginWrapper ChangeRoomContainerHotelDetailsMobileTop ShowOnMobile3";
                    PotonganContainer.style.bottom = "0";
                    PotonganContainer.style.position = "absolute";
                    PotonganContainer.style.zIndex = 1;
                    RoomHotelImageInsidePanel.append(PotonganContainer);

                    let MessageContainer = document.createElement("div");
                    MessageContainer.className = "ContainerWithIconAndText2 ShareBookingMesButtonContainer BasicRoundRadius";
                    MessageContainer.style.background = "#FC5555";
                    PotonganContainer.append(MessageContainer);

                    let ContentWrapper = document.createElement("div");
                    ContentWrapper.className = "ColumnGapBasic";
                    ContentWrapper.style.width = "fit-content";
                    ContentWrapper.style.height = "fit-content";
                    ContentWrapper.style.display = "flex";
                    ContentWrapper.style.margin = "auto";
                    MessageContainer.append(ContentWrapper);

                    let PercentIcon = document.createElement("img");
                    PercentIcon.src = "/Assets/images/ButtonIcon/percent-red.svg";
                    PercentIcon.className = "FacilityIcon";
                    PercentIcon.style.marginLeft = "0";
                    ContentWrapper.append(PercentIcon);

                    

                    let MessageText = document.createElement("p");
                    MessageText.className = "LabelGreyHeaderSmallerText InterMediumTextFont";
                    MessageText.style.margin = "auto 0";
                    MessageText.style.color = "white";
                    //console.log("RoomData[i]", RoomData[i]);
                    MessageText.innerText = window.DiscountWithMaxTxtid(DiscountPercentage, TotalMaxDiscount);
                    ContentWrapper.append(MessageText);
                }
            }


            let FunctionToCallAfterLoaded = function()
            {
                LoadingImageGrey.remove();
                if(PotonganContainer != null)
                    PotonganContainer.style.display = "flex";
            }

            window.CheckAllImageRemoveEmptyAndWaitLoadCallFunc(RoomData[i].photos, "room_photo", "/Assets/images/NoImage.jpeg", RoomHotelImageInsidePanel, {}, RoomHotelImageInsidePanel, ()=>FunctionToCallAfterLoaded());


            let RoomHotelImageRightSectionInSeparatorsidePanel = document.createElement("div");
            RoomHotelImageRightSectionInSeparatorsidePanel.className = "RoomHotelImageRightSectionInSeparatorsidePanel SmallCollapsibleContent BasicGradientBottomMask";
            RoomHotelWrapper.append(RoomHotelImageRightSectionInSeparatorsidePanel);

            let RoomHotelPanelInfoOneWrapper = document.createElement("div");
            RoomHotelPanelInfoOneWrapper.className = "RoomHotelPanelInfoOneWrapper";
            RoomHotelImageRightSectionInSeparatorsidePanel.append(RoomHotelPanelInfoOneWrapper);

            window.SetDynamicCollapsible(RoomHotelImageRightSectionInSeparatorsidePanel, RoomHotelPanel, null);


            let RoomHotelNameDescWrapper = document.createElement("div"); // Name and Description Wrapper ----------------
            RoomHotelNameDescWrapper.className = "HotelDetailsHotelInformationMarginWrapper2";
            RoomHotelNameDescWrapper.style.flexDirection = "column";
            RoomHotelPanelInfoOneWrapper.append(RoomHotelNameDescWrapper);

            let RoomTypeAndNameWrapper = document.createElement("div"); // Room Type ---
            RoomTypeAndNameWrapper.className = "HotelDetailsHotelInformationMarginWrapper BasicChildMargin2 RowGapBasic";
            RoomTypeAndNameWrapper.style.marginBottom = 0;
            RoomHotelNameDescWrapper.append(RoomTypeAndNameWrapper);

            let RoomTypeContainer = document.createElement("div"); // Room Type ---
            RoomTypeContainer.className = "RedBorderMaxDiscountHotelDetails";
            RoomTypeContainer.style.backgroundColor = "#2494D9"
            RoomTypeAndNameWrapper.append(RoomTypeContainer);

            let RoomTypeText = document.createElement("p");
            RoomTypeText.className = "LabelGreyHeaderSmallerText InterBoldTextFont";
            RoomTypeText.style = "opacity: 1; color: white;";
            RoomTypeText.innerHTML = RoomData[i].room_type["room_type_name_" + window.CurrentCountryID];
            RoomTypeContainer.append(RoomTypeText);        
        
            let RoomHotelNameText = document.createElement("p");
            RoomHotelNameText.className = "RoomHotelNameInsidePanel InterBoldTextFont";
            RoomHotelNameText.innerHTML = RoomData[i].room_name;
            RoomTypeAndNameWrapper.append(RoomHotelNameText);

            let RoomDescriptionToDisplay = RoomData[i].room_description.replace(/(?:\r\n|\r|\n)/g, '<br>');
            RoomDescriptionToDisplay = window.decodeGarbledContent(RoomDescriptionToDisplay);

            let RoomHotelDescriptionText = document.createElement("p");
            RoomHotelDescriptionText.className = "RoomHotelDescriptionInsidePanel InterRegularTextFont";
            RoomHotelDescriptionText.innerHTML = RoomDescriptionToDisplay;
            RoomHotelNameDescWrapper.append(RoomHotelDescriptionText);

            if(RoomData[i].facilities != null && RoomData[i].facilities.length > 0)
            {
                let RoomHotelFacilityContainer = document.createElement("div"); // Facility -----------------------
                RoomHotelFacilityContainer.className = "HotelDetailsHotelInformationMarginWrapper";
                RoomHotelFacilityContainer.style.flexDirection = "column";
                RoomHotelPanelInfoOneWrapper.append(RoomHotelFacilityContainer);
        
                let RoomHotelFacilityHeaderText = document.createElement("p");
                RoomHotelFacilityHeaderText.className = "LabelGreyHeaderSmallerText InterBoldTextFont";
                RoomHotelFacilityHeaderText.innerHTML = window["FacilityTxt" + window.CurrentCountryID];
                RoomHotelFacilityContainer.append(RoomHotelFacilityHeaderText);
        
                let RoomHotelFacilityWrapper = document.createElement("div");
                RoomHotelFacilityWrapper.className = "FacilityAndBenefitsContainer";
                RoomHotelFacilityContainer.append(RoomHotelFacilityWrapper);
        
                for(let j = 0; j < RoomData[i].facilities.length; j++)
                {
                    let FaciltyChildrenContainer = document.createElement("div");
                    FaciltyChildrenContainer.className = "FaciltyChildrenContainer";
                    RoomHotelFacilityWrapper.append(FaciltyChildrenContainer);
        
                    let FacilityIcon = document.createElement("img");
                    FacilityIcon.className = "FacilityIcon";
                    FacilityIcon.src = RoomData[i].facilities[j].icon_link;
                    FaciltyChildrenContainer.append(FacilityIcon);
        
                    let FacilityNameText = document.createElement("p");
                    FacilityNameText.className = "FacilityNameText InterRegularTextFont";
                    FacilityNameText.innerHTML = RoomData[i].facilities[j]["facility_name_" + window.CurrentCountryID];
                    FaciltyChildrenContainer.append(FacilityNameText);
                }
            }


            let RoomHotelPanelBlueBottomPanel = document.createElement("div"); // Bottom Info ----------------
            RoomHotelPanelBlueBottomPanel.className = "RoomHotelPanelBlueBottomPanel";
            RoomHotelPanel.append(RoomHotelPanelBlueBottomPanel);

            // let LastPingandPingToGoWrapper = document.createElement("div"); // Ping to Go and Last Ping
            // LastPingandPingToGoWrapper.className = "RoomHotelPanelBlueBottomLeftWrapper";
            // RoomHotelPanelBlueBottomPanel.append(LastPingandPingToGoWrapper);

            // let PingToGoText = document.createElement("p");
            // PingToGoText.className = "PingToGoHotelDetailsText InterRegularTextFont";
            // PingToGoText.innerHTML = "-- Ping! to go";
            // LastPingandPingToGoWrapper.append(PingToGoText);

            // let LastPingText = document.createElement("p");
            // LastPingText.className = "PingToGoInsidePanel InterBoldTextFont";
            // LastPingText.innerHTML = "Last Ping! -- Hours Ago";
            // LastPingandPingToGoWrapper.append(LastPingText);

            let OriginalandStartPriceWrapper = document.createElement("div"); // Ping to Go and Last Ping
            OriginalandStartPriceWrapper.className = "RoomHotelPanelBlueBottomRightWrapper";
            RoomHotelPanelBlueBottomPanel.append(OriginalandStartPriceWrapper);

            let OriginalPriceDiscountPercentageWrapper = document.createElement("div");
            OriginalPriceDiscountPercentageWrapper.className = "ColumnGapBasic";
            OriginalPriceDiscountPercentageWrapper.style.width = "fit-content";
            OriginalPriceDiscountPercentageWrapper.style.display = "flex";
            OriginalPriceDiscountPercentageWrapper.style.marginLeft = "auto";
            OriginalandStartPriceWrapper.append(OriginalPriceDiscountPercentageWrapper);

            let DiscountPercentageRoomText = document.createElement("p");
            DiscountPercentageRoomText.className = "CuttedPriceText DiscountPercentageRoomPriceHotelDetailsText ShowOnMobile3";
            DiscountPercentageRoomText.style.color = "red";
            DiscountPercentageRoomText.style.textDecoration = "none";
            OriginalPriceDiscountPercentageWrapper.append(DiscountPercentageRoomText);

            let OriginalPriceText = document.createElement("p");
            OriginalPriceText.className = "CuttedPriceText";
            // OriginalPriceText.style.color = "white";
            OriginalPriceDiscountPercentageWrapper.append(OriginalPriceText);

            let StartPriceText = document.createElement("p");
            StartPriceText.className = "OriginalPriceHotelDetailsText InterMediumTextFont";
            OriginalandStartPriceWrapper.append(StartPriceText);

            let ThisRoomIsAvailable = GetPingDataInformation(RoomData[i].room_pings, DiscountPercentageRoomText, OriginalPriceText, StartPriceText);

            let SelectRoomButton = document.createElement("button"); // Select Button
            SelectRoomButton.className = "BasicTextButton BasicBoxShadow OrangeButton SelectRoomButton Selectable NotSelectedHotelDetailsButton";
            SelectRoomButton.innerHTML = window["SelectRoomButtonTxt" + window.CurrentCountryID];
            SelectRoomButton.id = "SelectRoomButton" + RoomData[i].id_hotel_room;
            SelectRoomButton.onclick = function(event)
            {
                event.preventDefault();
                event.stopPropagation();

                window.CurrentSelectedRoomID = RoomData[i].id_hotel_room;
                const HotelDetailsRightPanel = document.getElementById("HotelDetailsInformationRightSection");
                const RightPanelCSSInfo = window.getComputedStyle(HotelDetailsRightPanel);

                if(RightPanelCSSInfo.display != "none")
                window.ScrollToWindow(HotelDetailsRightPanel);

                window.CalculateTotalHotelDetails(true);
            }
            RoomHotelPanelBlueBottomPanel.append(SelectRoomButton);

            if(window.CurrentSelectedRoomID != null && window.CurrentSelectedRoomID == RoomData[i].id_hotel_room)
            {
                SelectRoomButton.className = "BasicTextButton BasicBoxShadow OrangeButton SelectRoomButton Selectable";
                SelectRoomButton.innerHTML = window["SelectedButtonTxt" + window.CurrentCountryID];
            }
            

            // ------------------------- ROOM UNAVAILABLE -------------------------------

            let RoomUnavailableBlockerHotelDetails = document.createElement("div");
            RoomUnavailableBlockerHotelDetails.className = "RoomUnavailableBlockerHotelDetails";
            RoomUnavailableBlockerHotelDetails.style.display = "none";
            RoomUnavailableBlockerHotelDetails.style.zIndex = 1;
            RoomHotelPanel.append(RoomUnavailableBlockerHotelDetails);

            let RoomUnavailableWrapper = document.createElement("div");
            RoomUnavailableWrapper.className = "RoomUnavailableWrapper";
            RoomUnavailableBlockerHotelDetails.append(RoomUnavailableWrapper);

            let RoomUnavailableHeaderText = document.createElement("p");
            RoomUnavailableHeaderText.className = "RoomUnavailableHeaderText RoomUnavailableText InterBoldTextFont";
            RoomUnavailableHeaderText.innerHTML = window["WeAreSorryTxt" + window.CurrentCountryID];
            RoomUnavailableWrapper.append(RoomUnavailableHeaderText);

            let RoomUnavailableHeaderMessage = document.createElement("p");
            RoomUnavailableHeaderMessage.className = "RoomUnavailableHeaderMessage RoomUnavailableText InterBoldTextFont";
            RoomUnavailableHeaderMessage.innerHTML = window["RoomUnavailableFullyBookedTxt" + window.CurrentCountryID];
            RoomUnavailableWrapper.append(RoomUnavailableHeaderMessage);

            let GotoHotelButton = document.createElement("button");
            GotoHotelButton.className = "BasicTextButton BasicBoxShadow OrangeButton LoadMoreButton Selectable";
            GotoHotelButton.innerHTML = window["ChangeDateSettingsTxt" + window.CurrentCountryID];
            GotoHotelButton.onclick = function()
            {
                window.CurrentSelectedRoomID = RoomData[i].id_hotel_room;
                const HotelDetailsRightPanel = document.getElementById("HotelDetailsInformationRightSection");
                const RightPanelCSSInfo = window.getComputedStyle(HotelDetailsRightPanel);

                if(RightPanelCSSInfo.display != "none")
                window.ScrollToWindow(HotelDetailsRightPanel);
            
                window.CalculateTotalHotelDetails(true);
            }
            RoomUnavailableWrapper.append(GotoHotelButton);

            if(ThisRoomIsAvailable == false || RoomData[i].status_available == "No")
                RoomUnavailableBlockerHotelDetails.style.display = "";
        }
    }
    else
    {
        RoomHotelContainer.style.display = "none";
        NoRoomAvailableContainer.style.display = "";
    }
}

function GetPingDataInformation(ThisRoomPingsData, DiscountPercentageRoomText, OriginalPriceText, StartPriceText)
{
    let OriginalPrice = "--";
    let PriceAfterDiscount = "--";
    let DiscountPerc = "";
    let ThisRoomIsAvailable = false;

    //!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
    let RoomPingData = ThisRoomPingsData[0].dates;
    //console.log(RoomPingData);

    if(RoomPingData.length > 0)
    {
        OriginalPrice = RoomPingData[0].price;
        PriceAfterDiscount = RoomPingData[0].price_after_disc;
        DiscountPerc = RoomPingData[0].disc_now.total_discount;
        ThisRoomIsAvailable = true;

        for(let j = 0; j < RoomPingData.length; j++) //---------------------- GET ALL REQUIRED ROOM DATA
        {
            if(OriginalPrice == null || parseInt(OriginalPrice) < parseInt(RoomPingData[j].price))
            {
                if(RoomPingData[j].price != null)
                OriginalPrice = RoomPingData[j].price;
            }

            if(PriceAfterDiscount == null || parseInt(PriceAfterDiscount) > parseInt(RoomPingData[j].price_after_disc))
            {
                if(RoomPingData[j].price_after_disc != null)
                PriceAfterDiscount = RoomPingData[j].price_after_disc;
            }

            if(RoomPingData[j].status_available == "No")
            {
                ThisRoomIsAvailable = false;
            }
        }
    }

    if(DiscountPerc != null &&  DiscountPerc != "" && DiscountPerc != 0)
    {
        DiscountPercentageRoomText.innerHTML = DiscountPerc + "%";
    }
    if(OriginalPrice == 0)
    {
        OriginalPriceText.style.opacity = 0;
    }
    OriginalPriceText.innerHTML = OriginalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

    StartPriceText.innerHTML = window["StartFromTxt" + window.CurrentCountryID] + " Rp " + PriceAfterDiscount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + window["PerMalamTxt" + window.CurrentCountryID];

    return ThisRoomIsAvailable;
}

// ======================================= NEARBY MAP =======================================

function InstantiateNearbyMap(EmbedMapUrl, EmbedMapContainer)
{
    if(isValidGoogleMapsEmbedURL(EmbedMapUrl) == true)
    {
        EmbedMapContainer.innerHTML = "";
        
        let LoadingMapEmbedded = document.createElement("div");
        LoadingMapEmbedded.className = "loading_grey ImageFullCover";
        EmbedMapContainer.append(LoadingMapEmbedded);

        let LocationMapIframe = document.createElement("iframe");
        LocationMapIframe.className = "LocationMap";
        LocationMapIframe.style.allowfullscreen = "";
        LocationMapIframe.style.loading = "lazy";
        LocationMapIframe.style.referrerpolicy = "no-referrer-when-downgrade";
        LocationMapIframe.src = EmbedMapUrl;
        LocationMapIframe.onload = function(event)
        {
            OnMapSuccessLoaded(EmbedMapContainer, LoadingMapEmbedded, EmbedMapUrl);
        }
        EmbedMapContainer.append(LocationMapIframe);
    }
    else
    {
        document.getElementById("EmbedUrlMainContainer").remove();
    }
}

function isValidGoogleMapsEmbedURL(url)
{
    try {
      // Using URL API
      const parsedURL = new URL(url);
      
      // Check if the hostname matches the expected pattern
      if (!/^(www\.)?google(\.[a-z]{2,3}){1,2}$/.test(parsedURL.hostname)) {
        return false;
      }
  
      // Check if the path starts with /maps/embed
       if (!parsedURL.pathname.startsWith('/maps/embed')) {
        return false;
      }
  
      return true;
    } catch (error) {
      return false; // Invalid URL format
    }
}

function OnMapSuccessLoaded(EmbedMapContainer, LoadingMapEmbedded, EmbedMapUrl)
{
    LoadingMapEmbedded.remove();

    let ExpandButton = document.createElement("button");
    ExpandButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop ExpandMapButton Selectable";
    ExpandButton.onclick = function(event)
    {
        OpenMapInFullScreen(EmbedMapUrl);
    }
    EmbedMapContainer.append(ExpandButton);


    let ExpandButtonIcon = document.createElement("img");
    ExpandButtonIcon.className = "ExpandButtonIcon";
    ExpandButtonIcon.src = "/Assets/images/ButtonIcon/expand-white.svg";
    ExpandButton.append(ExpandButtonIcon);

    let ExpandButtonText = document.createElement("p");
    ExpandButtonText.className = "InterMediumTextFont";
    ExpandButtonText.innerHTML = window["ExpandBtnTxt" + window.CurrentCountryID];
    ExpandButton.append(ExpandButtonText);
}

//============================================ SHOW MAP IN FULL SCREEN ================================================

function OpenMapInFullScreen(EmbedMapUrl)
{
    let ShowFullImageBlocker = document.createElement('div');
    ShowFullImageBlocker.className = "BasicBlackBlocker";
    document.getElementsByTagName("body")[0].append(ShowFullImageBlocker);

    let LocationMapFullScreen = document.createElement('iframe');
    LocationMapFullScreen.className = "LocationMapFullScreen";
    LocationMapFullScreen.src = EmbedMapUrl;
    LocationMapFullScreen.allowFullscreen = "";
    LocationMapFullScreen.loading = "lazy";
    LocationMapFullScreen.referrerPolicy = "no-referrer-when-downgrade";
    ShowFullImageBlocker.append(LocationMapFullScreen);


    let CloseButton = document.createElement('img');
    CloseButton.className = "CloseButton Selectable";
    CloseButton.src = "/Assets/images/ButtonIcon/x-close.svg";
    CloseButton.onclick = function()
    {
        window.ClosePanelAnimate(null, ShowFullImageBlocker, null)
    }
    ShowFullImageBlocker.append(CloseButton);

    //------------------------------------ ANIMATE EASE IN --------------------------------------

    window.OpenPanelAnimate(null, ShowFullImageBlocker);
}

// =============================================== LOAD AND CALCULATE HOTEL DETAILS ================================


window.CalculateTotalHotelDetails = function(allowreload)
{
    if(window.CurrentSelectedRoomID == null && window.HotelDetails.rooms.length > 0)
    {
        window.CurrentSelectedRoomID = window.HotelDetails.rooms[0].id_hotel_room;
    }
    
    // Change Room Button To Selected -------------------------------
    let SelectRoomButton = document.querySelectorAll('.SelectRoomButton');
    SelectRoomButton.forEach(RoomButton =>
    {
        RoomButton.className = "BasicTextButton BasicBoxShadow OrangeButton SelectRoomButton Selectable NotSelectedHotelDetailsButton";
        RoomButton.innerHTML = window["SelectRoomButtonTxt" + window.CurrentCountryID];
        // RoomButton.style.pointerEvents = "";

        if(RoomButton.id == "SelectRoomButton" + window.CurrentSelectedRoomID)
        {
            RoomButton.className = "BasicTextButton BasicBoxShadow OrangeButton SelectRoomButton Selectable";
            RoomButton.innerHTML = window["SelectedButtonTxt" + window.CurrentCountryID];
            // RoomButton.style.pointerEvents = "none";
        }
    });

    let WhichBookTypeNowSelected;
    window.HotelDetails.rooms.forEach(thisroomdata =>
    {
        if(window.CurrentSelectedRoomID == thisroomdata.id_hotel_room)
        {
            WhichBookTypeNowSelected = thisroomdata.book_type;
        }
    });

    // Load Room Data ---------------------------------------------
    
    let ThisCheckInYear = window.CheckInNonTopInput.getAttribute("year");
    let ThisCheckInMonth = window.CheckInNonTopInput.getAttribute("month");
    let ThisCheckInDay = window.CheckInNonTopInput.getAttribute("date");
    let ThisCheckInDate = ThisCheckInYear + "-" + ThisCheckInMonth.toString().padStart(2, '0') + "-" + ThisCheckInDay.toString().padStart(2, '0');
    let ThisCheckInDateToDisplay = ThisCheckInDay + " " + window["monthNames" + window.CurrentCountryID][parseInt(ThisCheckInMonth)-1] + " " + ThisCheckInYear;

    let ThisCheckOutYear = window.CheckOutNonTopInput.getAttribute("year");
    let ThisCheckOutMonth = window.CheckOutNonTopInput.getAttribute("month");
    let ThisCheckOutDay = window.CheckOutNonTopInput.getAttribute("date");
    let ThisCheckOutDate = ThisCheckOutYear + "-" + ThisCheckOutMonth.toString().padStart(2, '0') + "-" + ThisCheckOutDay.toString().padStart(2, '0');
    let ThisCheckOutDateToDisplay = ThisCheckOutDay + " " + window["monthNames" + window.CurrentCountryID][parseInt(ThisCheckOutMonth)-1] + " " + ThisCheckOutYear;

    window.CheckInDateNonTop = ThisCheckInDate;
    window.CheckOutDateNonTop = ThisCheckOutDate;


    // Quota Preparation -------------

    window.RoomQuotaNonTop =  parseInt(document.getElementById("RoomQuotaHotelDetailsInput").getAttribute("room-quota"));
    let RoomQuotaTextToDisplay = window.RoomQuotaNonTop + " " + window["RoomTxt" + window.CurrentCountryID];
    if(window.RoomQuotaNonTop > 1)
    {
        RoomQuotaTextToDisplay = window.RoomQuotaNonTop + " " + window["RoomTxtex" + window.CurrentCountryID];
    }

    let HowManyTextNightTextDisplayer = document.getElementById("HowManyNightHotelDetailsInput");

    if(WhichBookTypeNowSelected == "per day")
    {
        RoomQuotaTextToDisplay = window.RoomQuotaNonTop + " " + window["ItemsTxt" + window.CurrentCountryID];
        if(window.RoomQuotaNonTop > 1)
        {
            RoomQuotaTextToDisplay = window.RoomQuotaNonTop + " " + window["ItemsTxtex" + window.CurrentCountryID];
        }

        HowManyTextNightTextDisplayer.style.display = "none";
    }
    else
    {
        HowManyTextNightTextDisplayer.style.display = "";
    }

    // Update All Room Quota Display ------------------------------

    let RoomQuotaTextDisplayNonTop = document.getElementById("RoomQuotaHotelDetailsDisplayText");
    if(RoomQuotaTextDisplayNonTop != null)
    {
        RoomQuotaTextDisplayNonTop.innerHTML = RoomQuotaTextToDisplay;
    }


    let HowManyGuestRoomTextMobileText = document.querySelectorAll(".HowManyGuestRoomTextMobile");
    if(HowManyGuestRoomTextMobileText != null)
    {
        HowManyGuestRoomTextMobileText.forEach(thistext =>
        {
            thistext.innerHTML = RoomQuotaTextToDisplay;
        });
    }

    let MobileCurrentStatusHotelDetailsText = document.querySelectorAll(".MobileCurrentStatusHotelDetailsText");
    let DifferenceBetweenDays = window.GetDateDifferences(window.CheckInDateNonTop, window.CheckOutDateNonTop);
    MobileCurrentStatusHotelDetailsText.forEach(thistext =>
    {
        if(WhichBookTypeNowSelected == "per day")
        {
            thistext.innerHTML = RoomQuotaTextToDisplay;
        }
        else
        {
            thistext.innerHTML = window.NightTextDisplayer(DifferenceBetweenDays) + " • " + RoomQuotaTextToDisplay;
        }
    });


    // If Allow Reload, then Load All Data ---------------------------------
    
    if(allowreload == true)
    {
        let HotelDetailsBlocker = window.InstantiateLoadingBlocker("HotelDetailsBlocker");

        window.LoadAccommodationDetails(HotelDetailsBlocker, ()=>
        {
            StartUpdatingHotelDetails(window.HotelDetails);

            // Drop Down Room Type -------------------------------------------------------------

            document.getElementById("RoomTypeClickDropDown").onclick = function()
            {
                window.InstantiateRoomTypeDropDown(document.getElementById('RoomTypeDetailsContainer'), window.HotelDetails.rooms, 'RoomDetails', 'RoomTypeToggleArrow', ()=> window.CalculateTotalHotelDetails(true), false);
            }

            // ---------------------------------------------------------------------------------
                
            HotelDetailsBlocker.remove();
        }, null)
    }
    else
    {
        StartUpdatingHotelDetails(window.HotelDetails);
    }
}

// ====================== UPDATE RIGHT HOTEL DETAILS ============================================

function StartUpdatingHotelDetails(HotelDetailsLoadedData)
{
    // Animate Right ---------------------------------------

    let RightSectionWrapper = document.getElementById("HotelDetailsInformationRightSection");
    let LeftSectionWrapper = document.getElementById("HotelDetailsInformationLeftSection");

    if(RightSectionWrapper.classList.contains("RightSectionOpen") == false)
    {
        RightSectionWrapper.classList.add('with-transition'); // Enable transition
        RightSectionWrapper.classList.add("RightSectionOpen");

        LeftSectionWrapper.classList.add("RightSectionOpen");

        let propertiesToWatch = new Set(['width','margin-left']);

        RightSectionWrapper.addEventListener('transitionend', function handler(e)
        {
            propertiesToWatch.delete(e.propertyName);

            if (propertiesToWatch.size === 0)
            {
                RightSectionWrapper.classList.remove('with-transition');
                RightSectionWrapper.removeEventListener('transitionend', handler);
            }
        });
    }


    // Ger Room Data -------------------------------------

    let RoomHotelPanels = document.querySelectorAll('.RoomHotelPanel');

    let RoomDatas = HotelDetailsLoadedData.rooms;

    for(let i = 0; i < RoomDatas.length; i++)
    {
        if(parseInt(RoomDatas[i].id_hotel_room) == parseInt(window.CurrentSelectedRoomID)) // Get Which Room Data ------------------
        {
            window.ThisRoomData = RoomDatas[i];
        }

        for(let j = 0; j < RoomHotelPanels.length; j++) // Check Which Room Available Based on Current Input ------------------------
        {
            if(parseInt(RoomDatas[i].id_hotel_room) == RoomHotelPanels[j].getAttribute("room-id"))
            {
                let WhichPingData = RoomDatas[i].room_pings[0].dates;
                let MaxAvailableRoom = WhichPingData[0].room_available;

                //console.log("WhichPingData[0]", WhichPingData[0]);

                for(let x = 0; x < WhichPingData.length; x++) // Get the Lowest Available Room --------------------------
                {
                    if(MaxAvailableRoom < WhichPingData[x].room_available)
                    {
                        MaxAvailableRoom = WhichPingData[x].room_available;
                    }
                }

                let InvalidBlocker = RoomHotelPanels[j].querySelectorAll('.RoomUnavailableBlockerHotelDetails')[0];
                
                if(window.RoomQuotaNonTop > MaxAvailableRoom)
                {
                    InvalidBlocker.style.display = "";
                }
                else
                {
                    InvalidBlocker.style.display = "none";
                }
            }
        }
    }


    // ----------------------------- ROOM TYPE --------------------------------

    //console.log("ThisRoomData", window.ThisRoomData);
    // document.getElementById("RoomTypeHotelDetailsContainer").setAttribute("room-type", ThisRoomData.id_hotel_room);
    document.getElementById("RoomTypeHotelDetailsText").innerHTML = window.ThisRoomData.room_name;

    // ----------------------------- ROOM PRICE & FINAL PRICE --------------------------------

    let ThisRoomPingData = window.ThisRoomData.room_pings[0].dates;

    let RoomTypeUnavailableText = document.getElementById("RoomTypeUnavailableText");
    RoomTypeUnavailableText.style.display = "none";

    let MobileWarningContainer = document.getElementById("MobileWarningContainer");
    let MobileWarningText = document.getElementById("MobileWarningText");
    MobileWarningContainer.style.display = "none";

    let RoomPingDataCheck = window.CheckRoomDataAvaliablePrice(ThisRoomPingData, window.ThisRoomData, false);

    let DPPercentage = HotelDetailsLoadedData.dp_percentage[0].percentage;
    // //console.log("DPPercentage = " + DPPercentage);
    if(DPPercentage == null)
        DPPercentage = 0;


    // APPLY CHANGES =========================

    let HotelDetailsOriginalPriceText = document.getElementById("HotelDetailsOriginalPrice");
    HotelDetailsOriginalPriceText.innerHTML = "---.---";

    let HotelDetailsDiscountedPriceText = document.getElementById("HotelDetailsDiscountedPrice");
    HotelDetailsDiscountedPriceText.innerHTML = "Rp ---.---";

    let DownPaymentPriceText = document.getElementById("DownPaymentPriceText");
    DownPaymentPriceText.innerHTML = "Rp ---.---";

    let FinalPriceEstimationText = document.getElementById("FinalPriceEstimationText");
    FinalPriceEstimationText.innerHTML = "Rp ---.---";
    
    let YouSavedPriceText = document.getElementById("YouSavedPriceText");
    YouSavedPriceText.innerHTML = window["YouSavedTxt" + window.CurrentCountryID] + " &#xB1; Rp ---.---";

    let PingNowButton = document.getElementById("PingNowButton"); // Main Book Button -----------------------------------------------------------------------
    let PingNowButtonHREF = document.getElementById("PingNowButtonHREF");
    PingNowButtonHREF.style.display = "none";
    PingNowButtonHREF.href = "";


    if(MobileBookCheckRoomButtonHotelDetails != null) // Mobile Low Panel Button -----------------------------------------------------------------------
    {
        MobileBookCheckRoomButtonHotelDetails.innerHTML = window["ContinueTxt2" + window.CurrentCountryID];
        MobileBookCheckRoomButtonHotelDetails.className = "BasicTextButton BasicBoxShadow OrangeButton HorizontalButtonExpanded SignInTopDropDownText ButtonInvalid";
        MobileBookCheckRoomButtonHotelDetails.onclick = function(){}
    }


    // Check If It is Per Night or Item --------------------------------------------------------------

    let CheckInHeaderText = document.getElementById("CheckInHeaderText");

    if(window.ThisRoomData.book_type == "per night") // Can Range of Date (Check In and Out)
    {
        window.CheckOutNonTopInput.style.display = "";
        // window.CheckOutNonTopInput.className = "HoverableContentInsideInputField Unselectable";

        if(CheckInHeaderText != null)
            CheckInHeaderText.innerHTML = window["CheckInTxt" + window.CurrentCountryID];
    }
    else if(window.ThisRoomData.book_type == "per day") // Select Date Only one day at a time
    {
        window.CheckOutNonTopInput.style.display = "none";
        // window.CheckOutNonTopInput.className = "HoverableContentInsideInputField DarkenUnselectable ButtonUnselectableOpacity";

        if(CheckInHeaderText != null)
            CheckInHeaderText.innerHTML = window["DateOfVisitTxt" + window.CurrentCountryID];
    }
    // //console.log("window.HotelDetails", ThisRoomPingData);


    if(RoomPingDataCheck.room_status == false)
    {
        RoomTypeUnavailableText.style.display = "";
        RoomTypeUnavailableText.innerHTML = RoomPingDataCheck.unavailable_text;

        MobileWarningContainer.style.display = "";
        MobileWarningText.innerHTML = RoomPingDataCheck.unavailable_text;

        PingNowButton.className = "BasicTextButton BasicBoxShadow ButtonInvalid SignInButtonTop";
        PingNowButton.onclick = function(){};
    }
    else
    {

        let OriginalPriceTotal = parseInt(RoomPingDataCheck.price_basic * window.RoomQuotaNonTop);
        //console.log("Total Original Price = " + RoomPingDataCheck.price_basic + " (Original Price) x " + window.RoomQuotaNonTop + " (Room Quota) = " + OriginalPriceTotal);

        let DiscountedPriceTotal = parseInt(OriginalPriceTotal * HotelDetailsLoadedData.max_disc / 100);
        //console.log("Total Discounted (Before Max) = " + OriginalPriceTotal + " (Total Original Price) x " + HotelDetailsLoadedData.max_disc + "% (Discount) = " + DiscountedPriceTotal);

        if(DiscountedPriceTotal >= HotelDetailsLoadedData.max_disc_until && HotelDetailsLoadedData.max_disc_until != 0 && HotelDetailsLoadedData.max_disc_until != null)
        {
            DiscountedPriceTotal = HotelDetailsLoadedData.max_disc_until;
            //console.log("Total Discounted Updated (Since it Exceed the Max) = " + DiscountedPriceTotal);
        }

        let FinalPriceAfterDiscount = OriginalPriceTotal - DiscountedPriceTotal;
        //console.log("Final Price After Discount = " + OriginalPriceTotal + " (Original Price) - " + DiscountedPriceTotal + " (Discount Price) = " + FinalPriceAfterDiscount);

        let PayAtHotelPercentage = 100 - DPPercentage;
        //console.log("Pay at Hotel Percentage = 100 - " + DPPercentage + " (DP Percentage)");

        let PayAtHotelPrice = OriginalPriceTotal * PayAtHotelPercentage / 100;
        //console.log("Pay at Hotel Price = " + OriginalPriceTotal + " (Original Price) x " + PayAtHotelPercentage + "% (Pay at Hotel %)/ 100");

        let FinalDPPrice = parseInt(FinalPriceAfterDiscount - PayAtHotelPrice);
        //console.log("Total Down Payment = " + FinalPriceAfterDiscount + " (Final Price After Discount) - " + PayAtHotelPrice + " (Pay at Hotel Price)");

        if(FinalDPPrice < 0)
        {
            //console.log("!!!!!!!!!!!!!!!!!!!! Since DP Become Minus Let's Calculate with 2nd Method !!!!!!!!!!!!!!!!!!!!");
            PayAtHotelPrice =  FinalPriceAfterDiscount * PayAtHotelPercentage / 100;
            //console.log("Pay at Hotel Price = " + FinalPriceAfterDiscount + " (Final Price) x " + PayAtHotelPercentage + "% (Pay at Hotel %)/ 100");

            FinalDPPrice = parseInt(FinalPriceAfterDiscount - PayAtHotelPrice);
            //console.log("Total Down Payment = " + FinalPriceAfterDiscount + " (Final Price After Discount) - " + PayAtHotelPrice + " (Pay at Hotel Price)");
        }

        let TotalSaved = OriginalPriceTotal - FinalPriceAfterDiscount;

        HotelDetailsOriginalPriceText.innerHTML = OriginalPriceTotal;
        HotelDetailsDiscountedPriceText.innerHTML = window.ConvertTextToRP(FinalPriceAfterDiscount, 1, false, false);
        DownPaymentPriceText.innerHTML = window.ConvertTextToRP(FinalDPPrice, 1, false, false);
        FinalPriceEstimationText.innerHTML = "&#xB1; " + window.ConvertTextToRP(FinalPriceAfterDiscount, 1, false, false);
        YouSavedPriceText.innerHTML = window["YouSavedTxt" + window.CurrentCountryID] + " &#xB1; " + window.ConvertTextToRP(TotalSaved, 1, false, false);


        let OriginalPriceTextMobileHotelDetails = document.getElementById("OriginalPriceTextMobileHotelDetails");
        let FinalPriceTextMobileHotelDetails = document.getElementById("FinalPriceTextMobileHotelDetails");

        OriginalPriceTextMobileHotelDetails.innerHTML = window.ConvertTextToRP(OriginalPriceTotal, 1, false, false);
        if(window.ThisRoomData.book_type == "per day")
        {
            FinalPriceTextMobileHotelDetails.innerHTML = window.ConvertTextToRP(FinalPriceAfterDiscount, 1, false, false) + "<span class='InterMediumTextFont' style='color:#000000'>" + window["PerItemTxt" + window.CurrentCountryID] + "</span>";
        }
        else
        {
            FinalPriceTextMobileHotelDetails.innerHTML = window.ConvertTextToRP(FinalPriceAfterDiscount, 1, false, false) + "<span class='InterMediumTextFont' style='color:#000000'>" + window["PerMalam2Txt" + window.CurrentCountryID] + "</span>";
        }
        
        let ThisCheckOutData = window.CheckOutDateNonTop;
        // if(window.ThisRoomData != null && window.ThisRoomData.book_type == "per day")
        //     ThisCheckOutData = window.CheckInDateNonTop;


        let UpdateHREFPingNow = "/" + window.CurrentCountryID + "/payment.html?search=" + HotelDetailsLoadedData.province + "&checkin=" + window.CheckInDateNonTop + "&checkout=" + ThisCheckOutData + "&room=" + window.RoomQuotaNonTop + "&id_hotel="+ window.HotelID + "&id_hotel_room=" + window.CurrentSelectedRoomID + "&slug=" + window.HotelSlug;
        //console.log(UpdateHREFPingNow);

        PingNowButtonHREF.style.display = "";
        PingNowButtonHREF.href = UpdateHREFPingNow;

        PingNowButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
        PingNowButton.onclick = function()
        {
            window.location.href = UpdateHREFPingNow;
        }

        if(MobileBookCheckRoomButtonHotelDetails != null)
        {
            MobileBookCheckRoomButtonHotelDetails.className = "BasicTextButton BasicBoxShadow OrangeButton HorizontalButtonExpanded SignInTopDropDownText Selectable";
            MobileBookCheckRoomButtonHotelDetails.onclick = function()
            {
                window.location.href = UpdateHREFPingNow;
            }
        }

    }
}



// ============================================ LOAD ADD ONS ============================================

function LoadAddOnsHotel()
{
    // Prepare Elements --------------------------------------------------------------------------
    let MainContainer = document.getElementById("HotelDetailsAddOnMainContainer");
    let SwiperWrapper = document.getElementById("AddOnsHotelDetailSwiperWrapper");

    MainContainer.style.display = "";
    SwiperWrapper.innerHTML = "";
    
    InstantiateLoadingAddOnHotelDetailsPanel(SwiperWrapper);

    // Load Add Ons --------------------------------------------------------------------------
    let LoadAddOnsURL = "/v2/hotels/" +window.HotelID + "/add-ons";
    // let LoadAddOnsURL = "/v2/rooms/" + window.CurrentSelectedRoomID + "/add-ons";

    let CheckAddOnFormData = new FormData();
    CheckAddOnFormData.append('checkin', window.CheckInDateNonTop);
    CheckAddOnFormData.append('checkout', window.CheckOutDateNonTop);
    CheckAddOnFormData.append('lang', window.CurrentCountryID);

    window.CallApiAxios({
        method: "POST",
        url: LoadAddOnsURL,
        data: CheckAddOnFormData,
    })
    .then(res =>
    {
        let ThisAddOnRoomData = res.data.data;
        //console.log(LoadAddOnsURL);
        //console.log(ThisAddOnRoomData);

        SwiperWrapper.innerHTML = "";
        InstantiateAddOnHotelDetailsPanel(SwiperWrapper, ThisAddOnRoomData);
    })
    .catch(err =>
    {
        //console.error(err);
        MainContainer.style.display = "none";
    });
}

function InstantiateLoadingAddOnHotelDetailsPanel(SwiperWrapper)
{
    for(let i = 0; i < 5; i++)
    {
        let AddOnsPanel = document.createElement("div");
        AddOnsPanel.className = "AddOnsHotelDetailsPanel swiper-slide";
        SwiperWrapper.append(AddOnsPanel);

        let AddOnsContainer = document.createElement("div");
        AddOnsContainer.className = "FaciltyChildrenContainer InputFieldMargin3";
        AddOnsPanel.append(AddOnsContainer);

        let AddOnsNameText = document.createElement("p");
        AddOnsNameText.className = "FacilityNameText InterBoldTextFont loading_grey";
        AddOnsNameText.innerHTML = 'Test Add Ons Name';
        AddOnsNameText.style.color = "transparent";
        AddOnsNameText.style.width = "fit-content";
        AddOnsContainer.append(AddOnsNameText);

        let AddOnsDescriptionContainer = document.createElement("div");
        AddOnsDescriptionContainer.className = "OrangeWarningContainer BasicRoundRadius InputFieldMargin2";
        AddOnsDescriptionContainer.style.display = "flex";
        AddOnsDescriptionContainer.style.flexDirection = "column";
        AddOnsPanel.append(AddOnsDescriptionContainer);

        let AddOnsDescriptionText = document.createElement("p");
        AddOnsDescriptionText.className = "LabelGreyHeaderSmallerText InterRegularTextFont loading_grey InputFieldMargin3";
        AddOnsDescriptionText.style.width = "95%";
        AddOnsDescriptionText.style.color = "transparent";
        AddOnsDescriptionText.innerText = "Test Info For A While";
        AddOnsDescriptionContainer.append(AddOnsDescriptionText);

        let AddOnsDescriptionText2 = document.createElement("p");
        AddOnsDescriptionText2.className = "LabelGreyHeaderSmallerText InterRegularTextFont loading_grey";
        AddOnsDescriptionText2.style.width = "70%";
        AddOnsDescriptionText2.style.color = "transparent";
        AddOnsDescriptionText2.innerText = "This Shorter";
        AddOnsDescriptionContainer.append(AddOnsDescriptionText2);
    }
}

function InstantiateAddOnHotelDetailsPanel(SwiperWrapper, thisaddondata)
{
    for(let i = 0; i < thisaddondata.length; i++)
    {
        let AmountRequiredThisData = thisaddondata[i].is_required;

        let AddOnName = thisaddondata[i]["name_" + window.CurrentCountryID];
        if(AmountRequiredThisData != "0")
            AddOnName = AddOnName + ' <span style="color: #c10000">*</span>';


        let AddOnsPanel = document.createElement("div");
        AddOnsPanel.className = "AddOnsHotelDetailsPanel swiper-slide";
        SwiperWrapper.append(AddOnsPanel);

        let FacilityContainer2 = document.createElement("div");
        FacilityContainer2.className = "FaciltyChildrenContainer InputFieldMargin3";
        AddOnsPanel.append(FacilityContainer2);

        let FacilityIcon2 = document.createElement("img");
        FacilityIcon2.className = "FacilityIcon";
        FacilityIcon2.src = thisaddondata[i].image_link;
        FacilityContainer2.append(FacilityIcon2);

        let FacilityText2 = document.createElement("p");
        FacilityText2.className = "FacilityNameText InterBoldTextFont";
        FacilityText2.innerHTML = AddOnName;
        FacilityContainer2.append(FacilityText2);

        if(thisaddondata[i]["desc_" + window.CurrentCountryID] != null  && thisaddondata[i]["desc_" + window.CurrentCountryID].replace(/ /g, "") != "")
        {
            let WarningContainer2 = document.createElement("div");
            WarningContainer2.className = "OrangeWarningContainer BasicRoundRadius InputFieldMargin2";
            WarningContainer2.style.display = "flex";
            WarningContainer2.style.flexDirection = "row";
            AddOnsPanel.append(WarningContainer2);

            let WarningText2 = document.createElement("p");
            WarningText2.className = "LabelGreyHeaderSmallerText InterRegularTextFont";
            WarningText2.style.color = "#344054";
            WarningText2.innerHTML = thisaddondata[i]["desc_" + window.CurrentCountryID];
            WarningContainer2.append(WarningText2);
        }
    }
}



// ============================================ UBAH KAMAR MOBILE ============================================

window.MobileCheckInToChange = '';
window.MobileCheckOutToChange = '';
window.MobileQuotaToChange = '';
window.MobileRoomTypeIDToChange = 0;
window.MobilePotentialRoomDataToChange = null;

window.InstantiateEditHotelDetailsMobileMenu = function(functiontocallafterclose, isallowchangeroomtype, allowchangedate)
{
    //console.log("window.ThisRoomData", window.ThisRoomData);
    if(window.ThisRoomData == null)
    {
        const RoomHotelContainer = document.getElementById("ChangeRoomContainerHotelDetailsMobile");
        window.ScrollToWindow(RoomHotelContainer);
        window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["PleaseSelectARoomOrItemFirstTxt" + window.CurrentCountryID]);
        return
    }

    // Early Setup -----------------------------------------------------------

    window.CurrentSelectedCheckIn = ''; // CHeck In
    if(window.CheckInDateNonTop != null)
    {
        let MobileCheckInArray = window.CheckInDateNonTop.split("-");
        let ThisCheckInDate = new Date(MobileCheckInArray[0], parseInt(MobileCheckInArray[1] - 1), MobileCheckInArray[2]);

        window.CurrentSelectedCheckIn = ThisCheckInDate;
        window.MobileCheckInToChange = ThisCheckInDate;
    }

    window.CurrentSelectedCheckOut = ''; // Check Out
    if(window.CheckOutDateNonTop != null)
    {
        let MobileCheckOutArray = window.CheckOutDateNonTop.split("-");
        let ThisCheckOutDate = new Date(MobileCheckOutArray[0], parseInt(MobileCheckOutArray[1] - 1), MobileCheckOutArray[2]);

        window.CurrentSelectedCheckOut = ThisCheckOutDate;
        window.MobileCheckOutToChange = ThisCheckOutDate;
    }

    window.ThisCurrentQuotaInput = 0; // Quota 
    if(window.RoomQuotaNonTop != null)
        window.ThisCurrentQuotaInput = window.RoomQuotaNonTop;
    
    window.MobileQuotaToChange = window.ThisCurrentQuotaInput;

    window.CurrentSelectedRoomTypeIDToChange = 0; // Room Type ID 
    if(window.CurrentSelectedRoomID != null)
        window.CurrentSelectedRoomTypeIDToChange = window.CurrentSelectedRoomID;
    
    window.MobileRoomTypeIDToChange = window.CurrentSelectedRoomTypeIDToChange;


    window.MobilePotentialRoomDataToChange = null; // Room Data
    if(window.ThisRoomData != null)
        window.MobilePotentialRoomDataToChange = window.ThisRoomData;


    let ContainerWarningBookingAtLeast = null; // Top Warning -----------
    let WarningBookingAtLeastText = null;

    let RoomExperienceValue = null; // Room or Experience Type -----------

    let CheckInValue = null; // Check In Out Value -----------

    let GuestTitle = null; // Guest Or Number of Room ------------------
    let GuestValue = null;
    let RoomWarning = null;

    let RefreshMobileUpdateUI = function()
    {
        if(RoomExperienceValue != null) // Room or Experience Type -----------
        {
            for(let i = 0; i < window.HotelDetails.rooms.length; i++)
            {
                if(window.HotelDetails.rooms[i].id_hotel_room == window.MobileRoomTypeIDToChange)
                {
                    window.MobilePotentialRoomDataToChange = window.HotelDetails.rooms[i];
                    RoomExperienceValue.innerHTML = window.MobilePotentialRoomDataToChange.room_name;
                }
            }
        }

        if(ContainerWarningBookingAtLeast != null)
        {
            if(window.MobilePotentialRoomDataToChange.min_booking_notice_days != null && window.MobilePotentialRoomDataToChange.min_booking_notice_days > 0) // Top Warning
            {
                ContainerWarningBookingAtLeast.style.display = "";
                WarningBookingAtLeastText.innerHTML = window.MinRangeTextLeft(window.MobilePotentialRoomDataToChange.min_booking_notice_days);
            }
            else
            {
                ContainerWarningBookingAtLeast.style.display = "none";
            }
        }
        
        if(CheckInValue != null)  // Check In Out Value -----------
        {
            let CheckInDateDisplay = "-- ---- ----";
            if(window.MobileCheckInToChange != "")
            {
                CheckInDateDisplay = window.MobileCheckInToChange.getDate() + " " + window["monthNames" + window.CurrentCountryID][window.MobileCheckInToChange.getMonth()] + " " + window.MobileCheckInToChange.getFullYear();
            }
            
            if(window.MobilePotentialRoomDataToChange.book_type == "per night")
            {
                let CheckOutDateDisplay = "-- ---- ----";

                if(window.MobileCheckOutToChange != "")
                {
                    CheckOutDateDisplay = window.MobileCheckOutToChange.getDate() + " " + window["monthNames" + window.CurrentCountryID][window.MobileCheckOutToChange.getMonth()] + " " + window.MobileCheckOutToChange.getFullYear();
                }

                CheckInValue.innerHTML = CheckInDateDisplay + " - " + CheckOutDateDisplay;
            }
            else
            {
                CheckInValue.innerHTML = CheckInDateDisplay;
            }
        }

        if(GuestTitle != null && GuestValue != null && RoomWarning != null)
        {
            let RoomQuotaTextToDisplay = window.MobileQuotaToChange + " " + window["RoomTxt" + window.CurrentCountryID];
            if(window.MobileQuotaToChange > 1)
            {
                RoomQuotaTextToDisplay = window.MobileQuotaToChange + " " + window["RoomTxtex" + window.CurrentCountryID];
            }

            if(window.MobilePotentialRoomDataToChange.book_type == "per day") // Select Date Only one day at a time
            {
                GuestTitle.innerHTML = window["ItemAmountTxt" + window.CurrentCountryID];

                RoomQuotaTextToDisplay = window.MobileQuotaToChange + " " + window["ItemsTxt" + window.CurrentCountryID];
                if(window.MobileQuotaToChange > 1)
                    RoomQuotaTextToDisplay = window.MobileQuotaToChange + " " + window["ItemsTxtex" + window.CurrentCountryID];
            }
            else
            {
                GuestTitle.innerHTML = window["RoomAmountTxt" + window.CurrentCountryID];
            }

            GuestValue.innerHTML = RoomQuotaTextToDisplay;
        }
    };
    
    // Instantiate -----------------------------------------------------------

    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    /* ==================== PANEL ==================== */

    let FlexFullDisplayPanel = document.createElement("div");
    FlexFullDisplayPanel.className = "FlexFullDisplayPanel FlexPanelOnlyForMobile";
    FlexFullDisplayPanel.style.padding = "0px";
    BasicBlackBlocker.append(FlexFullDisplayPanel);


    /* ==================== HEADER ==================== */

    let HeaderContainer = document.createElement("div");
    HeaderContainer.className = "TopBottomHeaderButtonPaddingContainer BasicBoxShadow";
    FlexFullDisplayPanel.append(HeaderContainer);

    let HeaderRow = document.createElement("div");
    HeaderRow.style.flex = "1 1 0%";
    HeaderRow.style.height = "fit-content";
    HeaderRow.style.display = "flex";
    HeaderRow.style.position = "relative";
    HeaderContainer.append(HeaderRow);

    let HeaderTitle = document.createElement("p");
    HeaderTitle.className = "PaymentPriceFinalToPay MarginTextUpDown InterBoldTextFont";
    HeaderTitle.style.margin = "auto 0";
    HeaderTitle.innerHTML = window["UpdateBookingDetailsTxt" + window.CurrentCountryID];
    HeaderRow.append(HeaderTitle);

    let CloseButton = document.createElement("img");
    CloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    CloseButton.className = "CloseButtonInsidePanel Selectable2";
    CloseButton.style.position = "absolute";
    CloseButton.style.right = "0px";
    CloseButton.style.top = "50%";
    CloseButton.style.transform = "translateY(-50%)";
    CloseButton.onclick = function()
    {
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);
    }
    HeaderRow.append(CloseButton);

    
    /* ==================== CONTENT ==================== */
    let ContentWrapper = document.createElement("div");
    ContentWrapper.className = "FlexContainerBaseAnimate TopBottomHeaderButtonPaddingContainer PingExprezyViewMoreContainer";
    ContentWrapper.style.width = "90vw";
    FlexFullDisplayPanel.append(ContentWrapper);


    /* ==================== BOOKING NOTICE DAYS ==================== */

    ContainerWarningBookingAtLeast = document.createElement("div"); // Top Warning Text ------------------------------------
    ContainerWarningBookingAtLeast.className = "ContainerWithIconAndText BasicRoundRadius InputFieldMargin3";
    ContainerWarningBookingAtLeast.style.backgroundColor = "#FFFAEB";
    ContainerWarningBookingAtLeast.flexDirection = "column";
    ContainerWarningBookingAtLeast.style.display = "none";
    ContentWrapper.append(ContainerWarningBookingAtLeast);

    let WarningBookingHeaderText = document.createElement("p");
    WarningBookingHeaderText.className = "LabelGreyHeaderSmallerText2 InterBoldTextFont InputFieldMargin3";
    WarningBookingHeaderText.innerHTML = window["KebijakanReservasiTxt" + window.CurrentCountryID];
    ContainerWarningBookingAtLeast.append(WarningBookingHeaderText);

    WarningBookingAtLeastText = document.createElement("p"); 
    WarningBookingAtLeastText.className = "LabelGreyHeaderSmallerText2 InterMediumTextFont";
    WarningBookingAtLeastText.style.margin = "auto 0";
    WarningBookingAtLeastText.style.color = "#344054";
    ContainerWarningBookingAtLeast.append(WarningBookingAtLeastText);

    /* ==================== ROOM OR EXPERIENCE TYPE ==================== */

    if(window.HotelDetails?.rooms?.length > 0 && isallowchangeroomtype == true)
    {
        let RoomExperienceWrapper = document.createElement("div");
        RoomExperienceWrapper.className = "HotelDetailsHotelInformationMarginWrapper2";
        ContentWrapper.append(RoomExperienceWrapper);

        let RoomExperienceHover = document.createElement("div");
        RoomExperienceHover.className = "HoverableContentInsideInputField Unselectable";
        RoomExperienceWrapper.append(RoomExperienceHover);

        let RoomExperienceField = document.createElement("div");
        RoomExperienceField.className = "SearchTopNonIndexSection BasicInputFieldContainer Selectable3";
        RoomExperienceField.style.backgroundColor = "rgba(252, 252, 255, 0.8)";
        RoomExperienceHover.append(RoomExperienceField);

        let RoomExperienceIcon = document.createElement("img");
        RoomExperienceIcon.className = "BasicIconInsideInput";
        RoomExperienceIcon.src = "/Assets/images/ButtonIcon/room-icon.svg";
        RoomExperienceIcon.style.marginLeft = "0";
        RoomExperienceField.append(RoomExperienceIcon);

        let RoomExperienceTextWrapper = document.createElement("div");
        RoomExperienceTextWrapper.className = "SearchInputFieldTopBottomTextWrapper";
        RoomExperienceField.append(RoomExperienceTextWrapper);

        let RoomExperienceTitle = document.createElement("p");
        RoomExperienceTitle.className = "BasicInputTextTop InterBoldTextFont";
        RoomExperienceTitle.style.marginTop = "0";
        RoomExperienceTitle.innerHTML = window["RoomOrItemTypeTxt" + window.CurrentCountryID];
        RoomExperienceTextWrapper.append(RoomExperienceTitle);

        RoomExperienceValue = document.createElement("p");
        RoomExperienceValue.className = "BasicInputTextBottom InterRegularTextFont";
        RoomExperienceValue.style.color = "#667085";
        RoomExperienceValue.innerHTML = "------ ------";
        RoomExperienceTextWrapper.append(RoomExperienceValue);

        let RoomExperienceChevron = document.createElement("img");
        RoomExperienceChevron.src = "/Assets/images/ButtonIcon/chevron.svg";
        RoomExperienceChevron.className = "BasicInputFieldChevronIconSearch ToggleArrow Selectable2";
        RoomExperienceChevron.style.rotate = "-90deg";
        RoomExperienceField.append(RoomExperienceChevron);

        RoomExperienceField.onclick = function()
        {
            window.InstantiateRoomTypePanel(()=>
            {
                window.MobileRoomTypeIDToChange = window.CurrentSelectedRoomTypeIDToChange;
                RefreshMobileUpdateUI();

            }, false);
        }


        // for(let i = 0; i < window.HotelDetails.rooms.length; i++)
        // {
        //     if(window.HotelDetails.rooms[i].id_hotel_room == window.CurrentSelectedRoomID)
        //     {
        //         window.MobileRoomTypeIDToChange = window.CurrentSelectedRoomID;
        //         RoomExperienceValue.innerHTML = window.HotelDetails.rooms[i].room_name;
        //     }
        // }
    }


    /* ==================== CHECK IN / OUT ==================== */

    if(allowchangedate == true)
    {
        let CheckInWrapper = document.createElement("div");
        CheckInWrapper.className = "HotelDetailsHotelInformationMarginWrapper2";
        ContentWrapper.append(CheckInWrapper);

        let CheckInHover = document.createElement("div");
        CheckInHover.className = "HoverableContentInsideInputField Unselectable";
        CheckInWrapper.append(CheckInHover);

        let CheckInField = document.createElement("div");
        CheckInField.className = "SearchTopNonIndexSection BasicInputFieldContainer Selectable3";
        CheckInField.style.backgroundColor = "rgba(252, 252, 255, 0.8)";
        CheckInHover.append(CheckInField);

        let CalendarIcon = document.createElement("img");
        CalendarIcon.className = "BasicIconInsideInput";
        CalendarIcon.src = "/Assets/images/ButtonIcon/calendar-black.svg";
        CalendarIcon.style.marginLeft = "0";
        CheckInField.append(CalendarIcon);

        let CheckInTextWrapper = document.createElement("div");
        CheckInTextWrapper.className = "SearchInputFieldTopBottomTextWrapper";
        CheckInField.append(CheckInTextWrapper);

        let CheckInTitle = document.createElement("p");
        CheckInTitle.className = "BasicInputTextTop InterBoldTextFont";
        CheckInTitle.style.marginTop = "0";
        CheckInTitle.innerHTML = window["CheckInNOutTxt" + window.CurrentCountryID];
        CheckInTextWrapper.append(CheckInTitle);

        CheckInValue = document.createElement("p");
        CheckInValue.className = "BasicInputTextBottom InterRegularTextFont";
        CheckInValue.style.color = "#667085";
        CheckInValue.innerHTML = "-- ---- ---- -  -- ---- ----";
        CheckInTextWrapper.append(CheckInValue);

        let CheckInChevron = document.createElement("img");
        CheckInChevron.src = "/Assets/images/ButtonIcon/chevron.svg";
        CheckInChevron.className = "BasicInputFieldChevronIconSearch ToggleArrow Selectable2";
        CheckInChevron.style.rotate = "-90deg";
        CheckInField.append(CheckInChevron);

        CheckInField.onclick = function()
        {
            window.InstantiateCheckInOutMobilePanel(()=>
            {
                if(window.MobilePotentialRoomDataToChange.book_type == "per day")
                {
                    window.CurrentSelectedCheckIn = new Date(window.CurrentSelectedYearEdit, parseInt(window.CurrentSelectedMonthEdit) - 1, window.CurrentSelectedDayEdit);
                    window.CurrentSelectedCheckOut = new Date(window.CurrentSelectedYearEdit, parseInt(window.CurrentSelectedMonthEdit) - 1, window.CurrentSelectedDayEdit);
                    window.CurrentSelectedCheckOut.setDate(window.CurrentSelectedCheckOut.getDate() + 1);
                }

                window.MobileCheckInToChange = window.CurrentSelectedCheckIn;
                window.MobileCheckOutToChange = window.CurrentSelectedCheckOut;

                //console.log("window.MobileCheckInToChange", window.MobileCheckInToChange);
                //console.log("window.MobileCheckOutToChange", window.MobileCheckOutToChange);

                RefreshMobileUpdateUI();
                // let UpdateCheckInDateToDisplay = "-- ---- ----";

                // if(window.MobileCheckInToChange != "")
                // {
                //     UpdateCheckInDateToDisplay = window.MobileCheckInToChange.getDate() + " " + window["monthNames" + window.CurrentCountryID][window.MobileCheckInToChange.getMonth()] + " " + window.MobileCheckInToChange.getFullYear();
                // }
                
                // if(window.MobilePotentialRoomDataToChange.book_type == "per night")
                // {
                //     let UpdateCheckOutDateToDisplay = "-- ---- ----";

                //     if(window.MobileCheckOutToChange != "")
                //     {
                //         UpdateCheckOutDateToDisplay = window.MobileCheckOutToChange.getDate() + " " + window["monthNames" + window.CurrentCountryID][window.MobileCheckOutToChange.getMonth()] + " " + window.CurrentSelectedCheckOut.getFullYear();
                //     }

                //     CheckInValue.innerHTML = UpdateCheckInDateToDisplay + " - " + UpdateCheckOutDateToDisplay;
                // }
                // else
                // {
                //     CheckInValue.innerHTML = UpdateCheckInDateToDisplay;
                // }
                
            }, false);
        }

    }


    /* ==================== GUEST & ROOM ==================== */
    let GuestWrapper = document.createElement("div");
    GuestWrapper.className = "HotelDetailsHotelInformationMarginWrapper2";
    ContentWrapper.append(GuestWrapper);

    let GuestHover = document.createElement("div");
    GuestHover.className = "HoverableContentInsideInputField Unselectable";
    GuestWrapper.append(GuestHover);

    let GuestField = document.createElement("div");
    GuestField.className = "SearchTopNonIndexSection BasicInputFieldContainer Selectable3";
    GuestField.style.backgroundColor = "rgba(252, 252, 255, 0.8)";
    GuestHover.append(GuestField);

    let GuestIcon = document.createElement("img");
    GuestIcon.className = "BasicIconInsideInput";
    GuestIcon.src = "/Assets/images/ButtonIcon/two-people-black.svg";
    GuestIcon.style.marginLeft = "0";
    GuestField.append(GuestIcon);

    let GuestTextWrapper = document.createElement("div");
    GuestTextWrapper.className = "SearchInputFieldTopBottomTextWrapper";
    GuestField.append(GuestTextWrapper);

    GuestTitle = document.createElement("p");
    GuestTitle.className = "BasicInputTextTop InterBoldTextFont";
    GuestTextWrapper.append(GuestTitle);

    GuestValue = document.createElement("p");
    GuestValue.className = "BasicInputTextBottom InterRegularTextFont";
    GuestValue.style.color = "#667085";
    GuestValue.innerHTML = "- ----";
    GuestTextWrapper.append(GuestValue);

    RoomWarning = document.createElement("p");
    RoomWarning.className = "RoomHotelDescriptionInsidePanel InterRegularTextFont";
    RoomWarning.style.color = "#D92D20";
    RoomWarning.style.display = "none";
    RoomWarning.innerHTML = "Sorry, Room not Available for this date please change room type.";
    GuestTextWrapper.append(RoomWarning);

    let GuestChevron = document.createElement("img");
    GuestChevron.src = "/Assets/images/ButtonIcon/chevron.svg";
    GuestChevron.className = "BasicInputFieldChevronIconSearch ToggleArrow Selectable2";
    GuestChevron.style.rotate = "-90deg";
    GuestField.append(GuestChevron);

    
    GuestField.onclick = function()
    {
        window.InstantiateEditGuestandRoomQuotaMobilePanel(()=>
        {
            window.MobileQuotaToChange = window.ThisCurrentQuotaInput;

            RefreshMobileUpdateUI();

            // let RoomQuotaTextToDisplay = window.MobileQuotaToChange + " " + window["RoomTxt" + window.CurrentCountryID];
            // if(window.MobileQuotaToChange > 1)
            //     RoomQuotaTextToDisplay = window.MobileQuotaToChange + " " + window["RoomTxtex" + window.CurrentCountryID];

            // if(window.MobilePotentialRoomDataToChange.book_type == "per day") // Select Date Only one day at a time
            // {
            //     RoomQuotaTextToDisplay = window.MobileQuotaToChange + " " + window["ItemsTxt" + window.CurrentCountryID];
            //     if(window.MobileQuotaToChange > 1)
            //         RoomQuotaTextToDisplay = window.MobileQuotaToChange + " " + window["ItemsTxtex" + window.CurrentCountryID];
            // }

            // GuestValue.innerHTML = RoomQuotaTextToDisplay;
        }, false);
    }

    /* ==================== SAVE BUTTON ==================== */
    let SaveWrapper = document.createElement("div");
    SaveWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
    SaveWrapper.style.marginBottom = "0";
    ContentWrapper.append(SaveWrapper);

    let SaveButton = document.createElement("button");
    SaveButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
    SaveButton.style.margin = "0";
    SaveButton.style.width = "100%";
    SaveButton.onclick = function()
    {
        //console.log("Save Ubah Change Mobile");
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);

        if(functiontocallafterclose != null)
            functiontocallafterclose();
    }
    SaveWrapper.append(SaveButton);

    let SaveText = document.createElement("p");
    SaveText.className = "LabelGreyHeaderText";
    SaveText.style.cssText = "color:white; margin:auto;";
    SaveText.innerHTML = window["SavedButtonTxt" + window.CurrentCountryID];
    SaveButton.append(SaveText);


    // UPDATE FUNCTION ==============================================


    //------------------------------------ ANIMATE EASE IN --------------------------------------

    RefreshMobileUpdateUI();

    window.OpenPanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker);
}

// ------------------------------------------ Check In Out ------------------------------------------

window.InstantiateCheckInOutMobilePanel = function(functiontocallwhenclose, isdirect)
{
    if(window.ThisRoomData == null || (isdirect == false && window.MobilePotentialRoomDataToChange == null))
    {
        const RoomHotelContainer = document.getElementById("ChangeRoomContainerHotelDetailsMobile");
        window.ScrollToWindow(RoomHotelContainer);
        window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["PleaseSelectARoomOrItemFirstTxt" + window.CurrentCountryID]);
        return
    }

    // Early Setup -----------------------------------------------------------

    window.CurrentSelectedCheckIn = '';
    window.CurrentSelectedCheckOut = '';
    
    if(isdirect == false && (window.MobileCheckInToChange != "" && window.MobileCheckOutToChange != "")) // If This Is Not Direct Insantiate -----------------
    {
        window.CurrentSelectedCheckIn = window.MobileCheckInToChange;
        window.CurrentSelectedCheckOut = window.MobileCheckOutToChange;

        //console.log("window.CurrentSelectedCheckIn", window.CurrentSelectedCheckIn);
    }
    else // If This is Direct Instantiate or Not Direct But No Previous Setup ------------------------
    {
        if(window.CheckInDateNonTop != null)
        {
            let MobileCheckInArray = window.CheckInDateNonTop.split("-");
            let ThisCheckInDate = new Date(MobileCheckInArray[0], parseInt(MobileCheckInArray[1] - 1), MobileCheckInArray[2]);

            window.CurrentSelectedCheckIn = ThisCheckInDate;
            window.MobileCheckInToChange = ThisCheckInDate;
        }

        if(window.CheckOutDateNonTop != null)
        {
            let MobileCheckOutArray = window.CheckOutDateNonTop.split("-");
            let ThisCheckOutDate = new Date(MobileCheckOutArray[0], parseInt(MobileCheckOutArray[1] - 1), MobileCheckOutArray[2]);
            
            window.CurrentSelectedCheckOut = ThisCheckOutDate;
            window.MobileCheckOutToChange = ThisCheckOutDate;
        }

        //console.log("window.CurrentSelectedCheckIn", window.CurrentSelectedCheckIn);
    }


    window.CurrentSelectedDayEdit = window.CurrentSelectedCheckIn.getDate();
    window.CurrentSelectedMonthEdit = window.CurrentSelectedCheckIn.getMonth()+1;
    window.CurrentSelectedYearEdit = window.CurrentSelectedCheckIn.getFullYear();
    

    // Instantiate -----------------------------------------------------------

    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let FlexContainerWithTopPanel = document.createElement("div");
    FlexContainerWithTopPanel.className = "FlexFullDisplayPanel FlexPanelOnlyForMobile";
    FlexContainerWithTopPanel.style.padding = "0px";
    BasicBlackBlocker.append(FlexContainerWithTopPanel);

    let TopBarContainer = document.createElement("div"); // Top Bar Container ------------------------------------
    TopBarContainer.className = "TopBottomHeaderButtonPaddingContainer BasicBoxShadowMid";
    TopBarContainer.style.flexDirection = "column";
    FlexContainerWithTopPanel.append(TopBarContainer);

    //console.log("window.ThisRoomData", window.ThisRoomData);

    let WhichRoomDataToUsed = window.ThisRoomData;
    if(isdirect == false && window.MobilePotentialRoomDataToChange != null)
        WhichRoomDataToUsed = window.MobilePotentialRoomDataToChange;
        
    if(WhichRoomDataToUsed.min_booking_notice_days != null && WhichRoomDataToUsed.min_booking_notice_days > 0)
    {
        let ContainerWarningBookingAtLeast = document.createElement("div"); // Top Warning Text ------------------------------------
        ContainerWarningBookingAtLeast.className = "ContainerWithIconAndText BasicRoundRadius InputFieldMargin3";
        ContainerWarningBookingAtLeast.style.backgroundColor = "#FFFAEB";
        ContainerWarningBookingAtLeast.flexDirection = "column";
        TopBarContainer.append(ContainerWarningBookingAtLeast);

        let WarningBookingAtLeastText = document.createElement("p"); 
        WarningBookingAtLeastText.className = "LabelGreyHeaderText InterMediumTextFont";
        WarningBookingAtLeastText.style.margin = "auto 0";
        WarningBookingAtLeastText.style.color = "#344054";
        WarningBookingAtLeastText.innerHTML = window.MinRangeTextLeft(WhichRoomDataToUsed.min_booking_notice_days);
        ContainerWarningBookingAtLeast.append(WarningBookingAtLeastText);
    }

    let TopHeaderContentWrapper = document.createElement("div"); // Main Header Top ------------------------------------
    TopHeaderContentWrapper.className = "ColumnGapExtraLong";
    TopHeaderContentWrapper.style.flex = 1;
    TopHeaderContentWrapper.style.height = "fit-content";
    TopHeaderContentWrapper.style.display = "flex";
    TopHeaderContentWrapper.style.position = "relative";
    TopBarContainer.append(TopHeaderContentWrapper)

    let TopPrevButton = document.createElement("img");
    TopPrevButton.className = "BasicInputFieldChevronIconSearch Selectable2";
    TopPrevButton.style.margin = "auto 0";
    TopPrevButton.style.rotate = "90deg";
    TopPrevButton.src = "/Assets/images/ButtonIcon/chevron.svg";
    TopHeaderContentWrapper.append(TopPrevButton)

    let TopHeaderText = document.createElement("p");
    TopHeaderText.className = "PaymentPriceFinalToPay MarginTextUpDown InterBoldTextFont";
    TopHeaderText.style.margin = "auto 0";
    TopHeaderText.innerHTML = window["ChangeDateSettingsTxt" + window.CurrentCountryID];
    TopHeaderContentWrapper.append(TopHeaderText)

    let TopCloseButton = document.createElement("img");
    TopCloseButton.className = "CloseButtonInsidePanel Selectable2";
    TopCloseButton.style.position = "absolute";
    TopCloseButton.style.right = "0";
    TopCloseButton.style.top = "50%";
    TopCloseButton.style.transform = "translateY(-50%)";
    TopCloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    TopHeaderContentWrapper.append(TopCloseButton)
    


    let MobileCalendarSwiperContainer = document.createElement("div"); // Date Container ------------------------------------
    MobileCalendarSwiperContainer.className = "MobileCalendarSwiperContainer BasicGradientTopBottomMask";
    FlexContainerWithTopPanel.append(MobileCalendarSwiperContainer);

    let MobileCalendarSwiper = document.createElement("div");
    MobileCalendarSwiper.className = "swiper MobileCalendarSwiper";
    MobileCalendarSwiperContainer.append(MobileCalendarSwiper);

    let MobileCalendarSwiperWrapper = document.createElement("div");
    MobileCalendarSwiperWrapper.className = "swiper-wrapper";
    MobileCalendarSwiper.append(MobileCalendarSwiperWrapper);

    
    let BottomMainContainer = document.createElement("div"); // Date Bottom Check In Out Button ------------------------------------
    BottomMainContainer.className = "TopBottomHeaderButtonPaddingContainer BasicBoxShadowUp RowGapBasic2";
    BottomMainContainer.style.flexDirection = "column";
    FlexContainerWithTopPanel.append(BottomMainContainer);

    let BottomCheckInOutWrapper = document.createElement("div"); //Check In Out ---------------
    BottomCheckInOutWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
    BottomCheckInOutWrapper.style.flex = 1;
    BottomCheckInOutWrapper.style.height = "fit-content";
    BottomCheckInOutWrapper.style.display = "flex";
    BottomCheckInOutWrapper.style.position = "relative"
    BottomMainContainer.append(BottomCheckInOutWrapper);

    let CheckInWrapper = document.createElement("div"); // Check In
    BottomCheckInOutWrapper.append(CheckInWrapper);

    let CheckInHeaderText = document.createElement("p");
    CheckInHeaderText.className = "BasicInputTextTop InterBoldTextFont";
    CheckInHeaderText.innerHTML = window["CheckInTxt" + window.CurrentCountryID];
    CheckInWrapper.append(CheckInHeaderText);

    let CheckInDateText = document.createElement("p");
    CheckInDateText.className = "RoomHotelNameInsidePanel InterMediumTextFont";
    CheckInDateText.style.marginBottom = "0";
    CheckInDateText.style.color = "#2494D9";
    CheckInDateText.innerHTML = "-- --- ----";
    CheckInWrapper.append(CheckInDateText);

    
    let HowManyNightsAndLineWrapper = document.createElement("div"); // How Many Nights
    HowManyNightsAndLineWrapper.className = "BluDotWrapper TextToDisplayAfterCalc RowGapBasic";
    HowManyNightsAndLineWrapper.style.width = "auto";
    HowManyNightsAndLineWrapper.style.flex = 1;
    HowManyNightsAndLineWrapper.style.display = "flex";
    HowManyNightsAndLineWrapper.style.flexDirection = "column";
    BottomCheckInOutWrapper.append(HowManyNightsAndLineWrapper);

    let BlueNightDotLine = document.createElement("div");
    BlueNightDotLine.className = "BlueNightDotLine";
    BlueNightDotLine.style.width = "100%";
    HowManyNightsAndLineWrapper.append(BlueNightDotLine);

    let HowManyNightsText = document.createElement("p");
    HowManyNightsText.className = "BasicInputTextTop InterRegularTextFont HowManyNightText";
    HowManyNightsText.style.margin = "0 auto";
    HowManyNightsText.innerHTML = "-- Night";
    HowManyNightsAndLineWrapper.append(HowManyNightsText);
    
    let CheckOutWrapper = document.createElement("div"); // Check Out
    BottomCheckInOutWrapper.append(CheckOutWrapper);

    let CheckOutHeaderText = document.createElement("p");
    CheckOutHeaderText.className = "BasicInputTextTop InterBoldTextFont";
    CheckOutHeaderText.innerHTML = window["CheckOutTxt" + window.CurrentCountryID];
    CheckOutWrapper.append(CheckOutHeaderText);

    let CheckOutDateText = document.createElement("p");
    CheckOutDateText.className = "RoomHotelNameInsidePanel InterMediumTextFont";
    CheckOutDateText.style.marginBottom = "0";
    CheckOutDateText.style.color = "#D92D20";
    CheckOutDateText.innerHTML = "Select Check-out Date";
    CheckOutWrapper.append(CheckOutDateText);


    if(WhichRoomDataToUsed.book_type == "per day")
    {
        CheckInHeaderText.innerHTML = window["DateOfVisitTxt" + window.CurrentCountryID];
        HowManyNightsAndLineWrapper.style.display = "none";
        CheckOutWrapper.style.display = "none";
    }

    
    let SaveButton = document.createElement("button"); // Save Button ---------------
    SaveButton.className = "ApplyMonthButton BasicRoundRadius ButtonInvalid";
    SaveButton.style.margin = 0;
    SaveButton.style.width = "100%";
    BottomMainContainer.append(SaveButton);

    let SaveButtonText = document.createElement("p");
    SaveButtonText.className = "InterMediumTextFont PaymentPriceFinalToPay ";
    SaveButtonText.innerHTML = window["SavedButtonTxt" + window.CurrentCountryID];
    SaveButtonText.style.margin = "auto";
    SaveButton.append(SaveButtonText);

    let ThisSwiper = new window.Swiper(MobileCalendarSwiper,
    {
        modules: [Mousewheel],
        direction: 'vertical',
        autoHeight: false,
        slidesPerView: 1,
        // spaceBetween: 16,
        mousewheel: true,
        grabCursor: true,
    });

    let ClosePanelFunction = function(isjustclose)
    {
        if(functiontocallwhenclose != null && isjustclose == false) // If Just Close Then don't call any function assigned
            functiontocallwhenclose();
        
        window.ClosePanelAnimate(FlexContainerWithTopPanel, BasicBlackBlocker, null);
    }

    let CloseWithoutSavingFunction = function()
    {
        // let CheckInArrayReset = window.CheckInDateNonTop.split("-"); // Reset Again Since it Closed Not Saved -------------------
        // window.CurrentSelectedCheckIn = new Date(CheckInArrayReset[0], parseInt(CheckInArrayReset[1] - 1), CheckInArrayReset[2]);
        // let CheckOutArrayReset = window.CheckOutDateNonTop.split("-");
        // window.CurrentSelectedCheckOut = new Date(CheckOutArrayReset[0], parseInt(CheckOutArrayReset[1] - 1), CheckOutArrayReset[2]);

        window.CurrentSelectedCheckIn = window.MobileCheckInToChange;
        window.CurrentSelectedCheckOut = window.MobileCheckOutToChange;

        window.CurrentSelectedYearEdit = window.CurrentSelectedCheckIn.getFullYear();
        window.CurrentSelectedMonthEdit = window.CurrentSelectedCheckIn.getMonth();
        window.CurrentSelectedDayEdit = window.CurrentSelectedCheckIn.getDate();

        ClosePanelFunction(true);
    }

    TopPrevButton.onclick = function()
    {
        CloseWithoutSavingFunction();
    }

    TopCloseButton.onclick = function()
    {
        CloseWithoutSavingFunction();
    }

    if(isdirect == true)
    {
        TopPrevButton.style.display = "none";
    }
    else
    {
        TopCloseButton.style.display = "none";
    }

    PrepareInstantiateCalendarTableMobile(MobileCalendarSwiperWrapper, CheckInDateText, HowManyNightsText, CheckOutDateText, SaveButton, ()=>ClosePanelFunction(false), ThisSwiper, WhichRoomDataToUsed);

    window.OpenPanelAnimate(FlexContainerWithTopPanel, BasicBlackBlocker);
}

function PrepareInstantiateCalendarTableMobile(MobileCalendarSwiperWrapper, CheckInDateText, HowManyNightsText, CheckOutDateText, SaveButton, ClosePanelFunction, ThisSwiper, WhichRoomDataToUsed)
{
    let TodayDate = window.GetAndConvertCurrentExactDate(false);
    let TodayMonth = TodayDate.getMonth();
    let TodayYear = TodayDate.getFullYear();

    let CheckOutDate = TodayDate;
    if(window.CurrentSelectedCheckOut != '')
    {
        CheckOutDate = window.CurrentSelectedCheckOut;
    }

    let MonthDifference = window.getCalendarMonthDiff(TodayDate, CheckOutDate);

    let isallowmorethanone = true;
    if(WhichRoomDataToUsed.book_type == "per day")
        isallowmorethanone = false;

    let FunctionTocall = function()
    {
        CheckAndUpdateMobileCalendar(CheckInDateText, HowManyNightsText, CheckOutDateText, MobileCalendarSwiperWrapper, SaveButton, ClosePanelFunction, isallowmorethanone, WhichRoomDataToUsed);
    }


    for(let i = 0; i < (MonthDifference + 2); i++)
    {
        let ThisDateToInstantiate = new Date(TodayYear, (TodayMonth + 1 + i), 0);
        InstantiateCalendarTable(ThisDateToInstantiate, MobileCalendarSwiperWrapper, ()=>FunctionTocall(), SaveButton, isallowmorethanone);
    }

    ThisSwiper.on('reachEnd', function ()
    {
        let ThisTableContainerNow = MobileCalendarSwiperWrapper.querySelectorAll(".ThisCalendarTable");
        let ThisDateToInstantiate = new Date(TodayYear, (TodayMonth + 1 + ThisTableContainerNow.length), 0);
        InstantiateCalendarTable(ThisDateToInstantiate, MobileCalendarSwiperWrapper, ()=>FunctionTocall(), SaveButton, isallowmorethanone);
        ThisSwiper.update();
    });
}

function InstantiateCalendarTable(thisdate, Parent, functiontocall, SaveButton, isallowmorethanone)
{
    let ThisDateCellsData = window.PreparePrevCurrentNextMonthCalendarInfo(thisdate.getFullYear(), thisdate.getMonth() + 1, isallowmorethanone);
    

    let CalendarSwiperSlide = document.createElement("div");
    CalendarSwiperSlide.className = "swiper-slide ThisCalendarTable";
    CalendarSwiperSlide.style.height = "auto";
    Parent.append(CalendarSwiperSlide);

    let MonthTitle = document.createElement("p");
    MonthTitle.className = "RoomHotelNameInsidePanel InterBoldTextFont HotelDetailsHotelInformationMarginWrapper";
    MonthTitle.style.textAlign = "center";
    MonthTitle.style.marginLeft = "auto";
    MonthTitle.style.marginRight = "auto";
    MonthTitle.style.width = "fit-content";
    MonthTitle.innerText = window["monthNamesFull" + window.CurrentCountryID][parseInt(thisdate.getMonth())] + " " + thisdate.getFullYear();
    CalendarSwiperSlide.append(MonthTitle);

    let DatePickerTable = document.createElement("div");
    DatePickerTable.className = "DatePickerDateTable";
    DatePickerTable.style.width = "auto";
    CalendarSwiperSlide.append(DatePickerTable);

    let CurrentMonthTable = document.createElement("table");
    CurrentMonthTable.className = "CurrentMonthTable";
    CurrentMonthTable.style.width = "100%";
    CurrentMonthTable.style.borderCollapse = "collapse";
    DatePickerTable.append(CurrentMonthTable);

    let TheadCalendarHeader = document.createElement("thead"); // Table Header -------------
    TheadCalendarHeader.className = "TheadCalendarHeader InterBoldTextFont";
    CurrentMonthTable.append(TheadCalendarHeader);

    let TrCalendarHeader = document.createElement("tr");
    TrCalendarHeader.className = "TrCalendarHeader";
    TheadCalendarHeader.append(TrCalendarHeader);

    for(let i = 0; i < window["weekday" + window.CurrentCountryID].length; i++)
    {
        let HeaderDays = document.createElement("th");
        HeaderDays.className = "HeaderDays";
        
        if(i == 0 || i == 6)
        {
            HeaderDays.className = "HeaderDaysHoliday";
        }
        HeaderDays.innerHTML = window["weekday" + window.CurrentCountryID][i];
        TrCalendarHeader.append(HeaderDays);
    }

    let TBodyCalendar = document.createElement("tbody"); // Table Body -------------
    TBodyCalendar.className = "TBodyCalendar InterRegularTextFont";
    CurrentMonthTable.append(TBodyCalendar);

    let HowManyInstantiated = 0;
    let CalendarBodyToInstantiate = null;
    let ThisDateButtonArray = [];
    let TodayDate = window.GetAndConvertCurrentExactDate(false);
    TodayDate = new Date(TodayDate.getFullYear(), TodayDate.getMonth(), TodayDate.getDate());

    for(let i = 0; i < ThisDateCellsData.length; i++)
    {
        if(HowManyInstantiated == 0)
        {
            CalendarBodyToInstantiate = document.createElement("tr");
            CalendarBodyToInstantiate.className = "TrCalendarBody";
            TBodyCalendar.append(CalendarBodyToInstantiate);
        }
        
        let ThisCalendarButton = document.createElement("td");
        ThisCalendarButton.className = "DateButton Selectable";
        ThisCalendarButton.setAttribute("What-date", ThisDateCellsData[i].date);
        ThisDateButtonArray.push(ThisCalendarButton);

        if(TodayDate.getTime() > ThisDateCellsData[i].datevalue.getTime() || ThisDateCellsData[i].isOtherMonth == true)
        {
            ThisCalendarButton.classList.add("DateButtonInvalid");

            if(ThisDateCellsData[i].isOtherMonth == true)
                ThisCalendarButton.style.opacity = "10%";
        }
        else
        {
            ThisCalendarButton.onclick = function()
            {
                window.ThisCalendarDateButtonSelected(ThisCalendarButton, isallowmorethanone, functiontocall);
            }
        }

        if(TodayDate.getTime() == ThisDateCellsData[i].datevalue.getTime())
        {
            ThisCalendarButton.classList.add("ThisCurrentDate");
        }

        ThisCalendarButton.setAttribute("original-class", ThisCalendarButton.className);

        CalendarBodyToInstantiate.append(ThisCalendarButton);
        
        let ThisCalendarButtonText = document.createElement("p");
        ThisCalendarButtonText.innerHTML = ThisDateCellsData[i].day;
        ThisCalendarButton.append(ThisCalendarButtonText);

        HowManyInstantiated++
        
        if(HowManyInstantiated >= 7)
            HowManyInstantiated = 0;
    }

    let ThisLoading = window.InstantiateLoadingCircle(CalendarSwiperSlide, true);
    window.CheckWhichDateExist(thisdate.getMonth() + 1, thisdate.getFullYear(), ThisDateButtonArray, ThisLoading, isallowmorethanone, SaveButton, functiontocall);

    if(functiontocall != null)
    functiontocall();
}


function CheckAndUpdateMobileCalendar(CheckInDateText, HowManyNightsText, CheckOutDateText, tablecontainer, SaveButton, ClosePanelFunction, isallowmorethanone, WhichRoomDataToUsed)
{
    let IsInputtedFalse = false;


    if(WhichRoomDataToUsed.book_type == "per night")
    {
        if(window.CurrentSelectedCheckIn != '')
        {
            let ThisCheckInDay = window.CurrentSelectedCheckIn.getDate();
            let ThisCheckInMonth = window.CurrentSelectedCheckIn.getMonth();
            let ThisCheckInYear = window.CurrentSelectedCheckIn.getFullYear();

            CheckInDateText.style.color = "#2494D9";
            CheckInDateText.innerHTML = ThisCheckInDay + " " + window["monthNames" + window.CurrentCountryID][ThisCheckInMonth] + " " + ThisCheckInYear;
        }
        else
        {
            CheckInDateText.style.color = "#D92D20";
            CheckInDateText.innerHTML = window["SelectCheckInTxt" + window.CurrentCountryID];

            IsInputtedFalse = true;
        }

        if(window.CurrentSelectedCheckOut != '')
        {
            let ThisCheckOutDay = window.CurrentSelectedCheckOut.getDate();
            let ThisCheckOutMonth = window.CurrentSelectedCheckOut.getMonth();
            let ThisCheckOutYear = window.CurrentSelectedCheckOut.getFullYear();

            CheckOutDateText.style.color = "#2494D9";
            CheckOutDateText.innerHTML = ThisCheckOutDay + " " + window["monthNames" + window.CurrentCountryID][ThisCheckOutMonth] + " " + ThisCheckOutYear;
        }
        else
        {
            CheckOutDateText.style.color = "#D92D20";
            CheckOutDateText.innerHTML = window["SelectCheckOutTxt" + window.CurrentCountryID];

            IsInputtedFalse = true;
        }
    }
    else
    {
        if(window.CurrentSelectedDayEdit != null && window.CurrentSelectedMonthEdit != null && window.CurrentSelectedYearEdit != null)
        {
            CheckInDateText.style.color = "#2494D9";
            CheckInDateText.innerHTML = window.CurrentSelectedDayEdit + " " + window["monthNames" + window.CurrentCountryID][(window.CurrentSelectedMonthEdit-1)] + " " + window.CurrentSelectedYearEdit;
        }
        else
        {
            CheckInDateText.style.color = "#D92D20";
            CheckInDateText.innerHTML = window["SelectDateOfVisitTxt" + window.CurrentCountryID];

            IsInputtedFalse = true;
        }
    }


    let ListOfCalendarButton = tablecontainer.querySelectorAll('.DateButton');

    for(let i = 0; i < ListOfCalendarButton.length; i++)
    {
        ListOfCalendarButton[i].className = ListOfCalendarButton[i].getAttribute("original-class");

        let WhichDateThisButtonArray = ListOfCalendarButton[i].getAttribute("What-date").split("-");
        let WhichDateThisButton = new Date(WhichDateThisButtonArray[0], parseInt(WhichDateThisButtonArray[1] - 1), WhichDateThisButtonArray[2]);
        
        if(isallowmorethanone == true && window.CurrentSelectedCheckIn != '')
        {
            if(WhichDateThisButton.getTime() == window.CurrentSelectedCheckIn.getTime())
            {
                if(window.CurrentSelectedCheckOut == '')
                {
                    ListOfCalendarButton[i].classList.add("CalendarCurrentOnlyThisDate");
                }
                else
                {
                    ListOfCalendarButton[i].classList.add("CalendarCurrentStartDate");
                }
            }
            else if(window.CurrentSelectedCheckOut != '')
            {
                if(WhichDateThisButton.getTime() > window.CurrentSelectedCheckIn.getTime() && WhichDateThisButton.getTime() < window.CurrentSelectedCheckOut.getTime())
                {
                    ListOfCalendarButton[i].classList.add("CalendarCurrentMidDate");
                }
                else if(WhichDateThisButton.getTime() == window.CurrentSelectedCheckOut.getTime())
                {
                    ListOfCalendarButton[i].classList.add("CalendarCurrentEndDate");
                }
            }
        }
        else if(isallowmorethanone == false && (window.CurrentSelectedDayEdit != null && window.CurrentSelectedMonthEdit != null && window.CurrentSelectedYearEdit != null))
        {
            let CurrentSelectedDay = new Date(window.CurrentSelectedYearEdit, window.CurrentSelectedMonthEdit-1, window.CurrentSelectedDayEdit);

            if(CurrentSelectedDay.getTime() == WhichDateThisButton.getTime())
            {
                ListOfCalendarButton[i].classList.add("CalendarCurrentOnlyThisDate");
            }
        }
    }

    window.CheckAndApplyDateButtonAvailability(ListOfCalendarButton, isallowmorethanone, false, SaveButton);


    if(IsInputtedFalse == true)
    {
        HowManyNightsText.innerHTML = "-- " + window["NightTxt" + window.CurrentCountryID];
        SaveButton.className = "BasicTextButton OrangeButton BasicPaddingButton ButtonInvalid";
        SaveButton.onclick = function(){};
    }
    else
    {
        let DifferenceBetweenDays = window.GetDateDifferences(window.CurrentSelectedCheckIn, window.CurrentSelectedCheckOut)
        HowManyNightsText.innerHTML = window.NightTextDisplayer(DifferenceBetweenDays)


        SaveButton.className = "BasicTextButton OrangeButton BasicPaddingButton Selectable";
        SaveButton.onclick = function() 
        {
            //console.log("Save Check In Out Mobile");
            ClosePanelFunction();
        }
    }
}



// Room Quota --------------------------------------------------------------------------------------------------


window.InstantiateEditGuestandRoomQuotaMobilePanel = function(functiontocallwhenclose, isdirect)
{
    //console.log("window.ThisRoomData", window.ThisRoomData);
    if(window.ThisRoomData == null || (isdirect == false && window.MobilePotentialRoomDataToChange == null))
    {
        const RoomHotelContainer = document.getElementById("ChangeRoomContainerHotelDetailsMobile");
        window.ScrollToWindow(RoomHotelContainer);
        window.DisplayWarningPopUp("WarningPanelFailed WarningFailedAlert", window["PleaseSelectARoomOrItemFirstTxt" + window.CurrentCountryID]);
        return
    }

    //console.log("window.MobileQuotaToChange", window.MobileQuotaToChange);

    window.ThisCurrentQuotaInput = 0;
    if(window.RoomQuotaNonTop != null && isdirect == true)
    {
        window.ThisCurrentQuotaInput = parseInt(window.RoomQuotaNonTop);
        window.MobileQuotaToChange = window.ThisCurrentQuotaInput;
    }
    else
    {
        window.ThisCurrentQuotaInput = parseInt(window.MobileQuotaToChange);
    }

    let WhichRoomDataToUsed = window.ThisRoomData;
    if(isdirect == false && window.MobilePotentialRoomDataToChange != null)
        WhichRoomDataToUsed = window.MobilePotentialRoomDataToChange;

    //console.log("window.ThisCurrentQuotaInput", window.ThisCurrentQuotaInput);


    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let FlexFullDisplayPanel = document.createElement("div");
    FlexFullDisplayPanel.className = "FlexFullDisplayPanel FlexPanelOnlyForMobile";
    FlexFullDisplayPanel.style.padding = "0px";
    BasicBlackBlocker.append(FlexFullDisplayPanel);

    /* ==================== HEADER ==================== */
    let HeaderContainer = document.createElement("div");
    HeaderContainer.className = "TopBottomHeaderButtonPaddingContainer BasicBoxShadow";
    FlexFullDisplayPanel.append(HeaderContainer);

    let HeaderRow = document.createElement("div");
    HeaderRow.className = "ColumnGapExtraLong";
    HeaderRow.style.flex = "1 1 0%";
    HeaderRow.style.height = "fit-content";
    HeaderRow.style.display = "flex";
    HeaderRow.style.position = "relative";
    HeaderContainer.append(HeaderRow);

    let BackButton = document.createElement("img");
    BackButton.src = "/Assets/images/ButtonIcon/chevron.svg";
    BackButton.className = "BasicInputFieldChevronIconSearch Selectable2";
    BackButton.style.margin = "auto 0";
    BackButton.style.rotate = "90deg";
    HeaderRow.append(BackButton);

    let HeaderTitle = document.createElement("p");
    HeaderTitle.className = "PaymentPriceFinalToPay MarginTextUpDown InterBoldTextFont";
    HeaderTitle.style.margin = "auto 0";
    HeaderTitle.innerHTML = window["ChangeRoomAmountTxt" + window.CurrentCountryID];
    HeaderRow.append(HeaderTitle);

    let CloseButton = document.createElement("img");
    CloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    CloseButton.className = "CloseButtonInsidePanel Selectable2";
    CloseButton.style.position = "absolute";
    CloseButton.style.right = "0px";
    CloseButton.style.top = "50%";
    CloseButton.style.transform = "translateY(-50%)";
    HeaderRow.append(CloseButton);


    /* ==================== CONTENT ==================== */
    let ContentWrapper = document.createElement("div");
    ContentWrapper.className = "FlexContainerBaseAnimate TopBottomHeaderButtonPaddingContainer PingExprezyViewMoreContainer RowGapBasic2";
    ContentWrapper.style.width = "90vw";
    FlexFullDisplayPanel.append(ContentWrapper);

    let HotelInfoWrapper = document.createElement("div");
    HotelInfoWrapper.className = "HotelDetailsHotelInformationMarginWrapper2";
    ContentWrapper.append(HotelInfoWrapper);

    let HoverContainer = document.createElement("div");
    HoverContainer.className = "HoverableContentInsideInputField";
    HoverContainer.style.flexDirection = "column";
    HotelInfoWrapper.append(HoverContainer);


    /* ==================== JUMLAH KAMAR ==================== */
    let RoomSection = document.createElement("div");
    RoomSection.className = "SearchTopNonIndexSection";
    RoomSection.style.backgroundColor = "transparent";
    RoomSection.setAttribute("room-quota", window.ThisCurrentQuotaInput);
    HoverContainer.append(RoomSection);

    let RoomIcon = document.createElement("img");
    RoomIcon.className = "BasicIconInsideInput";
    RoomIcon.src = "/Assets/images/ButtonIcon/room-icon-2-black.svg";
    RoomIcon.style.marginLeft = "0";
    RoomSection.append(RoomIcon);

    let RoomTextWrapper = document.createElement("div");
    RoomTextWrapper.className = "SearchInputFieldTopBottomTextWrapper";
    RoomTextWrapper.style.flexDirection = "row";
    RoomSection.append(RoomTextWrapper);

    let RoomTitle = document.createElement("p");
    RoomTitle.className = "BasicInputTextTop InterBoldTextFont";
    RoomTitle.style.margin = "auto 0";
    RoomTitle.innerHTML = window["RoomAmountTxt" + window.CurrentCountryID];
    RoomTextWrapper.append(RoomTitle);

    let RoomInputContainer = document.createElement("div");
    RoomInputContainer.className = "RoomButtonAndInputContainer";
    RoomTextWrapper.append(RoomInputContainer);

    let RoomReduce = document.createElement("img");
    RoomReduce.className = "IncreaseReduceRoomButton Selectable2 ButtonUnselectableOpacity";
    RoomReduce.src = "/Assets/images/ButtonIcon/reduce-circle-button.svg";
    RoomInputContainer.append(RoomReduce);

    let RoomInputWrapper = document.createElement("div");
    RoomInputWrapper.className = "SmallPanelDropDownContainer Selectable3";
    RoomInputContainer.append(RoomInputWrapper);

    let RoomInput = document.createElement("input");
    RoomInput.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    RoomInput.type = "number";
    RoomInput.placeholder = "0";
    RoomInput.value = window.ThisCurrentQuotaInput;
    RoomInputWrapper.append(RoomInput);

    let RoomIncrease = document.createElement("img");
    RoomIncrease.className = "IncreaseReduceRoomButton Selectable2";
    RoomIncrease.src = "/Assets/images/ButtonIcon/increase-circle-button.svg";
    RoomInputContainer.append(RoomIncrease);


    if(WhichRoomDataToUsed.book_type == "per day")
    {
        HeaderTitle.innerHTML = window["ChangeItemAmountTxt" + window.CurrentCountryID];
        RoomTitle.innerHTML = window["ItemAmountTxt" + window.CurrentCountryID];
    }

    /* ==================== TAMU DEWASA ==================== */
    // let AdultSection = document.createElement("div");
    // AdultSection.className = "SearchTopNonIndexSection";
    // AdultSection.style.backgroundColor = "transparent";
    // HoverContainer.append(AdultSection);

    // let AdultIcon = document.createElement("img");
    // AdultIcon.className = "BasicIconInsideInput";
    // AdultIcon.src = "/Assets/images/ButtonIcon/two-people-black.svg";
    // AdultIcon.style.marginLeft = "0";
    // AdultSection.append(AdultIcon);

    // let AdultTextWrapper = document.createElement("div");
    // AdultTextWrapper.className = "SearchInputFieldTopBottomTextWrapper";
    // AdultTextWrapper.style.flexDirection = "row";
    // AdultSection.append(AdultTextWrapper);

    // let AdultTitle = document.createElement("p");
    // AdultTitle.className = "BasicInputTextTop InterBoldTextFont";
    // AdultTitle.style.margin = "auto 0";
    // AdultTitle.innerHTML = window["TamuDewasaTxt" + window.CurrentCountryID];
    // AdultTextWrapper.append(AdultTitle);

    // let AdultInputContainer = document.createElement("div");
    // AdultInputContainer.className = "RoomButtonAndInputContainer";
    // AdultTextWrapper.append(AdultInputContainer);

    // let AdultReduce = document.createElement("img");
    // AdultReduce.className = "IncreaseReduceRoomButton Selectable2 ButtonUnselectableOpacity";
    // AdultReduce.src = "/Assets/images/ButtonIcon/reduce-circle-button.svg";
    // AdultInputContainer.append(AdultReduce);

    // let AdultInputWrapper = document.createElement("div");
    // AdultInputWrapper.className = "SmallPanelDropDownContainer Selectable3";
    // AdultInputContainer.append(AdultInputWrapper);

    // let AdultInput = document.createElement("input");
    // AdultInput.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    // AdultInput.type = "number";
    // AdultInput.placeholder = "0";
    // AdultInputWrapper.append(AdultInput);

    // let AdultIncrease = document.createElement("img");
    // AdultIncrease.className = "IncreaseReduceRoomButton Selectable2";
    // AdultIncrease.src = "/Assets/images/ButtonIcon/increase-circle-button.svg";
    // AdultInputContainer.append(AdultIncrease);


    // /* ==================== TAMU ANAK ==================== */
    // let ChildSection = document.createElement("div");
    // ChildSection.className = "SearchTopNonIndexSection";
    // ChildSection.style.backgroundColor = "transparent";
    // HoverContainer.append(ChildSection);

    // let ChildIcon = document.createElement("img");
    // ChildIcon.className = "BasicIconInsideInput";
    // ChildIcon.src = "/Assets/images/ButtonIcon/baby-child-icon.svg";
    // ChildIcon.style.marginLeft = "0";
    // ChildSection.append(ChildIcon);

    // let ChildTextWrapper = document.createElement("div");
    // ChildTextWrapper.className = "SearchInputFieldTopBottomTextWrapper";
    // ChildTextWrapper.style.flexDirection = "row";
    // ChildSection.append(ChildTextWrapper);

    // let ChildTitle = document.createElement("p");
    // ChildTitle.className = "BasicInputTextTop InterBoldTextFont";
    // ChildTitle.style.margin = "auto 0";
    // ChildTitle.innerText = window["TamuAnakTxt" + window.CurrentCountryID];
    // ChildTextWrapper.append(ChildTitle);

    // let ChildInputContainer = document.createElement("div");
    // ChildInputContainer.className = "RoomButtonAndInputContainer";
    // ChildTextWrapper.append(ChildInputContainer);

    // let ChildReduce = document.createElement("img");
    // ChildReduce.className = "IncreaseReduceRoomButton Selectable2 ButtonUnselectableOpacity";
    // ChildReduce.src = "/Assets/images/ButtonIcon/reduce-circle-button.svg";
    // ChildInputContainer.append(ChildReduce);

    // let ChildInputWrapper = document.createElement("div");
    // ChildInputWrapper.className = "SmallPanelDropDownContainer Selectable3";
    // ChildInputContainer.append(ChildInputWrapper);

    // let ChildInput = document.createElement("input");
    // ChildInput.className = "InputFieldInsideSmallPanel InputFieldSelectable InterMediumTextFont";
    // ChildInput.type = "number";
    // ChildInput.placeholder = "0";
    // ChildInputWrapper.append(ChildInput);

    // let ChildIncrease = document.createElement("img");
    // ChildIncrease.className = "IncreaseReduceRoomButton Selectable2";
    // ChildIncrease.src = "/Assets/images/ButtonIcon/increase-circle-button.svg";
    // ChildInputContainer.append(ChildIncrease);


    /* ==================== SAVE BUTTON ==================== */
    let SaveWrapper = document.createElement("div");
    SaveWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
    SaveWrapper.style.marginBottom = "0";
    ContentWrapper.append(SaveWrapper);

    let SaveButton = document.createElement("button");
    SaveButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
    SaveButton.style.margin = "0";
    SaveButton.style.width = "100%";
    SaveWrapper.append(SaveButton);


    let SaveText = document.createElement("p");
    SaveText.className = "LabelGreyHeaderText";
    SaveText.style.cssText = "color:white; margin:auto;";
    SaveText.innerHTML = window["SavedButtonTxt" + window.CurrentCountryID];
    SaveButton.append(SaveText);

    
    // Check If It is Per Night or Item --------------------------------------------------------------

    if(WhichRoomDataToUsed.book_type == "per day") // Select Date Only one day at a time
    {
        HeaderTitle.innerHTML = window["ChangeItemAmountTxt" + window.CurrentCountryID];
        RoomTitle.innerHTML = window["ItemAmountTxt" + window.CurrentCountryID];
    }

    /* ==================== SET FUNCTION ==================== */

    let ClosePanelFunction = function(isjustclose)
    {
        if(functiontocallwhenclose != null && isjustclose == false) // If Just Close Then don't call any function assigned
            functiontocallwhenclose();
        
        window.ClosePanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker, null);
    }
    
    let CloseWithoutSavingFunction = function()
    {
        window.ThisCurrentQuotaInput = window.MobileQuotaToChange;

        ClosePanelFunction(true);
    }

    SaveButton.onclick = function()
    {
        ClosePanelFunction(false);
    }

    BackButton.onclick = function()
    {
        CloseWithoutSavingFunction();
    }

    CloseButton.onclick = function()
    {
        CloseWithoutSavingFunction();
    }

    if(isdirect == true)
    {
        BackButton.style.display = "none";
    }
    else
    {
        CloseButton.style.display = "none";
    }

    let OnChangeQuotaFunction = function()
    {
        window.OnChangeCurrentQuotaInput(RoomSection, RoomInput, null, RoomReduce, null);
    }

    RoomReduce.onclick = function(event)
    {
        event.preventDefault();
        event.stopPropagation();

        window.ThisCurrentQuotaInput = window.ThisCurrentQuotaInput - 1;
        OnChangeQuotaFunction();
    }
    RoomIncrease.onclick = function(event)
    {
        event.preventDefault();
        event.stopPropagation();

        window.ThisCurrentQuotaInput = window.ThisCurrentQuotaInput + 1;
        OnChangeQuotaFunction();
    }

    RoomInput.addEventListener("focusout", (event) =>
    {
        window.ThisCurrentQuotaInput = RoomInput.value;
        OnChangeQuotaFunction();
    });

    window.OnChangeCurrentQuotaInput(RoomSection, RoomInput, null, RoomReduce, null);

    window.OpenPanelAnimate(FlexFullDisplayPanel, BasicBlackBlocker);
}


// ROOM TYPE --------------------------------------------------------------------------------------------------

window.CurrentSelectedRoomTypeIDToChange = 0;

window.InstantiateRoomTypePanel = function(functiontocall, isdirect)
{
    window.CurrentSelectedRoomTypeIDToChange = 0;
    if(window.CurrentSelectedRoomID != null && isdirect == true)
    {
        window.CurrentSelectedRoomTypeIDToChange = window.CurrentSelectedRoomID;
        window.MobileRoomTypeIDToChange = window.CurrentSelectedRoomTypeIDToChange;
    }
    else
    {
        window.CurrentSelectedRoomTypeIDToChange = window.MobileRoomTypeIDToChange;
    }

    let BasicBlackBlocker = document.createElement("div");
    BasicBlackBlocker.className = "BasicBlackBlocker";
    document.getElementsByTagName("body")[0].append(BasicBlackBlocker);

    let MainPanel = document.createElement("div");
    MainPanel.className = "FlexFullDisplayPanel FlexPanelOnlyForMobile";
    MainPanel.style.padding = "0px";
    BasicBlackBlocker.append(MainPanel);

    // ================= HEADER =================

    let HeaderContainer = document.createElement("div");
    HeaderContainer.className = "TopBottomHeaderButtonPaddingContainer BasicBoxShadow";
    MainPanel.append(HeaderContainer);

    let HeaderWrapper = document.createElement("div");
    HeaderWrapper.className = "ColumnGapExtraLong";
    HeaderWrapper.style.cssText = "flex:1 1 0%; height:fit-content; display:flex; position:relative;";
    HeaderContainer.append(HeaderWrapper);

    let BackButton = document.createElement("img");
    BackButton.src = "/Assets/images/ButtonIcon/chevron.svg";
    BackButton.className = "BasicInputFieldChevronIconSearch Selectable2";
    BackButton.style.cssText = "margin:auto 0; rotate:90deg;";
    HeaderWrapper.append(BackButton);

    let HeaderText = document.createElement("p");
    HeaderText.className = "PaymentPriceFinalToPay MarginTextUpDown InterBoldTextFont";
    HeaderText.style.margin = "auto 0";
    HeaderText.textContent = window["SelectRoomItemButtonTxt" + window.CurrentCountryID];
    HeaderWrapper.append(HeaderText);

    let CloseButton = document.createElement("img");
    CloseButton.src = "/Assets/images/ButtonIcon/cancel-x-grey.svg";
    CloseButton.className = "CloseButtonInsidePanel Selectable2";
    CloseButton.style.cssText = "position:absolute; right:0; top:50%; transform:translateY(-50%);";
    HeaderWrapper.append(CloseButton);

    // ================= BODY =================

    let BodyContainer = document.createElement("div");
    BodyContainer.className = "FlexContainerBaseAnimate TopBottomHeaderButtonPaddingContainer PingExprezyViewMoreContainer RowGapBasic2";
    BodyContainer.style.width = "90vw";
    MainPanel.append(BodyContainer);

    // ================= HOTEL CONTAINER =================

    let HotelWrapper = document.createElement("div");
    HotelWrapper.className = "HotelDetailsHotelInformationMarginWrapper2";
    BodyContainer.append(HotelWrapper);

    let HoverContainer = document.createElement("div");
    HoverContainer.className = "HoverableContentInsideInputField";
    HoverContainer.style.flexDirection = "column";
    HotelWrapper.append(HoverContainer);

    // ================= SWIPER =================

    let SwiperContainer = document.createElement("div");
    SwiperContainer.className = "BasicSwiperSlideVerticalContainer BasicGradientTopBottomMask";
    SwiperContainer.id = "BasicVerticalSlider";
    HoverContainer.append(SwiperContainer);

    let SwiperWrapper = document.createElement("div");
    SwiperWrapper.className = "swiper-wrapper";
    SwiperContainer.append(SwiperWrapper);

    let WhichIndexToSlide = 0;

    for(let i = 0; i < window.HotelDetails.rooms.length; i++)
    {
        let RoomTypeDropDownSlide = document.createElement("div");
        RoomTypeDropDownSlide.className = "BasicSwiperSlideVerticalSlider swiper-slide Unselectable";
        SwiperWrapper.append(RoomTypeDropDownSlide);

        let RoomTypeDropDownText = document.createElement("p");
        RoomTypeDropDownText.className = "LabelGreyHeaderText InterBoldTextFont";
        RoomTypeDropDownText.textContent = window.HotelDetails.rooms[i].room_name;
        RoomTypeDropDownSlide.append(RoomTypeDropDownText);

        if(window.HotelDetails.rooms[i].id_hotel_room == window.CurrentSelectedRoomTypeIDToChange)
        {
            WhichIndexToSlide = i;
        }
    }

    // ================= SAVE BUTTON =================

    let ButtonWrapper = document.createElement("div");
    ButtonWrapper.className = "HotelDetailsHotelInformationMarginWrapper";
    ButtonWrapper.style.marginBottom = "0px";
    BodyContainer.append(ButtonWrapper);

    let SaveButton = document.createElement("button");
    SaveButton.className = "BasicTextButton BasicBoxShadow OrangeButton SignInButtonTop Selectable";
    SaveButton.style.cssText = "margin:0; width:100%;";
    ButtonWrapper.append(SaveButton);

    let SaveText = document.createElement("p");
    SaveText.className = "LabelGreyHeaderText";
    SaveText.style.cssText = "color:white; margin:auto;";
    SaveText.textContent = window["ApplyTxt" + window.CurrentCountryID];
    SaveButton.append(SaveText);

    // ================= SWIPER INIT =================

    const swiper = new window.Swiper('.BasicSwiperSlideVerticalContainer',
    {
        direction: 'vertical',
        centeredSlides: true,
        initialSlide: 2,
        slidesPerView: 5,
        mousewheel: true,
    });
    swiper.on("slideChange", function ()
    {
        let index = swiper.realIndex;

        window.CurrentSelectedRoomTypeIDToChange = window.HotelDetails.rooms[index].id_hotel_room;
    });

    if(WhichIndexToSlide >= 0)
    {
        swiper.slideToLoop(WhichIndexToSlide, 0);
    }


    let ClosePanelFunction = function(isjustclose)
    {
        if(functiontocall != null && isjustclose == false) // If Just Close Then don't call any function assigned
            functiontocall();
        
        window.ClosePanelAnimate(MainPanel, BasicBlackBlocker, null);
    }
    
    let CloseWithoutSavingFunction = function()
    {
        window.CurrentSelectedRoomTypeIDToChange = window.MobileRoomTypeIDToChange;

        ClosePanelFunction(true);
    }

    
    SaveButton.onclick = function()
    {
        ClosePanelFunction(false);
    }

    BackButton.onclick = function()
    {
        CloseWithoutSavingFunction();
    }

    CloseButton.onclick = function()
    {
        CloseWithoutSavingFunction();
    }

    if(isdirect == true)
    {
        BackButton.style.display = "none";
    }
    else
    {
        CloseButton.style.display = "none";
    }
    
    window.OpenPanelAnimate(MainPanel, BasicBlackBlocker);
};